import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.review.modal');
import { EventEmitter, HostListener, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import {
    REVIEWOPS_CODEX_ALLOWED_REASONING_EFFORTS,
    reviewOpsCodexBuiltinModelDefinitions,
    reviewOpsCodexBuiltinModelOptionRows,
    reviewOpsCodexModelAliases,
    reviewOpsCodexReasoningSelectOptions
} from 'src/app/codex-model-catalog';

declare const require: any;
const showdown = require('showdown');

@Component({
    selector: 'wiz-component-review-modal',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/component.review.modal/view.scss */
:host(.reviewops-review-sidebar-detail) {
  display: block;
  width: 100%;
  height: 100%;
  min-height: 0;
}

:host ::ng-deep .reviewops-markdown {
  color: #334155;
  font-size: 13px;
  line-height: 1.65;
  overflow-wrap: anywhere;
}

:host ::ng-deep .reviewops-markdown > *:first-child {
  margin-top: 0;
}

:host ::ng-deep .reviewops-markdown > *:last-child {
  margin-bottom: 0;
}

:host ::ng-deep .reviewops-markdown p {
  margin: 0 0 0.75rem;
}

:host ::ng-deep .reviewops-markdown h1,
:host ::ng-deep .reviewops-markdown h2,
:host ::ng-deep .reviewops-markdown h3,
:host ::ng-deep .reviewops-markdown h4,
:host ::ng-deep .reviewops-markdown h5,
:host ::ng-deep .reviewops-markdown h6 {
  margin: 1.15rem 0 0.55rem;
  color: #0f172a;
  font-weight: 700;
  line-height: 1.3;
}

:host ::ng-deep .reviewops-markdown h1,
:host ::ng-deep .reviewops-markdown h2 {
  padding-bottom: 0.35rem;
  border-bottom: 1px solid #e2e8f0;
}

:host ::ng-deep .reviewops-markdown h1 {
  font-size: 1.35rem;
}

:host ::ng-deep .reviewops-markdown h2 {
  font-size: 1.15rem;
}

:host ::ng-deep .reviewops-markdown h3 {
  font-size: 1rem;
}

:host ::ng-deep .reviewops-markdown h4,
:host ::ng-deep .reviewops-markdown h5,
:host ::ng-deep .reviewops-markdown h6 {
  font-size: 0.92rem;
}

:host ::ng-deep .reviewops-markdown ul,
:host ::ng-deep .reviewops-markdown ol {
  margin: 0.5rem 0 0.85rem;
  padding-left: 1.55rem;
}

:host ::ng-deep .reviewops-markdown ul {
  list-style: disc;
}

:host ::ng-deep .reviewops-markdown ol {
  list-style: decimal;
}

:host ::ng-deep .reviewops-markdown li {
  margin: 0.22rem 0;
  padding-left: 0.1rem;
}

:host ::ng-deep .reviewops-markdown li > p {
  margin: 0.25rem 0;
}

:host ::ng-deep .reviewops-markdown li > ul,
:host ::ng-deep .reviewops-markdown li > ol {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}

:host ::ng-deep .reviewops-markdown ul ul {
  list-style: circle;
}

:host ::ng-deep .reviewops-markdown ul ul ul {
  list-style: square;
}

:host ::ng-deep .reviewops-markdown .contains-task-list {
  padding-left: 1.35rem;
}

:host ::ng-deep .reviewops-markdown .task-list-item {
  list-style: none;
}

:host ::ng-deep .reviewops-markdown blockquote {
  margin: 0.85rem 0;
  padding: 0.1rem 0 0.1rem 0.85rem;
  border-left: 0.25rem solid #d0d7de;
  color: #64748b;
}

:host ::ng-deep .reviewops-markdown blockquote > *:last-child {
  margin-bottom: 0;
}

:host ::ng-deep .reviewops-markdown a {
  color: #0969da;
  text-decoration: underline;
  text-underline-offset: 2px;
}

:host ::ng-deep .reviewops-markdown a:hover {
  color: #0756b8;
}

:host ::ng-deep .reviewops-markdown code {
  padding: 0.12rem 0.28rem;
  border-radius: 4px;
  background: #f1f5f9;
  color: #0f172a;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 0.92em;
}

:host ::ng-deep .reviewops-markdown pre {
  margin: 0.85rem 0;
  padding: 0.85rem;
  overflow-x: auto;
  border-radius: 6px;
  background: #f6f8fa;
  color: #0f172a;
  font-size: 12px;
  line-height: 1.55;
}

:host ::ng-deep .reviewops-markdown pre code {
  display: block;
  padding: 0;
  border-radius: 0;
  background: transparent;
  font-size: inherit;
  white-space: pre;
}

:host ::ng-deep .reviewops-markdown table {
  display: block;
  width: max-content;
  max-width: 100%;
  margin: 0.85rem 0;
  overflow-x: auto;
  border-collapse: collapse;
  font-size: 12px;
}

:host ::ng-deep .reviewops-markdown th,
:host ::ng-deep .reviewops-markdown td {
  padding: 0.42rem 0.65rem;
  border: 1px solid #d0d7de;
}

:host ::ng-deep .reviewops-markdown th {
  background: #f8fafc;
  color: #0f172a;
  font-weight: 700;
}

:host ::ng-deep .reviewops-markdown tr:nth-child(2n) {
  background: #f8fafc;
}

:host ::ng-deep .reviewops-markdown hr {
  height: 1px;
  margin: 1rem 0;
  border: 0;
  background: #e2e8f0;
}

:host ::ng-deep .reviewops-markdown img {
  max-width: 100%;
  border-radius: 6px;
}

:host ::ng-deep .reviewops-markdown input[type=checkbox] {
  width: 0.9rem;
  height: 0.9rem;
  margin: 0 0.4rem 0.15rem -1.25rem;
  vertical-align: middle;
}

.reviewops-modal-viewport {
  max-height: var(--reviewops-viewport-height, 100vh);
  overflow-anchor: none;
}

.reviewops-inline-viewport {
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  overflow-x: hidden;
  overflow-anchor: none;
}

.reviewops-modal-viewport input:not([type=checkbox]):not([type=radio]),
.reviewops-modal-viewport textarea,
.reviewops-modal-viewport select,
.reviewops-inline-viewport input:not([type=checkbox]):not([type=radio]),
.reviewops-inline-viewport textarea,
.reviewops-inline-viewport select {
  max-width: 100%;
  scroll-margin-top: 4rem;
  scroll-margin-bottom: calc(32vh + env(safe-area-inset-bottom, 0px));
}

.reviewops-inline-viewport,
.reviewops-inline-viewport * {
  box-sizing: border-box;
  min-width: 0;
}

.reviewops-inline-viewport p,
.reviewops-inline-viewport span,
.reviewops-inline-viewport a,
.reviewops-inline-viewport button,
.reviewops-inline-viewport label,
.reviewops-inline-viewport td,
.reviewops-inline-viewport th,
.reviewops-inline-viewport pre,
.reviewops-inline-viewport code {
  max-width: 100%;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.reviewops-modal-scroll-pane,
.reviewops-modal-workspace-pane,
.reviewops-modal-viewport .overflow-y-auto,
.reviewops-inline-viewport .overflow-y-auto {
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  overflow-anchor: none;
}

.reviewops-preview-overlay {
  align-items: stretch;
  padding: 0;
}

.reviewops-preview-dialog {
  width: 100vw;
  height: var(--reviewops-viewport-height, 100vh);
  max-height: var(--reviewops-viewport-height, 100vh);
  border-radius: 0;
}

.reviewops-preview-body {
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
}

.reviewops-preview-overlay.reviewops-file-preview-fullscreen {
  padding: 0;
  align-items: stretch;
}
.reviewops-preview-overlay.reviewops-file-preview-fullscreen .reviewops-file-preview-dialog {
  width: 100%;
  max-width: none;
  height: 100%;
  max-height: none !important;
  border-radius: 0;
}

.reviewops-file-preview-html {
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
  background: #fff;
}

.reviewops-preview-image {
  max-height: 100%;
  max-width: 100%;
}

.reviewops-screenshot-actions,
.reviewops-screenshot-actions button,
.reviewops-screenshot-actions span {
  overflow-wrap: normal;
  word-break: keep-all;
}

.reviewops-file-preview-markdown {
  padding: 1.25rem;
}

.reviewops-file-preview-text {
  min-height: 100%;
  margin: 0;
  padding: 1rem;
  background: #f8fafc;
  color: #0f172a;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

.reviewops-context-viewer-dialog {
  max-width: 860px;
}

.reviewops-codex-pane,
.reviewops-codex-chat {
  width: 100%;
  min-width: 0;
  background: #ffffff;
}

.reviewops-codex-picker-panel {
  height: 100%;
  min-height: 0;
}

.reviewops-codex-picker-stage {
  display: flex;
  width: 100%;
  height: 100%;
  min-height: 0;
}

.reviewops-codex-picker-stage > .reviewops-codex-picker-panel {
  flex: 1 1 100%;
  width: 100%;
  min-width: 0;
  max-width: 100%;
}

.reviewops-codex-picker-body,
.reviewops-codex-screenshot-grid {
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
}

.reviewops-codex-screenshot-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  align-content: start;
  gap: 0;
}

.reviewops-modal-header {
  background: #020617;
}

.reviewops-mobile-modal-tabs,
.reviewops-desktop-tabs {
  background: #0f172a;
}

.reviewops-history-pane,
.reviewops-log-pane {
  background: #f1f5f9;
}

.reviewops-activity-composer,
.reviewops-codex-composer {
  border-top-color: #475569;
  background: #334155;
}

.reviewops-activity-composer textarea,
.reviewops-codex-composer textarea {
  background: #ffffff;
  color: #0f172a;
}

.reviewops-activity-composer textarea:focus,
.reviewops-codex-composer textarea:focus {
  border-color: #38bdf8;
  box-shadow: 0 0 0 2px #e0f2fe;
}

.reviewops-composer-textarea {
  min-height: 2.25rem;
  line-height: 1.25rem;
}

.reviewops-composer-submit {
  align-self: stretch;
  width: 2.25rem;
  min-height: 2.25rem;
  height: auto;
}

.reviewops-codex-runtime-select {
  line-height: 1.25rem;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.reviewops-codex-runtime-action {
  width: 6rem;
  height: 2rem;
  white-space: nowrap;
}

.reviewops-codex-independent-toggle[aria-checked=true] {
  border-color: #38bdf8;
  background: #0ea5e9;
  color: #fff;
}

.reviewops-codex-independent-toggle[aria-checked=true]:hover {
  background: #0284c7;
}

.reviewops-codex-progress-card,
.reviewops-codex-progress-toggle,
.reviewops-codex-progress-list {
  min-width: 0;
}

.reviewops-codex-progress-list {
  max-height: 14rem;
  overflow-y: auto;
  scrollbar-width: thin;
}

.reviewops-codex-progress-list p {
  overflow-wrap: anywhere;
}

.reviewops-log-version-select {
  width: 10rem;
  max-width: 100%;
  min-height: 2rem;
  height: 2rem;
  line-height: normal;
  padding-top: 0;
  padding-bottom: 0;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.reviewops-log-tabs {
  flex-wrap: nowrap;
  scrollbar-width: thin;
}

.reviewops-log-tabs button {
  min-width: max-content;
}

.reviewops-mobile-modal-tabs button,
.reviewops-desktop-tabs button,
.reviewops-log-tabs button,
.reviewops-log-tabs span,
.reviewops-log-version-control,
.reviewops-log-version-control span,
.reviewops-log-version-meta {
  overflow-wrap: normal;
  word-break: keep-all;
  white-space: nowrap;
}

.reviewops-inline-layer {
  border-left: 3px solid #0f172a;
  box-shadow: -12px 0 28px rgba(15, 23, 42, 0.28);
}

.reviewops-modal-workspace-pane {
  box-shadow: inset 1px 0 0 #475569;
}

@media (min-width: 1024px) {
  .reviewops-preview-overlay {
    align-items: center;
    padding: 1rem;
  }
  .reviewops-preview-dialog {
    width: min(72rem, 100vw - 2rem);
    height: calc(var(--reviewops-viewport-height, 100vh) - 2rem);
    max-height: calc(var(--reviewops-viewport-height, 100vh) - 2rem);
    border-radius: 0.5rem;
  }
  .reviewops-file-preview-dialog {
    width: min(64rem, 100vw - 2rem);
  }
  .reviewops-context-viewer-dialog {
    width: min(54rem, 100vw - 2rem);
  }
  .reviewops-file-preview-markdown {
    padding: 1.5rem 2rem 2rem;
  }
  .reviewops-file-preview-text {
    padding: 1.25rem 1.5rem;
  }
}
@media (max-width: 1023px) {
  .reviewops-modal-viewport {
    width: 100vw;
    max-width: 100vw;
    height: var(--reviewops-viewport-height, 100vh);
    max-height: var(--reviewops-viewport-height, 100vh);
    overflow-x: hidden;
    padding-bottom: max(env(safe-area-inset-bottom, 0px), 1.5rem);
  }
  .reviewops-modal-viewport,
  .reviewops-modal-viewport * {
    box-sizing: border-box;
    min-width: 0;
  }
  .reviewops-modal-viewport p,
  .reviewops-modal-viewport span,
  .reviewops-modal-viewport a,
  .reviewops-modal-viewport button,
  .reviewops-modal-viewport label,
  .reviewops-modal-viewport td,
  .reviewops-modal-viewport th,
  .reviewops-modal-viewport pre,
  .reviewops-modal-viewport code {
    max-width: 100%;
    overflow-wrap: anywhere;
    word-break: break-word;
  }
  .reviewops-modal-viewport .reviewops-mobile-modal-tabs button,
  .reviewops-modal-viewport .reviewops-log-tabs button,
  .reviewops-modal-viewport .reviewops-log-tabs span,
  .reviewops-modal-viewport .reviewops-log-version-control,
  .reviewops-modal-viewport .reviewops-log-version-control span,
  .reviewops-modal-viewport .reviewops-log-version-meta {
    overflow-wrap: normal;
    word-break: keep-all;
    white-space: nowrap;
  }
  .reviewops-preview-dialog,
  .reviewops-preview-dialog * {
    box-sizing: border-box;
    min-width: 0;
  }
  .reviewops-file-preview-markdown {
    padding: 1rem;
  }
  .reviewops-mobile-composer {
    width: 100%;
    max-width: 100%;
    padding: 0.5rem !important;
    padding-bottom: 0.5rem !important;
    overflow-x: hidden;
    overscroll-behavior: contain;
  }
  .reviewops-mobile-composer-active .reviewops-modal-header,
  .reviewops-mobile-composer-active .reviewops-mobile-modal-tabs {
    display: none;
  }
  .reviewops-mobile-composer-active:not(.reviewops-mobile-picker-active) .reviewops-mobile-composer-background {
    display: none;
  }
  .reviewops-mobile-composer-active.reviewops-mobile-picker-active .reviewops-mobile-composer-background {
    display: block;
    min-height: 0;
    flex: 1 1 auto;
  }
  .reviewops-mobile-composer-active.reviewops-mobile-picker-active .reviewops-codex-picker-stage {
    display: flex;
  }
  .reviewops-mobile-composer-active .reviewops-modal-body {
    min-height: 0;
    flex: 1 1 auto;
  }
  .reviewops-mobile-composer-expanded {
    display: flex;
    min-height: 0;
    max-height: none;
    flex: 1 1 auto !important;
    flex-direction: column;
    overflow: hidden;
  }
  .reviewops-mobile-composer-active.reviewops-mobile-picker-active .reviewops-mobile-composer-expanded {
    max-height: none;
    flex: 0 0 auto !important;
    overflow: visible;
  }
  .reviewops-mobile-composer-collapsed {
    overflow-y: hidden;
  }
  .reviewops-mobile-composer-collapsed .reviewops-composer-textarea {
    height: 2.25rem;
    min-height: 2.25rem;
    max-height: 2.25rem;
  }
  .reviewops-mobile-composer-expanded .reviewops-mobile-composer-input-row {
    min-height: 0;
    flex: 1 1 auto;
    align-items: stretch;
  }
  .reviewops-mobile-composer-active.reviewops-mobile-picker-active .reviewops-mobile-composer-expanded .reviewops-mobile-composer-input-row {
    flex: 0 0 auto;
    align-items: stretch;
  }
  .reviewops-mobile-composer-expanded .reviewops-composer-textarea {
    height: 100%;
    min-height: 0;
    max-height: none;
    overflow-y: auto;
  }
  .reviewops-mobile-composer-active.reviewops-mobile-picker-active .reviewops-mobile-composer-expanded .reviewops-composer-textarea {
    height: 2.25rem;
    min-height: 2.25rem;
    max-height: 2.25rem;
  }
  .reviewops-codex-screenshot-grid {
    grid-template-columns: repeat(auto-fill, minmax(132px, 1fr));
  }
}
@supports (-webkit-touch-callout: none) {
  @media (max-width: 1023px) {
    .reviewops-inline-layer input:not([type=checkbox]):not([type=radio]),
    .reviewops-inline-layer textarea,
    .reviewops-inline-layer select {
      font-size: 16px !important;
    }
    .reviewops-codex-runtime-select,
    .reviewops-log-version-select {
      min-height: 2.5rem;
      line-height: 1.5rem;
      padding-top: 0.5rem;
      padding-bottom: 0.5rem;
    }
    .reviewops-log-version-select {
      min-height: 2.25rem;
      height: 2.25rem;
      line-height: normal;
      padding-top: 0;
      padding-bottom: 0;
    }
  }
}`],
})
export class ComponentReviewModalComponent implements OnInit, OnChanges, OnDestroy {
    @Input() review: any = null;
    @Input() projectId: string = '';
    @Input() adminMode: boolean = false;
    @Input() showProjectMeta: boolean = false;
    @Input() captureScreenshot: any = null;
    @Input() captureLogs: any = null;
    @Input() activeProjectFile: any = null;
    @Input() inlineMode: boolean = false;
    @Output() closed = new EventEmitter<void>();
    @Output() reviewChange = new EventEmitter<any>();
    @Output() reviewDelete = new EventEmitter<any>();

    public selectedReview: any = null;
    public currentUser: any = {};
    public reviewDetailLoading: boolean = false;
    public reviewEvidenceLoading: boolean = false;
    public reviewEvidenceAssetLoading: boolean = false;
    public reviewActivityLoading: boolean = false;
    public documentFileLoading: boolean = false;
    public downloadingDocumentVersionId: string = '';
    public reviewModalTab: string = 'history';
    public reviewLogTab: string = 'navigation';
    public reviewLogVersionId: string = 'current';
    public editingReview: boolean = false;
    public savingReviewEdit: boolean = false;
    public sendingActivity: boolean = false;
    public savingActivityEdit: boolean = false;
    public selectedReviewAttachmentBusy: boolean = false;
    public activityAttachmentBusy: boolean = false;
    public activityEditAttachmentBusy: boolean = false;
    public uploadProgress: any = {};
    public uploadDropTarget: string = '';
    public activityEditId: string = '';
    public screenshotPreviewUrl: string = '';
    public screenshotPreviewTitle: string = '';
    public screenshotPreviewIndex: number = 0;
    public attachmentPreviewUrl: string = '';
    public attachmentPreviewTitle: string = '';
    public attachmentPreviewAttachment: any = null;
    public codexFilePreview: any = { open: false, loading: false, type: '', title: '', content: '', imageUrl: '', fileUrl: '', downloadUrl: '', dataUrl: '', error: '' };
    public codexFilePreviewFullscreen: boolean = false;
    public codexContextViewer: any = { open: false, type: '', title: '', subtitle: '', content: '', items: [] };
    public screenshotPage: number = 1;
    public screenshotActionMenuOpen: boolean = false;
    public capturingScreenshot: boolean = false;
    public screenshotCaptureModalHidden: boolean = false;
    public deletingScreenshot: boolean = false;
    public capturingLogCapture: boolean = false;
    public capturePrompt: any = { open: false, type: '', mode: 'browser-partial', message: '' };
    public screenshotCaptureMode: string = 'browser-partial';
    public inlineDialogOpen: boolean = false;
    public screenshotCaptureModeOptions: any[] = [
        { value: 'auto', label: '자동', icon: 'fa-solid fa-wand-magic-sparkles' },
        { value: 'browser-partial', label: 'Chrome 부분', icon: 'fa-solid fa-crop-simple' }
    ];
    public activityForm: any = { message: '', status: '', attachments: [] };
    public activityEditForm: any = { message: '', attachments: [] };
    public expandedCodexActivities: any = {};
    public expandedCodexMessageProgress: any = {};
    public reviewEditForm: any = { title: '', body: '', priority: 'normal', category: 'ux' };
    public codexForm: any = { message: '', include_screenshot: false, screenshot_index: 1, include_agent_instruction: false, attachments: [], log_capture_ids: [] };
    public activityComposerExpanded: boolean = false;
    public codexComposerExpanded: boolean = false;
    private readonly codexDefaultModel: string = 'gpt-5.6-sol';
    private readonly codexDefaultReasoningEffort: string = 'xhigh';
    private readonly codexRuntimePreferenceStorageKey: string = 'reviewops.codex.runtimePreference';
    private readonly codexBuiltinModelDefinitions: any[] = reviewOpsCodexBuiltinModelDefinitions();
    public codexModel: string = this.codexDefaultModel;
    public codexReasoningEffort: string = this.codexDefaultReasoningEffort;
    public codexModelOptions: any[] = this.codexBuiltinModelDefinitions.map((item: any) => ({ value: item.value, label: item.label }));
    public codexReasoningOptionMap: any = this.codexBuiltinModelDefinitions.reduce((map: any, item: any) => {
        map[item.value] = reviewOpsCodexReasoningSelectOptions(item.reasoning || []);
        return map;
    }, {});
    public codexScreenshotPickerOpen: boolean = false;
    public codexLogCapturePickerOpen: boolean = false;
    public codexAttachmentPickerOpen: boolean = false;
    public codexAttachmentSearch: string = '';
    public codexSharedFilePickerOpen: boolean = false;
    public codexSharedFileLoading: boolean = false;
    public codexSharedFileError: string = '';
    public codexSharedFileBrowser: any = { path: '', root_label: 'root', breadcrumbs: [{ label: 'root', path: '' }], items: [] };
    public codexDetailLoading: boolean = false;
    public codexMessages: any[] = [];
    public codexRunning: boolean = false;
    public codexJobId: string = '';
    public codexJobStatus: string = '';
    public codexJobMessage: string = '';
    public codexJobStarted: any = 0;
    public codexElapsedSeconds: number = 0;
    public codexProgressLog: string = '';
    public codexProgressLogMaxChars: number = 12000;
    public stoppingCodexJob: boolean = false;
    public checkingCodexSession: boolean = false;
    public codexIndependentExecution: boolean = false;
    public savingCodexActivityKey: string = '';
    public statusOptions: string[] = ['open', 'in_progress', 'in_review', 'resolved', 'recheck', 'closed'];
    public priorityOptions: string[] = ['low', 'normal', 'high', 'critical'];
    public webCategoryOptions: string[] = ['bug', 'ux', 'design', 'content', 'performance', 'accessibility', 'security', 'other'];
    public documentCategoryOptions: string[] = ['content', 'structure', 'design', 'data', 'message', 'typo', 'other'];
    public uploadSettings: any = { policies: {} };
    public reviewAttachmentAccept: string = 'image/*,.pdf,.txt,.md,.csv,.json,.zip,.doc,.docx,.xls,.xlsx,.ppt,.pptx';
    public activityAttachmentAccept: string = 'image/*,.pdf,.txt,.md,.csv,.json,.zip,.doc,.docx,.xls,.xlsx,.ppt,.pptx';
    public reviewAttachmentLimits: any = { files: 10, fileBytes: 500 * 1024 * 1024, totalBytes: 500 * 1024 * 1024 };
    public activityAttachmentLimits: any = { files: 5, fileBytes: 500 * 1024 * 1024, totalBytes: 500 * 1024 * 1024 };
    public reviewBodyMaxLength: number = 1000;
    public reviewLogTabs: any[] = [
        { key: 'navigation', label: '네비게이션', field: 'navigation_log' },
        { key: 'input', label: '입력', field: 'input_log' },
        { key: 'network', label: '트래픽', field: 'network_log' },
        { key: 'console', label: '콘솔', field: 'console_log' },
        { key: 'fingerprint', label: '환경', field: 'fingerprint_log' }
    ];
    public labels: any = {
        status: {
            open: '열림',
            in_progress: '진행',
            in_review: '검토',
            resolved: '해결',
            recheck: '재검토',
            closed: '닫힘'
        },
        statusDescription: {
            open: '새로 등록되어 확인이 필요한 리뷰입니다.',
            in_progress: '수정 또는 조치가 진행 중인 리뷰입니다.',
            in_review: '개발 내용 검토가 진행 중인 리뷰입니다.',
            resolved: '작업자 검토가 완료되어 작성자 확인이 필요한 리뷰입니다.',
            recheck: '작성자가 재검토를 요청한 리뷰입니다.',
            closed: '추가 조치 없이 종료된 리뷰입니다.'
        },
        priority: { low: '낮음', normal: '보통', high: '높음', critical: '긴급' },
        category: {
            bug: '버그',
            ux: 'UX',
            content: '콘텐츠',
            performance: '성능',
            accessibility: '접근성',
            security: '보안',
            structure: '구조',
            design: '설계',
            data: '데이터',
            message: '메시지',
            typo: '오탈자',
            other: '기타'
        },
        capture: {
            'capture-pending': '캡처 대기',
            'browser-capture-required': '브라우저 캡처 필요',
            'capture-unavailable-cross-origin': '교차 출처 제한으로 캡처 불가',
            'same-origin-dom-snapshot': '동일 출처 DOM 스냅샷',
            'postmessage-screenshot': '협조형 스크린샷 수신',
            'reviewops-sdk-dom-snapshot': 'ReviewOps SDK 스냅샷',
            'reviewops-sdk-screenshot-unavailable': 'ReviewOps SDK 캡처 불가',
            'remote-cdp-screencast': '원격 브라우저 스트림',
            'remote-cdp-screencast-unchanged': '원격 브라우저 스트림 대기',
            'browser-display-capture': '브라우저 화면 캡처',
            'browser-display-capture-crop': '브라우저 화면 캡처',
            'browser-display-capture-element': 'iframe 영역 캡처',
            'browser-capture-denied': '브라우저 화면 캡처 취소',
            'browser-capture-blank': '브라우저 화면 캡처 비어 있음',
            'browser-capture-unavailable': '브라우저 화면 캡처 미지원',
            'review-create-screenshot-skipped': '캡처 안함',
            'pdf-viewer': 'PDF 뷰어',
            not_available: '사용할 수 없음'
        }
    };
    private loadedReviewId: string = '';
    private evidenceAssetsLoadedReviewId: string = '';
    private heavyEvidenceLoadedReviewId: string = '';
    private activitiesLoadedReviewId: string = '';
    private reviewDetailRequestToken: number = 0;
    private codexLoadedReviewId: string = '';
    private markdownConverter: any = null;
    private markdownHtmlCache: any = {};
    private markdownHtmlCacheKeys: string[] = [];
    private reviewTimelineCache: any = {
        reviewId: '',
        body: '',
        created: '',
        author: null,
        attachments: null,
        activities: null,
        attachmentCount: 0,
        activityCount: 0,
        screenshotSignature: '',
        logCaptureSignature: '',
        items: []
    };
    private destroyed: boolean = false;
    public codexPollIntervalMs: number = 10000;
    public codexPollMaxBackoffMs: number = 60000;
    public codexLogPollIntervalMs: number = 30000;
    private codexPollTimer: any = null;
    private codexClockTimer: any = null;
    private codexPollRequestSeq: number = 0;
    private codexPollLoading: boolean = false;
    private codexPollErrorCount: number = 0;
    private codexLastLogPollAt: number = 0;
    private modalBackdropPointerDown: boolean = false;
    private modalBackdropPointerUp: boolean = false;
    private screenshotBackdropPointerDown: boolean = false;
    private screenshotBackdropPointerUp: boolean = false;
    private attachmentBackdropPointerDown: boolean = false;
    private attachmentBackdropPointerUp: boolean = false;
    private codexFilePreviewObjectUrl: string = '';
    private codexFilePreviewFullscreenElement: HTMLElement | null = null;
    private focusedControlScrollTimer?: number;
    private modalScrollLockActive: boolean = false;

    constructor(@Inject( Service) public service: Service) {
        // NgFor invokes trackBy callbacks without preserving the component context.
        this.evidenceScreenshotKey = this.evidenceScreenshotKey.bind(this);
        this.trackCodexScreenshotOption = this.trackCodexScreenshotOption.bind(this);
        this.codexContextAttachmentTrack = this.codexContextAttachmentTrack.bind(this);
        this.markdownConverter = new showdown.Converter({
            tables: true,
            tasklists: true,
            strikethrough: true,
            simplifiedAutoLink: true,
            excludeTrailingPunctuationFromURLs: true,
            literalMidWordUnderscores: true,
            ghCodeBlocks: true,
            openLinksInNewWindow: true,
            backslashEscapesHTMLTags: true,
            disableForced4SpacesIndentedSublists: true,
            simpleLineBreaks: false
        });
    }

    public async ngOnInit() {
        this.destroyed = false;
        this.loadCodexRuntimePreference();
        await this.service.init();
        if (this.review && this.review.id !== this.loadedReviewId) await this.openReview(this.review);
    }

    public async ngOnChanges(changes: SimpleChanges) {
        if (!changes.review) return;
        const next = changes.review.currentValue;
        if (!next) {
            this.reviewDetailRequestToken++;
            this.inlineDialogOpen = false;
            this.setModalScrollLock(false);
            this.resetMobileComposerState();
            this.selectedReview = null;
            this.loadedReviewId = '';
            this.evidenceAssetsLoadedReviewId = '';
            this.heavyEvidenceLoadedReviewId = '';
            this.activitiesLoadedReviewId = '';
            this.reviewDetailLoading = false;
            this.reviewEvidenceLoading = false;
            this.reviewEvidenceAssetLoading = false;
            this.reviewActivityLoading = false;
            this.resetCodexState();
            await this.closeCapturePrompt(null, false);
            await this.closeScreenshotPreview(false);
            await this.closeAttachmentPreview(false);
            await this.closeCodexFilePreview(false);
            await this.closeCodexContextViewer(false);
            return;
        }
        if (next.id && next.id !== this.loadedReviewId) {
            await this.openReview(next);
            return;
        }
        const keepActivityForm = this.shouldKeepActivityFormOnReviewRefresh(next);
        this.selectedReview = this.mergeReviewContext(next, this.selectedReview || {});
        this.ensureScreenshotPage();
        if (!keepActivityForm) this.resetActivityForm(this.selectedReview);
    }

    public requestParams(extra: any = {}) {
        const params: any = Object.assign({}, extra);
        const projectId = this.currentProjectId();
        if (projectId) params.project_id = projectId;
        if (this.adminMode) params.admin = '1';
        return params;
    }

    public currentProjectId() {
        return this.projectId || (this.selectedReview && (this.selectedReview.project_id || (this.selectedReview.project && this.selectedReview.project.id))) || '';
    }

    public async openReview(review: any) {
        if (!review || !review.id) return;
        const requestToken = ++this.reviewDetailRequestToken;
        if (this.isInlineMode()) this.inlineDialogOpen = false;
        this.setModalScrollLock(true);
        this.loadedReviewId = review.id;
        this.evidenceAssetsLoadedReviewId = '';
        this.heavyEvidenceLoadedReviewId = '';
        this.activitiesLoadedReviewId = '';
        this.selectedReview = this.mergeReviewContext(review, this.selectedReview || {});
        this.reviewDetailLoading = true;
        this.reviewEvidenceLoading = false;
        this.reviewEvidenceAssetLoading = false;
        this.reviewActivityLoading = false;
        this.reviewModalTab = 'history';
        this.expandedCodexActivities = {};
        this.expandedCodexMessageProgress = {};
        this.resetMobileComposerState();
        this.reviewLogTab = 'navigation';
        this.reviewLogVersionId = 'current';
        this.screenshotPage = 1;
        this.screenshotActionMenuOpen = false;
        this.editingReview = false;
        this.resetCodexState();
        await this.cancelActivityEdit(false);
        await this.closeCapturePrompt(null, false);
        await this.closeScreenshotPreview(false);
        await this.closeAttachmentPreview(false);
        await this.closeCodexFilePreview(false);
        await this.closeCodexContextViewer(false);
        this.reviewEditForm = this.reviewEditPayload(this.selectedReview);
        this.resetActivityForm(this.selectedReview);
        await this.service.render();

        const { code, data } = await wiz.call('load_review_detail', this.requestParams({
            review_id: review.id,
            include_heavy_evidence: '0',
            include_evidence_assets: '1',
            include_activities: '0',
            include_attachment_data: '0'
        }));
        if (!this.isActiveReviewRequest(requestToken, review.id)) return;
        this.reviewDetailLoading = false;
        if (code === 200 && data.user) this.currentUser = data.user || {};
        if (code === 200 && data.review) {
            this.selectedReview = this.mergeReviewContext(data.review, this.selectedReview);
            this.applyUploadSettings(this.selectedReview.upload_settings || (this.selectedReview.project && this.selectedReview.project.upload_settings));
            this.reviewEditForm = this.reviewEditPayload(this.selectedReview);
            this.ensureScreenshotPage();
            this.resetActivityForm(this.selectedReview);
            this.evidenceAssetsLoadedReviewId = review.id;
            this.reviewChange.emit(this.selectedReview);
        } else if (this.selectedReview && this.selectedReview.id === review.id) {
            this.reviewEvidenceLoading = false;
            await this.service.modal.error((data && data.message) || '리뷰 상세 정보를 불러오지 못했습니다.');
            await this.service.render();
            return;
        }
        await this.service.render();
        this.loadReviewEvidenceAssets();
        this.loadReviewActivities().then(() => this.scrollActivityHistoryToBottom()).catch(() => {});
    }

    private isActiveReviewRequest(requestToken: number, reviewId: string) {
        return requestToken === this.reviewDetailRequestToken && !!(this.selectedReview && this.selectedReview.id === reviewId);
    }

    public async reloadSelectedReviewDetail(syncCodexState: boolean = false) {
        if (!this.selectedReview || !this.selectedReview.id) return false;
        const reviewId = this.selectedReview.id;
        const requestToken = this.reviewDetailRequestToken;
        const params = this.requestParams({
            review_id: this.selectedReview.id,
            include_heavy_evidence: '0',
            include_activities: syncCodexState ? '1' : '0',
            include_attachment_data: '0'
        });
        if (syncCodexState) params.include_codex = '1';
        const { code, data } = await wiz.call('load_review_detail', params);
        if (this.destroyed || requestToken !== this.reviewDetailRequestToken || !this.selectedReview || this.selectedReview.id !== reviewId) {
            this.codexDetailLoading = false;
            return false;
        }
        if (code !== 200 || !data.review) return false;
        if (data.user) this.currentUser = data.user || {};
        if (this.selectedReview && this.selectedReview.evidence) data.review.evidence = this.selectedReview.evidence;
        this.applyReview(data.review);
        if (syncCodexState) {
            this.codexLoadedReviewId = this.selectedReview.id;
            this.activitiesLoadedReviewId = this.selectedReview.id;
            this.syncCodexStateFromReview();
        }
        return true;
    }

    public reviewEvidenceLoaded() {
        return !!(this.selectedReview && this.selectedReview.id && this.heavyEvidenceLoadedReviewId === this.selectedReview.id);
    }

    public reviewActivitiesLoaded() {
        return !!(this.selectedReview && this.selectedReview.id && this.activitiesLoadedReviewId === this.selectedReview.id);
    }

    public reviewEvidenceAssetsLoaded() {
        return !!(this.selectedReview && this.selectedReview.id && this.evidenceAssetsLoadedReviewId === this.selectedReview.id);
    }

    public async loadReviewEvidenceAssets(force: boolean = false) {
        if (!this.selectedReview || !this.selectedReview.id) return false;
        if (this.reviewEvidenceAssetsLoaded() && !force) return true;
        if (this.reviewEvidenceAssetLoading) return false;
        const reviewId = this.selectedReview.id;
        const requestToken = this.reviewDetailRequestToken;
        this.reviewEvidenceAssetLoading = true;
        await this.service.render();
        const { code, data } = await wiz.call('load_review_detail', this.requestParams({
            review_id: reviewId,
            include_heavy_evidence: '0',
            include_evidence_assets: '1',
            include_activities: '0',
            include_attachment_data: '0'
        }));
        if (this.destroyed || requestToken !== this.reviewDetailRequestToken || !this.selectedReview || this.selectedReview.id !== reviewId) {
            this.reviewEvidenceAssetLoading = false;
            return false;
        }
        this.reviewEvidenceAssetLoading = false;
        if (code === 200 && data.user) this.currentUser = data.user || {};
        if (code === 200 && data.review) {
            if (this.reviewEvidenceLoaded() && this.selectedReview.evidence) {
                data.review.evidence = Object.assign({}, data.review.evidence || {}, {
                    navigation_log: this.selectedReview.evidence.navigation_log || [],
                    input_log: this.selectedReview.evidence.input_log || [],
                    network_log: this.selectedReview.evidence.network_log || [],
                    console_log: this.selectedReview.evidence.console_log || [],
                    fingerprint_log: this.selectedReview.evidence.fingerprint_log || [],
                    log_captures: this.selectedReview.evidence.log_captures || []
                });
            }
            if (this.reviewActivitiesLoaded() && Array.isArray(this.selectedReview.activities)) {
                data.review.activities = this.selectedReview.activities;
            }
            if (this.codexDetailLoaded() && Array.isArray(this.selectedReview.codex_history)) {
                data.review.codex_history = this.selectedReview.codex_history;
            }
            this.applyReview(data.review);
            this.evidenceAssetsLoadedReviewId = reviewId;
            await this.service.render();
            return true;
        }
        await this.service.render();
        return false;
    }

    public async loadReviewEvidence(includeActivities: boolean = false) {
        if (!this.selectedReview || !this.selectedReview.id) return false;
        if (this.reviewEvidenceLoaded() && (!includeActivities || this.reviewActivitiesLoaded())) return true;
        if (this.reviewEvidenceLoading) return false;
        const reviewId = this.selectedReview.id;
        const requestToken = this.reviewDetailRequestToken;
        this.reviewEvidenceLoading = true;
        await this.service.render();
        const { code, data } = await wiz.call('load_review_detail', this.requestParams({
            review_id: reviewId,
            include_heavy_evidence: '1',
            include_activities: includeActivities ? '1' : '0',
            include_attachment_data: '0'
        }));
        if (this.destroyed || requestToken !== this.reviewDetailRequestToken || !this.selectedReview || this.selectedReview.id !== reviewId) {
            this.reviewEvidenceLoading = false;
            return false;
        }
        this.reviewEvidenceLoading = false;
        if (code === 200 && data.user) this.currentUser = data.user || {};
        if (code === 200 && data.review) {
            if (!includeActivities && Array.isArray(this.selectedReview.activities)) data.review.activities = this.selectedReview.activities;
            this.applyReview(data.review);
            this.heavyEvidenceLoadedReviewId = reviewId;
            this.evidenceAssetsLoadedReviewId = reviewId;
            if (includeActivities) this.activitiesLoadedReviewId = reviewId;
            await this.service.render();
            return true;
        }
        await this.service.render();
        await this.service.modal.error((data && data.message) || '리뷰 로그를 불러오지 못했습니다.');
        return false;
    }

    public async loadReviewActivities() {
        if (!this.selectedReview || !this.selectedReview.id) return false;
        if (this.reviewActivitiesLoaded()) return true;
        if (this.reviewActivityLoading) return false;
        const reviewId = this.selectedReview.id;
        const requestToken = this.reviewDetailRequestToken;
        this.reviewActivityLoading = true;
        await this.service.render();
        const { code, data } = await wiz.call('load_review_detail', this.requestParams({
            review_id: reviewId,
            activities_only: '1',
            include_attachment_data: '0'
        }));
        if (this.destroyed || requestToken !== this.reviewDetailRequestToken || !this.selectedReview || this.selectedReview.id !== reviewId) {
            this.reviewActivityLoading = false;
            return false;
        }
        this.reviewActivityLoading = false;
        if (code === 200 && data.user) this.currentUser = data.user || {};
        if (code === 200 && Array.isArray(data.activities)) {
            this.selectedReview = Object.assign({}, this.selectedReview, { activities: data.activities });
            this.activitiesLoadedReviewId = reviewId;
            this.reviewChange.emit(this.selectedReview);
            await this.service.render();
            return true;
        }
        await this.service.render();
        await this.service.modal.error((data && data.message) || '작업이력을 불러오지 못했습니다.');
        return false;
    }

    public async loadFullReviewForDownload() {
        if (!this.selectedReview || !this.selectedReview.id) return false;
        const reviewId = this.selectedReview.id;
        const requestToken = this.reviewDetailRequestToken;
        this.reviewEvidenceLoading = true;
        this.reviewActivityLoading = true;
        await this.service.render();
        const { code, data } = await wiz.call('load_review_detail', this.requestParams({
            review_id: reviewId,
            include_codex: '1',
            include_heavy_evidence: '1',
            include_activities: '1',
            include_attachment_data: '1'
        }));
        if (this.destroyed || requestToken !== this.reviewDetailRequestToken || !this.selectedReview || this.selectedReview.id !== reviewId) {
            this.reviewEvidenceLoading = false;
            this.reviewActivityLoading = false;
            return false;
        }
        this.reviewEvidenceLoading = false;
        this.reviewActivityLoading = false;
        if (code === 200 && data.user) this.currentUser = data.user || {};
        if (code === 200 && data.review) {
            this.applyReview(data.review);
            this.heavyEvidenceLoadedReviewId = reviewId;
            this.evidenceAssetsLoadedReviewId = reviewId;
            this.activitiesLoadedReviewId = reviewId;
            this.codexLoadedReviewId = reviewId;
            await this.service.render();
            return true;
        }
        await this.service.render();
        await this.service.modal.error((data && data.message) || '다운로드 데이터를 불러오지 못했습니다.');
        return false;
    }

    public mergeReviewContext(detail: any, source: any = {}) {
        const project = (detail && detail.project) || (source && source.project) || {};
        const group = (detail && detail.group) || (source && source.group) || (project && project.group) || {};
        const merged = Object.assign({}, source || {}, detail || {}, { project, group });
        this.applyCodexModelOptions(project && project.codex_model_options);
        if (detail && Object.prototype.hasOwnProperty.call(detail, 'evidence')) {
            merged.evidence = this.mergeReviewEvidence(detail.evidence, source && source.evidence);
        } else if (source && source.evidence) {
            merged.evidence = Object.assign({}, source.evidence);
        }
        return merged;
    }

    private mergeReviewEvidence(detailEvidence: any, sourceEvidence: any = {}) {
        if (!detailEvidence || !sourceEvidence) return detailEvidence || sourceEvidence || {};
        const merged = Object.assign({}, detailEvidence);
        const detailScreenshots = this.copyEvidenceScreenshots(detailEvidence.screenshots);
        const sourceScreenshots = this.copyEvidenceScreenshots(sourceEvidence.screenshots);
        if (detailScreenshots.length) {
            merged.screenshots = detailScreenshots.map((item: any) => {
                const matched = this.findMatchingEvidenceScreenshot(item, sourceScreenshots);
                if (matched && !item.data_url && matched.data_url) item.data_url = matched.data_url;
                return item;
            });
        } else if (!Object.prototype.hasOwnProperty.call(detailEvidence, 'screenshots') && sourceScreenshots.length) {
            merged.screenshots = sourceScreenshots;
        }

        const detailPrimaryKey = this.primaryEvidenceScreenshotKey(merged);
        const sourcePrimaryKey = this.primaryEvidenceScreenshotKey(sourceEvidence);
        if (detailPrimaryKey && sourcePrimaryKey && detailPrimaryKey === sourcePrimaryKey) {
            if (!merged.screenshot_data_url && sourceEvidence.screenshot_data_url) {
                merged.screenshot_data_url = sourceEvidence.screenshot_data_url;
            }
            if (!merged.screenshot_storage_path && sourceEvidence.screenshot_storage_path) {
                merged.screenshot_storage_path = sourceEvidence.screenshot_storage_path;
            }
        }

        const firstScreenshot = Array.isArray(merged.screenshots) ? merged.screenshots[0] : null;
        if (!merged.screenshot_data_url && firstScreenshot && firstScreenshot.data_url) {
            merged.screenshot_data_url = firstScreenshot.data_url;
        }
        if (!merged.screenshot_storage_path && firstScreenshot && firstScreenshot.storage_path) {
            merged.screenshot_storage_path = firstScreenshot.storage_path;
        }

        ['navigation_log', 'input_log', 'network_log', 'console_log', 'fingerprint_log', 'log_captures'].forEach((field: string) => {
            if (Array.isArray(sourceEvidence[field]) && sourceEvidence[field].length && (!Array.isArray(merged[field]) || !merged[field].length)) {
                merged[field] = sourceEvidence[field];
            }
        });
        return merged;
    }

    private copyEvidenceScreenshots(value: any) {
        return Array.isArray(value) ? value.filter((item: any) => !!item).map((item: any) => Object.assign({}, item)) : [];
    }

    public evidenceScreenshotKey(item: any) {
        if (!item) return '';
        const path = String(item.storage_path || item.screenshot_storage_path || '').trim();
        if (path) return `path:${path}`;
        const assetId = String(item.screenshot_asset_id || '').trim();
        if (assetId) return `asset:${assetId}`;
        return '';
    }

    private primaryEvidenceScreenshotKey(evidence: any) {
        if (!evidence) return '';
        const directKey = this.evidenceScreenshotKey({
            storage_path: evidence.screenshot_storage_path,
            screenshot_asset_id: evidence.screenshot_asset_id
        });
        if (directKey) return directKey;
        const screenshots = this.copyEvidenceScreenshots(evidence.screenshots);
        return screenshots.length ? this.evidenceScreenshotKey(screenshots[0]) : '';
    }

    private findMatchingEvidenceScreenshot(item: any, sourceScreenshots: any[]) {
        const key = this.evidenceScreenshotKey(item);
        if (!key) return null;
        return sourceScreenshots.find((source: any) => this.evidenceScreenshotKey(source) === key) || null;
    }

    private isBackdropEvent(event: any) {
        return event && event.target === event.currentTarget;
    }

    public onModalLayerPointerDown(event: any) {
        if (!this.isDialogMode()) return;
        this.modalBackdropPointerDown = this.isBackdropEvent(event);
        this.modalBackdropPointerUp = false;
    }

    public onModalLayerPointerUp(event: any) {
        if (!this.isDialogMode()) return;
        this.modalBackdropPointerUp = this.isBackdropEvent(event);
    }

    public async onModalLayerClick(event: any) {
        if (!this.isDialogMode()) return;
        const shouldClose = this.modalBackdropPointerDown && this.modalBackdropPointerUp && this.isBackdropEvent(event);
        this.modalBackdropPointerDown = false;
        this.modalBackdropPointerUp = false;
        if (!shouldClose) return;
        await this.close();
    }

    public onScreenshotPreviewPointerDown(event: any) {
        this.screenshotBackdropPointerDown = this.isBackdropEvent(event);
        this.screenshotBackdropPointerUp = false;
    }

    public onScreenshotPreviewPointerUp(event: any) {
        this.screenshotBackdropPointerUp = this.isBackdropEvent(event);
    }

    public async onScreenshotPreviewLayerClick(event: any) {
        const shouldClose = this.screenshotBackdropPointerDown && this.screenshotBackdropPointerUp && this.isBackdropEvent(event);
        this.screenshotBackdropPointerDown = false;
        this.screenshotBackdropPointerUp = false;
        if (!shouldClose) return;
        await this.closeScreenshotPreview();
    }

    public onAttachmentPreviewPointerDown(event: any) {
        this.attachmentBackdropPointerDown = this.isBackdropEvent(event);
        this.attachmentBackdropPointerUp = false;
    }

    public onAttachmentPreviewPointerUp(event: any) {
        this.attachmentBackdropPointerUp = this.isBackdropEvent(event);
    }

    public async onAttachmentPreviewLayerClick(event: any) {
        const shouldClose = this.attachmentBackdropPointerDown && this.attachmentBackdropPointerUp && this.isBackdropEvent(event);
        this.attachmentBackdropPointerDown = false;
        this.attachmentBackdropPointerUp = false;
        if (!shouldClose) return;
        await this.closeAttachmentPreview();
    }

    public async close() {
        if (this.isInlineMode() && this.inlineDialogOpen) {
            this.modalBackdropPointerDown = false;
            this.modalBackdropPointerUp = false;
            this.inlineDialogOpen = false;
            if (this.reviewModalTab === 'request') this.reviewModalTab = 'history';
            this.setModalScrollLock(false);
            await this.service.render();
            return;
        }
        this.reviewDetailRequestToken++;
        this.modalBackdropPointerDown = false;
        this.modalBackdropPointerUp = false;
        this.setModalScrollLock(false);
        this.selectedReview = null;
        this.loadedReviewId = '';
        this.evidenceAssetsLoadedReviewId = '';
        this.heavyEvidenceLoadedReviewId = '';
        this.activitiesLoadedReviewId = '';
        this.reviewDetailLoading = false;
        this.reviewEvidenceLoading = false;
        this.reviewEvidenceAssetLoading = false;
        this.reviewActivityLoading = false;
        this.screenshotActionMenuOpen = false;
        this.resetMobileComposerState();
        this.resetCodexState();
        await this.closeCapturePrompt(null, false);
        await this.closeScreenshotPreview(false);
        await this.closeAttachmentPreview(false);
        await this.closeCodexFilePreview(false);
        await this.closeCodexContextViewer(false);
        this.closed.emit();
        await this.service.render();
    }

    public ngOnDestroy() {
        this.destroyed = true;
        this.reviewDetailRequestToken++;
        this.codexPollRequestSeq++;
        this.codexPollLoading = false;
        if (this.focusedControlScrollTimer) window.clearTimeout(this.focusedControlScrollTimer);
        this.setModalScrollLock(false);
        this.clearCodexPoll();
        this.clearCodexClock();
        this.resetCodexFilePreview();
    }

    @HostListener('document:focusin', ['$event'])
    public onDocumentFocusIn(event: FocusEvent) {
        this.scrollFocusedModalControlIntoView(event.target);
    }

    @HostListener('document:pointerup', ['$event'])
    public onDocumentPointerUp(event: PointerEvent) {
        this.scrollFocusedModalControlIntoView(event.target);
    }

    @HostListener('document:click', ['$event'])
    public async onDocumentClick(event: MouseEvent) {
        if (!this.screenshotActionMenuOpen) return;
        const target: any = event.target;
        if (target && target.closest && target.closest('.reviewops-screenshot-actions')) return;
        await this.closeScreenshotActionMenu();
    }

    @HostListener('document:keydown', ['$event'])
    public async onDocumentKeydown(event: KeyboardEvent) {
        if (event.key === 'Escape' && this.codexFilePreviewFullscreen) {
            event.preventDefault();
            await this.exitCodexFilePreviewFullscreen();
            await this.service.render();
            return;
        }
        if (event.key !== 'Escape' || !this.screenshotActionMenuOpen) return;
        await this.closeScreenshotActionMenu();
    }

    @HostListener('window:resize')
    public async onWindowResize() {
        let changed = false;
        if (this.screenshotActionMenuOpen) {
            this.screenshotActionMenuOpen = false;
            changed = true;
        }
        if (!this.isMobileLayout() && this.reviewModalTab === 'request') {
            this.reviewModalTab = 'history';
            changed = true;
        }
        if (changed) await this.service.render();
    }

    public isInlineMode() {
        return this.inlineMode === true || String(this.inlineMode).toLowerCase() === 'true';
    }

    public isInlinePaneMode() {
        return this.isInlineMode() && !this.inlineDialogOpen;
    }

    public isDialogMode() {
        return !this.isInlinePaneMode();
    }

    public async openDialog() {
        if (!this.isInlinePaneMode()) return;
        this.inlineDialogOpen = true;
        this.setModalScrollLock(true);
        await this.service.render();
    }

    public reviewLayerClass() {
        if (this.isInlinePaneMode()) {
            return 'reviewops-inline-layer relative flex h-full min-h-0 w-full items-stretch overflow-hidden bg-slate-200';
        }
        return 'reviewops-modal-layer fixed inset-0 z-[96] flex items-start justify-center bg-slate-950/50 p-0 lg:items-center lg:px-4 lg:py-6';
    }

    public reviewViewportClass() {
        if (this.isInlinePaneMode()) {
            return 'reviewops-inline-viewport flex h-full min-h-0 w-full max-w-full flex-col overflow-hidden bg-slate-200';
        }
        return 'reviewops-modal-viewport flex h-screen max-h-none w-full max-w-none flex-col overflow-hidden rounded-none bg-slate-200 shadow-xl lg:h-[calc(100vh-48px)] lg:max-w-[1480px] lg:rounded-lg';
    }

    public reviewTabBarClass() {
        const base = 'reviewops-mobile-modal-tabs flex shrink-0 gap-1 overflow-x-auto border-b border-slate-950 bg-slate-900 px-2';
        return this.isInlinePaneMode() ? base : `${base} lg:hidden`;
    }

    public reviewBodyClass() {
        if (!this.isInlinePaneMode()) {
            return 'reviewops-modal-body grid min-h-0 flex-1 overflow-hidden bg-slate-100 lg:grid-cols-[minmax(0,1.15fr)_minmax(500px,0.85fr)]';
        }
        const overflow = this.reviewModalTab === 'info' ? 'overflow-x-hidden overflow-y-auto' : 'overflow-hidden';
        return `reviewops-modal-body flex min-h-0 flex-1 flex-col bg-slate-100 ${overflow}`;
    }

    public reviewDesktopTabBarClass() {
        const base = 'reviewops-desktop-tabs shrink-0 border-b border-slate-950 bg-slate-900 px-5';
        return this.isInlinePaneMode() ? `hidden ${base}` : `hidden ${base} lg:flex`;
    }

    public reviewInfoPaneClass() {
        if (this.isInlinePaneMode()) return 'shrink-0 overflow-visible bg-slate-100 p-3';
        return 'min-h-0 flex-1 overflow-x-hidden overflow-y-auto bg-slate-100 p-3 lg:p-5';
    }

    public reviewCloseTitle() {
        return this.isInlinePaneMode() ? '리뷰 목록으로 돌아가기' : '닫기';
    }

    public reviewCloseIconClass() {
        return this.isInlinePaneMode() ? 'fa-solid fa-arrow-left text-[13px]' : 'fa-solid fa-xmark text-[15px]';
    }

    public isMobileLayout() {
        return window.innerWidth < 1024;
    }

    private reviewPreviewOpen() {
        return !!(
            this.screenshotPreviewUrl ||
            this.attachmentPreviewUrl ||
            (this.capturePrompt && this.capturePrompt.open) ||
            (this.codexFilePreview && this.codexFilePreview.open) ||
            (this.codexContextViewer && this.codexContextViewer.open)
        );
    }

    private syncModalScrollLock() {
        this.setModalScrollLock((this.isDialogMode() && !!this.selectedReview) || this.reviewPreviewOpen());
    }

    private setModalScrollLock(locked: boolean) {
        locked = locked && (this.isDialogMode() || this.reviewPreviewOpen());
        if (this.modalScrollLockActive === locked) return;
        this.modalScrollLockActive = locked;
        const root = document.documentElement;
        const body = document.body;
        if (!root || !body) return;
        root.classList.toggle('reviewops-modal-open', locked);
        body.classList.toggle('reviewops-modal-open', locked);
    }

    private captureParentScrollPositions() {
        const elements = Array.prototype.slice.call(document.querySelectorAll('.reviewops-layout-content, .reviewops-empty-layout-content'));
        const scrollingElement = document.scrollingElement || document.documentElement;
        if (scrollingElement) elements.push(scrollingElement);
        return elements
            .filter((element: any, index: number) => element && elements.indexOf(element) === index)
            .map((element: any) => ({ element, top: element.scrollTop || 0, left: element.scrollLeft || 0 }));
    }

    private restoreParentScrollPositions(snapshot: any[]) {
        (snapshot || []).forEach((item: any) => {
            if (!item || !item.element) return;
            item.element.scrollTop = item.top || 0;
            item.element.scrollLeft = item.left || 0;
        });
    }

    private modalScrollContainerFor(target: any) {
        const viewportSelector = '.reviewops-modal-viewport, .reviewops-inline-viewport';
        const viewport = target && target.closest ? target.closest(viewportSelector) : null;
        if (!viewport) return null;
        let node = target.parentElement;
        while (node && node !== viewport) {
            const style = window.getComputedStyle(node);
            const scrollable = /(auto|scroll)/.test(style.overflowY || '') && node.scrollHeight > node.clientHeight + 1;
            if (scrollable && node.closest(viewportSelector) === viewport) return node;
            node = node.parentElement;
        }
        return null;
    }

    private scrollModalControlIntoContainer(target: any, container: any) {
        if (!target || !container) return;
        const targetRect = target.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();
        const topPadding = 18;
        const bottomPadding = Math.max(24, Math.min(containerRect.height * 0.28, 140));
        const visibleTop = containerRect.top + topPadding;
        const visibleBottom = containerRect.bottom - bottomPadding;
        if (targetRect.top >= visibleTop && targetRect.bottom <= visibleBottom) return;
        const targetCenter = targetRect.top + (targetRect.height / 2);
        const containerCenter = containerRect.top + ((visibleBottom - visibleTop) / 2);
        container.scrollTop += targetCenter - containerCenter;
    }

    private scrollFocusedModalControlIntoView(target: any) {
        if (!this.isMobileLayout() || !target || !target.closest || !target.closest('.reviewops-modal-layer, .reviewops-inline-layer')) return;
        const tag = String(target.tagName || '').toLowerCase();
        if (!['input', 'textarea', 'select'].includes(tag)) return;
        const container = this.modalScrollContainerFor(target);
        if (!container) return;
        const parentScrollSnapshot = this.captureParentScrollPositions();
        if (this.focusedControlScrollTimer) window.clearTimeout(this.focusedControlScrollTimer);
        this.focusedControlScrollTimer = window.setTimeout(() => {
            if (this.destroyed || !target) return;
            this.setModalScrollLock(true);
            this.scrollModalControlIntoContainer(target, container);
            this.restoreParentScrollPositions(parentScrollSnapshot);
        }, 220);
    }

    public label(group: string, key: string) {
        return (this.labels[group] && this.labels[group][key]) || key || '-';
    }

    public statusLabel(status: string) { return this.label('status', status); }
    public statusDescription(status: string) { return this.label('statusDescription', status); }
    public priorityLabel(priority: string) { return this.label('priority', priority || 'normal'); }
    public categoryLabel(category: string) { return this.label('category', category || 'other'); }
    public captureLabel(method: string) { return this.label('capture', method || 'not_available'); }

    public statusBadgeClass(status: string) {
        const base = 'shrink-0 rounded-full px-2 py-0.5 text-[11px] font-medium ';
        if (status === 'resolved') return base + 'bg-emerald-50 text-emerald-700';
        if (status === 'closed') return base + 'bg-slate-100 text-slate-700';
        if (status === 'in_review') return base + 'bg-indigo-50 text-indigo-700';
        if (status === 'in_progress') return base + 'bg-amber-50 text-amber-700';
        if (status === 'recheck') return base + 'bg-rose-50 text-rose-700';
        return base + 'bg-sky-50 text-sky-700';
    }

    public projectMeta() {
        if (!this.showProjectMeta || !this.selectedReview) return '';
        return [this.reviewProjectName(), this.reviewGroupName(), this.projectUpdatedLabel()].filter((value) => !!value && value !== '-').join(' · ');
    }

    public projectMetaVisible() {
        return !!(this.showProjectMeta && this.selectedReview && (this.reviewProjectName() !== '-' || this.reviewGroupName() !== '-'));
    }

    public reviewProject(review: any = this.selectedReview) {
        return review && review.project ? review.project : {};
    }

    public canUseCodex() {
        const project = this.reviewProject();
        return !!(this.selectedReview && project && project.can_use_codex);
    }

    public reviewIsHtmlProject(review: any = this.selectedReview) {
        const type = this.projectType(review);
        return ['html', 'html_document', 'html_presentation'].includes(type);
    }

    public canUseCodexSharedFiles() {
        const project = this.reviewProject();
        const canUseHtmlSharedFiles = this.reviewIsHtmlProject() && this.currentProjectId();
        const canUseProjectFileBrowser = !this.reviewIsHtmlProject() && this.currentProjectId() && (project.file_enabled || !!this.currentCodexProjectFileOption());
        return !!(this.canUseCodex() && (canUseHtmlSharedFiles || canUseProjectFileBrowser));
    }

    public reviewScreenshots(review: any = this.selectedReview) {
        const evidence = this.reviewEvidence(review);
        const raw = []
            .concat(Array.isArray(evidence.screenshots) ? evidence.screenshots : [])
            .concat(review && Array.isArray(review.screenshots) ? review.screenshots : []);
        const seen: any = {};
        const items = raw
            .filter((item: any) => item && (item.data_url || item.storage_path || item.screenshot_storage_path))
            .map((item: any) => {
                const copied = Object.assign({}, item);
                if (!copied.storage_path && copied.screenshot_storage_path) copied.storage_path = copied.screenshot_storage_path;
                return copied;
            })
            .filter((item: any) => {
                const key = this.evidenceScreenshotKey(item) || String(item.data_url || '').slice(0, 160);
                if (!key) return false;
                if (seen[key]) return false;
                seen[key] = true;
                return true;
            });
        const primaryDataUrl = String(evidence.screenshot_data_url || (review && review.screenshot_data_url) || '');
        const primaryStoragePath = String(evidence.screenshot_storage_path || (review && review.screenshot_storage_path) || '');
        const primaryKey = this.evidenceScreenshotKey({ storage_path: primaryStoragePath }) || String(primaryDataUrl || '').slice(0, 160);
        if ((primaryDataUrl || primaryStoragePath) && !items.some((item: any) => {
            const itemKey = this.evidenceScreenshotKey(item) || String(item.data_url || '').slice(0, 160);
            return itemKey && primaryKey && itemKey === primaryKey;
        })) {
            items.unshift({
                data_url: primaryDataUrl,
                storage_path: primaryStoragePath,
                capture_method: evidence.capture_method || (review && review.capture_method) || 'not_available',
                screenshot_asset_id: evidence.screenshot_asset_id || (review && review.screenshot_asset_id) || '',
                created: evidence.created || (review && review.created) || ''
            });
        }
        return items.map((item: any, index: number) => Object.assign({}, item, {
            index: index + 1,
            label: item.label || `스크린샷 ${index + 1}`
        }));
    }

    public reviewScreenshotTotal(review: any = this.selectedReview) {
        return this.reviewScreenshots(review).length;
    }

    public codexScreenshotOptions(review: any = this.selectedReview) {
        return this.reviewScreenshots(review);
    }

    public selectedCodexScreenshotIndex(review: any = this.selectedReview) {
        const total = this.reviewScreenshotTotal(review);
        if (!total) return 0;
        return Math.min(Math.max(Number(this.codexForm.screenshot_index) || 1, 1), total);
    }

    public codexScreenshotButtonLabel(review: any = this.selectedReview) {
        const total = this.reviewScreenshotTotal(review);
        if (!total || !this.codexForm.include_screenshot) return '스크린샷';
        return `스크린샷 ${this.selectedCodexScreenshotIndex(review)}/${total}`;
    }

    public codexScreenshotOptionLabel(screenshot: any, index: number = 0) {
        return String(screenshot && screenshot.label ? screenshot.label : `스크린샷 ${index + 1}`);
    }

    public codexScreenshotOptionMeta(screenshot: any) {
        const parts = [
            this.captureLabel((screenshot && screenshot.capture_method) || this.reviewEvidence(this.selectedReview).capture_method),
            this.kstDateTime(screenshot && screenshot.created),
            this.dataUrlSizeLabel(screenshot && screenshot.data_url)
        ].filter((item: any) => !!item && item !== '-' && item !== '0 B');
        return parts.join(' · ') || '스크린샷';
    }

    public codexScreenshotOptionClass(index: number) {
        const base = 'flex min-w-0 max-w-full flex-1 items-center gap-3 overflow-hidden px-3 py-2 text-left ';
        return this.codexForm.include_screenshot && this.selectedCodexScreenshotIndex(this.selectedReview) === index
            ? base + 'bg-slate-900 text-white'
            : base + 'bg-white text-slate-700 hover:bg-slate-50';
    }

    public codexScreenshotAlbumItemClass(index: number) {
        const base = 'flex min-w-0 flex-col overflow-hidden border-b border-r bg-white transition ';
        return this.codexForm.include_screenshot && this.selectedCodexScreenshotIndex(this.selectedReview) === index
            ? base + 'border-sky-500 ring-2 ring-sky-100'
            : base + 'border-slate-200 hover:border-slate-300';
    }

    public codexScreenshotSelectButtonClass(index: number) {
        const base = 'inline-flex h-8 flex-1 items-center justify-center gap-1.5 rounded-md px-2 text-[12px] font-semibold disabled:opacity-50 ';
        return this.codexForm.include_screenshot && this.selectedCodexScreenshotIndex(this.selectedReview) === index
            ? base + 'border border-sky-200 bg-sky-50 text-sky-700'
            : base + 'border border-slate-200 bg-white text-slate-600 hover:bg-slate-50 hover:text-slate-900';
    }

    public codexScreenshotPickerDisabled() {
        if (this.codexRunning || !this.selectedReview || !this.selectedReview.id) return true;
        return false;
    }

    public trackCodexScreenshotOption(index: number, screenshot: any) {
        const key = this.evidenceScreenshotKey(screenshot) || String(screenshot && screenshot.storage_path || screenshot && screenshot.data_url || '');
        return key ? `codex-screenshot:${key}` : `codex-screenshot:${index}`;
    }

    public timelineScreenshotDataUrlValue(screenshot: any) {
        const dataUrl = String(screenshot && screenshot.data_url ? screenshot.data_url : '');
        return /^data:image\/(png|jpeg|jpg|gif|webp|svg\+xml|bmp);base64,/i.test(dataUrl) ? dataUrl : '';
    }

    public currentScreenshotIndex(review: any = this.selectedReview) {
        const total = this.reviewScreenshotTotal(review);
        if (!total) return 0;
        return Math.min(Math.max(Number(this.screenshotPage) || 1, 1), total) - 1;
    }

    public currentScreenshot(review: any = this.selectedReview) {
        const screenshots = this.reviewScreenshots(review);
        if (!screenshots.length) return null;
        return screenshots[this.currentScreenshotIndex(review)] || screenshots[0];
    }

    public currentScreenshotDataUrl(review: any = this.selectedReview) {
        const screenshot = this.currentScreenshot(review);
        return screenshot && screenshot.data_url ? screenshot.data_url : '';
    }

    public currentScreenshotNumber(review: any = this.selectedReview) {
        return this.currentScreenshotIndex(review) + 1;
    }

    public currentScreenshotLabel(review: any = this.selectedReview) {
        const total = this.reviewScreenshotTotal(review);
        if (!total) return '스크린샷';
        return `스크린샷 ${this.currentScreenshotNumber(review)}/${total}`;
    }

    public ensureScreenshotPage() {
        const total = this.reviewScreenshotTotal(this.selectedReview);
        this.screenshotPage = total ? Math.min(Math.max(Number(this.screenshotPage) || 1, 1), total) : 1;
        if (this.codexForm.include_screenshot) {
            this.codexForm.screenshot_index = total ? Math.min(Math.max(Number(this.codexForm.screenshot_index) || 1, 1), total) : 1;
            if (!total) this.codexForm.include_screenshot = false;
        }
    }

    public async setScreenshotPage(page: number) {
        this.screenshotPage = page;
        this.ensureScreenshotPage();
        await this.service.render();
    }

    public hasReviewScreenshot() {
        return this.reviewScreenshotTotal(this.selectedReview) > 0;
    }

    public reviewGroup(review: any = this.selectedReview) {
        const project = this.reviewProject(review);
        return (review && review.group) || (project && project.group) || {};
    }

    public reviewProjectName(review: any = this.selectedReview) {
        const project = this.reviewProject(review);
        return project && project.name ? project.name : '-';
    }

    public reviewGroupName(review: any = this.selectedReview) {
        const group = this.reviewGroup(review);
        return group && group.name ? group.name : '-';
    }

    public projectUpdatedLabel() {
        return this.selectedReview ? this.kstDateTime(this.selectedReview.updated) : '';
    }

    public projectDetailUrl(tab: string = 'review') {
        const project = this.reviewProject();
        const id = (project && project.id) || (this.selectedReview && this.selectedReview.project_id) || '';
        if (!id) return '';
        return `/projects/${encodeURIComponent(id)}${tab === 'review' ? '/review' : ''}`;
    }

    public groupDetailUrl() {
        const project = this.reviewProject();
        const group = this.reviewGroup();
        const id = (group && group.id) || (project && project.group_id) || (this.selectedReview && this.selectedReview.group_id) || '';
        if (!id) return '';
        const role = (group && (group.group_role || group.project_role)) || (project && (project.group_role || project.project_role)) || '';
        if (role === 'owner' || role === 'developer') return `/projects/mine/group/${encodeURIComponent(id)}`;
        if (role === 'reviewer') return `/projects/participating/group/${encodeURIComponent(id)}`;
        return `/projects/group/${encodeURIComponent(id)}`;
    }

    public reviewEvidence(review: any = this.selectedReview) {
        return review && review.evidence ? review.evidence : {};
    }

    public reviewIsDocument(review: any = this.selectedReview) {
        const project = review && review.project ? review.project : {};
        const evidence = this.reviewEvidence(review);
        return ['pdf', 'pdf_document', 'pdf_presentation', 'proposal', 'presentation'].includes(project.project_type) || !!evidence.document_version_id || !!evidence.document_version;
    }

    public reviewUsesDocumentCategories(review: any = this.selectedReview) {
        const project = review && review.project ? review.project : {};
        const type = String(project && project.project_type ? project.project_type : '');
        return this.reviewIsDocument(review) || ['html', 'html_document', 'html_presentation'].includes(type);
    }

    public documentEvidenceVersion(review: any = this.selectedReview) {
        const evidence = this.reviewEvidence(review);
        return evidence.document_version || null;
    }

    public documentVersionDisplayLabel(version: any) {
        if (!version) return '-';
        const page = Number(this.reviewEvidence().document_page) || 1;
        return [version.version_label, version.file_name, `p.${page}`].filter((value) => !!value).join(' / ');
    }

    public documentEvidenceLabel(review: any = this.selectedReview) {
        return this.documentVersionDisplayLabel(this.documentEvidenceVersion(review));
    }

    public projectType(review: any = this.selectedReview) {
        const project = review && review.project ? review.project : {};
        return project && project.project_type ? String(project.project_type) : 'web_service';
    }

    public projectTypeLabel(review: any = this.selectedReview) {
        const project = review && review.project ? review.project : {};
        return project.project_type_label || ({
            web_service: '웹서비스',
            pdf: 'PDF',
            html: 'HTML',
            pdf_document: 'PDF',
            pdf_presentation: 'PDF',
            html_document: 'HTML',
            html_presentation: 'HTML',
            proposal: 'PDF',
            presentation: 'PDF'
        } as any)[this.projectType(review)] || '웹서비스';
    }

    public reviewScaleLabel(value: any) {
        const num = Number(value);
        if (!num) return '100%';
        return `${Math.round(num * 100)}%`;
    }

    public evidenceEntries(review: any, key: string) {
        const evidence = review && review.evidence ? review.evidence : {};
        return evidence[key] || [];
    }

    public evidenceCount(review: any, key: string) {
        return this.evidenceEntries(review, key).length;
    }

    public latestEvidenceEntry(review: any, key: string) {
        const entries = this.evidenceEntries(review, key);
        return entries.length ? entries[entries.length - 1] : null;
    }

    public lastAccessUrl(review: any) {
        const lastNavigation = this.latestEvidenceEntry(review, 'navigation_log');
        return (lastNavigation && lastNavigation.url) || (review && review.current_url) || '';
    }

    public latestFingerprint(review: any, type: string = '') {
        const entries = this.evidenceEntries(review, 'fingerprint_log');
        for (let i = entries.length - 1; i >= 0; i--) {
            if (!type || entries[i].type === type) return entries[i];
        }
        return null;
    }

    public reviewLogCaptures(review: any = this.selectedReview) {
        const evidence = this.reviewEvidence(review);
        return Array.isArray(evidence.log_captures) ? evidence.log_captures.filter((item: any) => !!item) : [];
    }

    public logCaptureId(capture: any, index: number = 0) {
        const id = String(capture && (capture.id || capture.key) || '').trim();
        return id || `capture-${index + 1}`;
    }

    public logCaptureCounts(capture: any) {
        const raw = capture && capture.counts && typeof capture.counts === 'object' ? capture.counts : {};
        return {
            navigation: Number(raw.navigation) || (Array.isArray(capture && capture.navigation_log) ? capture.navigation_log.length : 0),
            input: Number(raw.input) || (Array.isArray(capture && capture.input_log) ? capture.input_log.length : 0),
            network: Number(raw.network) || (Array.isArray(capture && capture.network_log) ? capture.network_log.length : 0),
            console: Number(raw.console) || (Array.isArray(capture && capture.console_log) ? capture.console_log.length : 0),
            fingerprint: Number(raw.fingerprint) || (Array.isArray(capture && capture.fingerprint_log) ? capture.fingerprint_log.length : 0)
        };
    }

    public logCaptureTotal(capture: any) {
        const counts = this.logCaptureCounts(capture);
        return counts.navigation + counts.input + counts.network + counts.console + counts.fingerprint;
    }

    public logCaptureCountLabel(capture: any) {
        const counts = this.logCaptureCounts(capture);
        const rows = [
            ['네비게이션', counts.navigation],
            ['입력', counts.input],
            ['트래픽', counts.network],
            ['콘솔', counts.console],
            ['환경', counts.fingerprint]
        ].filter((row: any[]) => Number(row[1]) > 0);
        return rows.length ? rows.map((row: any[]) => `${row[0]} ${row[1]}`).join(' · ') : '로그 없음';
    }

    public logCaptureDisplayLabel(capture: any, index: number = 0) {
        const label = String(capture && capture.label || '').trim();
        if (label) return label.replace(/^로그\s*캡[처쳐]/, '로그');
        return `로그 ${index + 1}`;
    }

    public logCaptureMeta(capture: any) {
        const created = this.kstDateTime(capture && (capture.created || capture.captured_at));
        return [created !== '-' ? created : '', this.logCaptureCountLabel(capture)].filter((item) => !!item).join(' · ') || '로그';
    }

    public logCaptureVersionMeta(capture: any) {
        const created = this.kstDateTime(capture && (capture.created || capture.captured_at));
        const total = this.logCaptureTotal(capture);
        return [created !== '-' ? created : '', `${total}건`].filter((item) => !!item).join(' · ') || '로그';
    }

    public reviewLogVersionOptions() {
        const evidence = this.reviewEvidence(this.selectedReview);
        const currentTotal = this.reviewLogTabs.reduce((sum: number, tab: any) => sum + (Array.isArray(evidence[tab.field]) ? evidence[tab.field].length : 0), 0);
        const current = [{
            id: 'current',
            label: '현재 로그',
            meta: `${currentTotal}건`,
            capture: null
        }];
        const captures = this.reviewLogCaptures(this.selectedReview).map((capture: any, index: number) => ({
            id: this.logCaptureId(capture, index),
            label: this.logCaptureDisplayLabel(capture, index),
            meta: this.logCaptureVersionMeta(capture),
            capture
        })).reverse();
        return current.concat(captures);
    }

    public reviewLogVersionTrack(index: number, option: any) {
        return option && option.id ? option.id : `review-log-version:${index}`;
    }

    public selectedReviewLogVersionOption() {
        const options = this.reviewLogVersionOptions();
        return options.find((option: any) => option.id === this.reviewLogVersionId) || options[0] || null;
    }

    public selectedReviewLogVersionMeta() {
        const option = this.selectedReviewLogVersionOption();
        return option && option.meta ? option.meta : '';
    }

    public selectedReviewLogCapture() {
        if (this.reviewLogVersionId === 'current') return null;
        return this.reviewLogCaptures(this.selectedReview).find((capture: any, index: number) => this.logCaptureId(capture, index) === this.reviewLogVersionId) || null;
    }

    public selectedReviewLogEvidence() {
        return this.selectedReviewLogCapture() || this.reviewEvidence(this.selectedReview);
    }

    public async setReviewLogVersion(versionId: any) {
        const id = String(versionId || 'current');
        const exists = this.reviewLogVersionOptions().some((option: any) => option.id === id);
        this.reviewLogVersionId = exists ? id : 'current';
        await this.service.render();
    }

    public syncReviewLogVersion() {
        if (this.reviewLogVersionId === 'current') return;
        const exists = this.reviewLogVersionOptions().some((option: any) => option.id === this.reviewLogVersionId);
        if (!exists) this.reviewLogVersionId = 'current';
    }

    public selectedReviewLogEntries(field: string) {
        const evidence = this.selectedReviewLogEvidence();
        return evidence && Array.isArray(evidence[field]) ? evidence[field] : [];
    }

    public selectedReviewLogCount(tab: string) {
        const item = this.reviewLogTabs.find((entry) => entry.key === tab);
        return item ? this.selectedReviewLogEntries(item.field).length : 0;
    }

    public debugInfoCards(review: any) {
        const sdk = this.latestFingerprint(review, 'reviewops-sdk');
        const browser = this.latestFingerprint(review, 'browser-fingerprint');
        const frame = this.latestFingerprint(review, 'iframe-fingerprint');
        const evidence = this.reviewEvidence(review);
        if (this.reviewIsDocument(review)) {
            const version = this.documentEvidenceVersion(review);
            return [
                {
                    title: '문서',
                    rows: [
                        ['프로젝트 종류', this.projectTypeLabel(review)],
                        ['버전', this.documentVersionDisplayLabel(version)],
                        ['파일', version && version.file_name],
                        ['크기', version && (version.file_size_label || this.networkSizeLabel(version.file_size))],
                        ['페이지', evidence.document_page ? `p.${evidence.document_page}` : 'p.1'],
                        ['캡처', this.captureLabel(evidence.capture_method || 'pdf-viewer')]
                    ]
                }
            ];
        }
        return [
            {
                title: '리뷰',
                rows: [
                    ['요청 링크', review && review.current_url],
                    ['마지막 접속 링크', this.lastAccessUrl(review)],
                    ['화면', review ? `${review.viewport_width}x${review.viewport_height} / ${this.reviewScaleLabel(review.scale)}` : ''],
                    ['캡처', this.captureLabel(evidence.capture_method || 'not_available')],
                    ['스크린샷', evidence.screenshot_data_url ? '첨부됨' : '없음']
                ]
            },
            {
                title: 'SDK',
                rows: [
                    ['상태', sdk ? '수집됨' : '없음'],
                    ['버전', sdk && sdk.sdk ? sdk.sdk.version : ''],
                    ['Origin', sdk && sdk.target_origin],
                    ['문서', sdk && sdk.document ? this.compactJson(sdk.document) : ''],
                    ['보안', sdk && sdk.security ? this.compactJson(sdk.security) : '']
                ]
            },
            {
                title: '브라우저',
                rows: [
                    ['플랫폼', browser && browser.platform],
                    ['언어', browser && browser.languages],
                    ['타임존', browser && browser.timezone],
                    ['Viewport', browser && browser.viewport ? this.compactJson(browser.viewport) : ''],
                    ['Storage', browser && browser.storage ? this.compactJson(browser.storage) : '']
                ]
            },
            {
                title: 'iframe',
                rows: [
                    ['읽기 가능', frame ? (frame.readable ? '가능' : '제한') : ''],
                    ['제한 사유', frame && frame.reason],
                    ['Target', frame && (frame.target_url || frame.target_origin)],
                    ['Frame', frame && frame.iframe ? this.compactJson(frame.iframe) : ''],
                    ['Review viewport', frame && frame.review_viewport ? this.compactJson(frame.review_viewport) : '']
                ]
            }
        ];
    }

    public filteredInfoRows(rows: any[]) {
        return (rows || []).filter((row) => row && row[1] !== undefined && row[1] !== null && String(row[1]).trim() !== '');
    }

    public reviewEditPayload(review: any) {
        const fallbackCategory = this.reviewUsesDocumentCategories(review) ? 'content' : 'ux';
        return {
            title: review ? review.title : '',
            body: review ? review.body : '',
            priority: review ? review.priority : 'normal',
            category: review ? review.category : fallbackCategory
        };
    }

    public textLength(value: any) {
        return String(value || '').length;
    }

    public reviewBodyLength(form: any = this.reviewEditForm) {
        return this.textLength(form && form.body);
    }

    public reviewBodyCounterClass(form: any = this.reviewEditForm) {
        const length = this.reviewBodyLength(form);
        const base = 'text-[11px] font-medium ';
        if (length > this.reviewBodyMaxLength) return base + 'text-rose-600';
        if (length > this.reviewBodyMaxLength * 0.9) return base + 'text-amber-600';
        return base + 'text-slate-400';
    }

    public reviewBodyLimitMessage(form: any = this.reviewEditForm) {
        return `${this.reviewBodyLength(form)}/${this.reviewBodyMaxLength}`;
    }

    public canSaveReviewEdit() {
        return !!(
            this.selectedReview &&
            this.selectedReview.can_edit &&
            !this.savingReviewEdit &&
            this.reviewBodyLength(this.reviewEditForm) <= this.reviewBodyMaxLength
        );
    }

    public editCategoryOptions() {
        return this.reviewUsesDocumentCategories() ? this.documentCategoryOptions : this.webCategoryOptions;
    }

    public async setReviewEditOption(key: string, value: string) {
        if (!this.selectedReview || !this.selectedReview.can_edit) return;
        this.reviewEditForm[key] = value;
        await this.service.render();
    }

    public async startReviewEdit() {
        if (!this.selectedReview || !this.selectedReview.can_edit) return;
        this.reviewEditForm = this.reviewEditPayload(this.selectedReview);
        this.editingReview = true;
        await this.service.render();
    }

    public async cancelReviewEdit() {
        this.editingReview = false;
        this.reviewEditForm = this.reviewEditPayload(this.selectedReview);
        await this.service.render();
    }

    public async saveReviewEdit() {
        if (!this.selectedReview || !this.selectedReview.can_edit) return;
        if (this.reviewBodyLength(this.reviewEditForm) > this.reviewBodyMaxLength) {
            await this.service.modal.error(`리뷰 내용은 공백 포함 ${this.reviewBodyMaxLength}자까지 입력할 수 있습니다.`);
            return;
        }
        this.savingReviewEdit = true;
        await this.service.render();
        const { code, data } = await wiz.call('update_review', this.requestParams({
            review_id: this.selectedReview.id,
            data: JSON.stringify(this.reviewEditForm)
        }));
        this.savingReviewEdit = false;
        if (code === 200) {
            this.applyReview(data.review);
            this.editingReview = false;
        } else {
            await this.service.modal.error(data.message || '리뷰 정보를 저장하지 못했습니다.');
        }
        await this.service.render();
    }

    public activityStatusOptions(review: any = this.selectedReview) {
        const allowed = review && Array.isArray(review.allowed_statuses) ? review.allowed_statuses : [];
        return this.statusOptions.filter((status) => allowed.includes(status));
    }

    public reviewTimelineItems(review: any = this.selectedReview) {
        if (!review) return [];
        const activities = Array.isArray(review.activities) ? review.activities : [];
        const attachments = Array.isArray(review.attachments) ? review.attachments : [];
        const screenshots = this.reviewScreenshotTimelineItems(review);
        const screenshotSignature = this.reviewTimelineScreenshotSignature(screenshots);
        const logCaptures = this.reviewLogCaptureTimelineItems(review);
        const logCaptureSignature = this.reviewTimelineLogCaptureSignature(logCaptures);
        const body = String(review.body || '').trim();
        const cache = this.reviewTimelineCache;
        if (
            cache.reviewId === String(review.id || '') &&
            cache.body === body &&
            cache.created === String(review.created || '') &&
            cache.author === review.author &&
            cache.attachments === attachments &&
            cache.activities === activities &&
            cache.attachmentCount === attachments.length &&
            cache.activityCount === activities.length &&
            cache.screenshotSignature === screenshotSignature &&
            cache.logCaptureSignature === logCaptureSignature
        ) {
            return cache.items;
        }
        const startItem = {
            id: `review-created:${String(review.id || '')}`,
            timeline_kind: 'review_created',
            timeline_order: 0,
            author: review.author || {},
            created: review.created || '',
            status: '',
            message: body || '리뷰가 등록되었습니다.',
            attachments,
            can_edit: false
        };
        const activityItems = activities.map((activity: any, index: number) => Object.assign({}, activity || {}, {
            timeline_kind: activity && activity.timeline_kind ? activity.timeline_kind : 'activity',
            timeline_order: 100 + index
        }));
        const items = [startItem].concat(screenshots).concat(logCaptures).concat(activityItems).sort((a: any, b: any) => {
            const aTime = this.reviewTimelineTimeValue(a && a.created);
            const bTime = this.reviewTimelineTimeValue(b && b.created);
            if (aTime !== bTime) return aTime - bTime;
            return (Number(a && a.timeline_order) || 0) - (Number(b && b.timeline_order) || 0);
        });
        this.reviewTimelineCache = {
            reviewId: String(review.id || ''),
            body,
            created: String(review.created || ''),
            author: review.author,
            attachments,
            activities,
            attachmentCount: attachments.length,
            activityCount: activities.length,
            screenshotSignature,
            logCaptureSignature,
            items
        };
        return items;
    }

    private reviewTimelineTimeValue(value: any) {
        return this.codexTimestampSeconds(value) || 0;
    }

    private reviewTimelineScreenshotSignature(items: any[]) {
        return (Array.isArray(items) ? items : []).map((item: any, index: number) => [
            index,
            String(item && item.id || ''),
            String(item && item.created || ''),
            String(item && item.screenshot && (item.screenshot.storage_path || item.screenshot.data_url) || '')
        ].join(':')).join('|');
    }

    private reviewTimelineLogCaptureSignature(items: any[]) {
        return (Array.isArray(items) ? items : []).map((item: any, index: number) => [
            index,
            String(item && item.id || ''),
            String(item && item.created || ''),
            String(item && item.log_capture_id || ''),
            String(item && item.log_capture && item.log_capture.total || '')
        ].join(':')).join('|');
    }

    public reviewScreenshotTimelineItems(review: any = this.selectedReview) {
        if (!review) return [];
        const evidence = this.reviewEvidence(review);
        const evidenceCreated = evidence && evidence.created ? evidence.created : '';
        return this.reviewScreenshots(review).map((screenshot: any, index: number) => {
            const created = screenshot.created || evidenceCreated || review.created || '';
            const key = this.evidenceScreenshotKey(screenshot) || `index:${index + 1}`;
            const label = screenshot.label || `스크린샷 ${index + 1}`;
            return {
                id: `review-screenshot:${String(review.id || '')}:${key}`,
                timeline_kind: 'review_screenshot',
                timeline_order: 10 + index,
                author: review.author || {},
                created,
                status: '',
                message: `${label}이 등록되었습니다.`,
                attachments: [],
                can_edit: false,
                screenshot: Object.assign({}, screenshot, {
                    index: index + 1,
                    label,
                    created
                })
            };
        });
    }

    public reviewLogCaptureTimelineItems(review: any = this.selectedReview) {
        if (!review) return [];
        return this.reviewLogCaptures(review).map((capture: any, index: number) => {
            const created = capture.captured_at || capture.created || (review.evidence && review.evidence.created) || review.created || '';
            const key = this.logCaptureId(capture, index);
            const label = this.logCaptureDisplayLabel(capture, index);
            const enrichedCapture = Object.assign({}, capture || {}, {
                index: index + 1,
                label,
                created,
                captured_at: capture.captured_at || capture.created || created,
                total: this.logCaptureTotal(capture)
            });
            return {
                id: `review-log:${String(review.id || '')}:${key}`,
                timeline_kind: 'review_log',
                timeline_order: 20 + index,
                author: review.author || {},
                created,
                status: '',
                message: '로그 정보가 저장되었습니다.',
                attachments: [],
                can_edit: false,
                log_capture_id: key,
                log_capture: enrichedCapture
            };
        });
    }

    public isScreenshotTimelineItem(item: any) {
        return !!(item && item.timeline_kind === 'review_screenshot');
    }

    public isLogCaptureTimelineItem(item: any) {
        return !!(item && item.timeline_kind === 'review_log');
    }

    public timelineScreenshotDataUrl(item: any) {
        const screenshot = item && item.screenshot ? item.screenshot : {};
        return this.timelineScreenshotDataUrlValue(screenshot);
    }

    public async openTimelineScreenshot(item: any) {
        const dataUrl = this.timelineScreenshotDataUrl(item);
        if (!dataUrl) return;
        const screenshot = item && item.screenshot ? item.screenshot : {};
        this.screenshotPreviewUrl = dataUrl;
        this.screenshotPreviewIndex = Number(screenshot.index) || 0;
        this.screenshotPreviewTitle = `${screenshot.label || '스크린샷'} · ${this.kstDateTime(item && item.created)}`;
        this.syncModalScrollLock();
        await this.service.render();
    }

    public logCaptureTimelineLabel(item: any) {
        const capture = item && item.log_capture ? item.log_capture : {};
        return this.logCaptureDisplayLabel(capture, Number(capture.index || 1) - 1);
    }

    public logCaptureTimelineCapturedAt(item: any) {
        const capture = item && item.log_capture ? item.log_capture : {};
        return this.kstDateTime(capture.captured_at || capture.created || (item && item.created));
    }

    public firstLogTabWithEntries(evidence: any) {
        const found = this.reviewLogTabs.find((tab: any) => Array.isArray(evidence && evidence[tab.field]) && evidence[tab.field].length);
        return found ? found.key : 'navigation';
    }

    public async openTimelineLogCapture(item: any) {
        if (!this.isLogCaptureTimelineItem(item)) return;
        const versionId = String(item && item.log_capture_id || '').trim();
        if (versionId) this.reviewLogVersionId = versionId;
        this.reviewLogTab = this.firstLogTabWithEntries(item && item.log_capture);
        await this.setReviewModalTab('log');
        if (versionId) this.reviewLogVersionId = versionId;
        this.reviewLogTab = this.firstLogTabWithEntries(this.selectedReviewLogEvidence());
        await this.service.render();
    }

    public trackReviewTimelineItem(index: number, item: any) {
        return item && item.id ? item.id : `timeline:${index}`;
    }

    public isReviewStartTimelineItem(item: any) {
        return !!(item && item.timeline_kind === 'review_created');
    }

    public isCodexActivity(item: any) {
        return !!(item && !this.isReviewStartTimelineItem(item) && item.is_codex);
    }

    public codexActivityKey(item: any, index: number = 0) {
        const reviewId = String(this.selectedReview && this.selectedReview.id ? this.selectedReview.id : 'review');
        const activityId = String(item && item.id ? item.id : `activity-${index}`);
        return `${reviewId}:${activityId}`;
    }

    public codexActivityContentId(item: any, index: number = 0) {
        const key = this.codexActivityKey(item, index).replace(/[^a-zA-Z0-9_-]+/g, '-');
        return `reviewops-codex-activity-${key}`;
    }

    public isCodexActivityExpanded(item: any, index: number = 0) {
        return !!this.expandedCodexActivities[this.codexActivityKey(item, index)];
    }

    public async toggleCodexActivity(item: any, index: number = 0) {
        if (!this.isCodexActivity(item)) return;
        const key = this.codexActivityKey(item, index);
        this.expandedCodexActivities = Object.assign({}, this.expandedCodexActivities, {
            [key]: !this.expandedCodexActivities[key]
        });
        await this.service.render();
    }

    public async openTimelineAttachment(attachment: any, attachmentIndex: number, item: any, timelineIndex: number) {
        const isReviewStart = this.isReviewStartTimelineItem(item);
        const activityIndex = isReviewStart ? 0 : timelineIndex;
        await this.openAttachmentPreview(attachment, isReviewStart ? 'review' : 'activity', attachmentIndex, isReviewStart ? null : item, activityIndex);
    }

    public async downloadTimelineAttachment(attachment: any, attachmentIndex: number, item: any, timelineIndex: number) {
        const isReviewStart = this.isReviewStartTimelineItem(item);
        const activityIndex = isReviewStart ? 0 : timelineIndex;
        await this.downloadAttachment(attachment, isReviewStart ? 'review' : 'activity', attachmentIndex, isReviewStart ? null : item, activityIndex);
    }

    public defaultActivityStatus(review: any = this.selectedReview) {
        return '';
    }

    public resetActivityForm(review: any = this.selectedReview) {
        this.activityForm = { message: '', status: this.defaultActivityStatus(review), attachments: [] };
    }

    private blurMobileComposerControl() {
        const activeElement = document.activeElement as any;
        if (activeElement && activeElement.closest && activeElement.closest('.reviewops-mobile-composer') && activeElement.blur) {
            activeElement.blur();
        }
    }

    public resetMobileComposerState() {
        this.blurMobileComposerControl();
        this.activityComposerExpanded = false;
        this.codexComposerExpanded = false;
        this.closeCodexScreenshotPicker();
        this.closeCodexLogCapturePicker();
        this.closeCodexAttachmentPicker();
        this.closeCodexSharedFilePicker();
    }

    public mobileComposerExpanded(kind: string) {
        if (!this.isMobileLayout()) return true;
        return kind === 'codex' ? this.codexComposerExpanded : this.activityComposerExpanded;
    }

    public mobileComposerActive() {
        if (!this.isMobileLayout()) return false;
        if (this.reviewModalTab === 'history') return this.activityComposerExpanded;
        if (this.reviewModalTab === 'codex') return this.codexComposerExpanded;
        return false;
    }

    public codexPickerOpen() {
        return !!(this.codexScreenshotPickerOpen || this.codexLogCapturePickerOpen || this.codexAttachmentPickerOpen || this.codexSharedFilePickerOpen);
    }

    public codexChatClass() {
        const base = 'reviewops-codex-chat reviewops-mobile-composer-background min-h-0 flex-1 bg-white';
        if (this.codexPickerOpen()) return `${base} reviewops-codex-picker-stage flex overflow-hidden p-0`;
        return `${base} space-y-3 overflow-y-auto p-3 lg:p-5`;
    }

    public mobileComposerClass(kind: string) {
        const composer = kind === 'codex' ? 'reviewops-codex-composer' : 'reviewops-activity-composer';
        const state = this.mobileComposerExpanded(kind)
            ? 'reviewops-mobile-composer-expanded'
            : 'reviewops-mobile-composer-collapsed';
        const surface = 'border-slate-600 bg-slate-700';
        return `${composer} reviewops-mobile-composer ${state} shrink-0 border-t ${surface} p-2 lg:p-3`;
    }

    public mobileComposerRows(kind: string) {
        return this.mobileComposerExpanded(kind) ? 3 : 1;
    }

    public async expandMobileComposer(kind: string) {
        if (!this.isMobileLayout() || this.mobileComposerExpanded(kind)) return;
        if (kind === 'codex') {
            this.codexComposerExpanded = true;
            this.closeCodexScreenshotPicker();
            this.closeCodexLogCapturePicker();
            this.closeCodexAttachmentPicker();
            this.closeCodexSharedFilePicker();
        } else {
            this.activityComposerExpanded = true;
        }
        await this.service.render();
        this.scrollFocusedModalControlIntoView(document.activeElement);
    }

    public async collapseMobileComposer(kind: string) {
        if (!this.isMobileLayout()) return;
        this.blurMobileComposerControl();
        if (kind === 'codex') {
            this.codexComposerExpanded = false;
            this.closeCodexScreenshotPicker();
            this.closeCodexLogCapturePicker();
            this.closeCodexAttachmentPicker();
            this.closeCodexSharedFilePicker();
        } else {
            this.activityComposerExpanded = false;
        }
        await this.service.render();
    }

    public shouldKeepActivityFormOnReviewRefresh(next: any) {
        const sameReview = !!(next && next.id && this.selectedReview && this.selectedReview.id === next.id);
        return sameReview && this.reviewModalTab === 'history';
    }

    public async setActivityStatus(status: string) {
        this.activityForm.status = this.activityForm.status === status ? '' : status;
        await this.service.render();
    }

    public activityEditPayload(item: any) {
        const attachments = item && Array.isArray(item.attachments) ? JSON.parse(JSON.stringify(item.attachments)) : [];
        return { message: item ? item.message : '', attachments };
    }

    public resetActivityEditState() {
        this.activityEditId = '';
        this.activityEditForm = { message: '', attachments: [] };
        this.savingActivityEdit = false;
        this.activityEditAttachmentBusy = false;
    }

    public async startActivityEdit(item: any) {
        if (!item || !item.can_edit) return;
        this.activityEditId = item.id || '';
        this.activityEditForm = this.activityEditPayload(item);
        await this.service.render();
    }

    public async cancelActivityEdit(render: boolean = true) {
        this.resetActivityEditState();
        if (render) await this.service.render();
    }

    public isEditingActivity(item: any) {
        return !!(item && item.id && this.activityEditId === item.id);
    }

    public async setReviewModalTab(tab: string) {
        if (tab === 'codex' && !this.canUseCodex()) return;
        const previousTab = this.reviewModalTab;
        this.reviewModalTab = tab || 'history';
        if (previousTab !== this.reviewModalTab) this.resetMobileComposerState();
        this.screenshotActionMenuOpen = false;
        if (this.reviewModalTab === 'codex' && !this.canUseCodex()) this.reviewModalTab = 'history';
        if (this.reviewModalTab !== 'codex') {
            this.closeCodexScreenshotPicker();
            this.closeCodexLogCapturePicker();
            this.closeCodexAttachmentPicker();
            this.closeCodexSharedFilePicker();
        }
        await this.service.render();
        if (this.reviewModalTab === 'log') await this.loadReviewEvidence(false);
        if (this.reviewModalTab === 'history') {
            await this.loadReviewActivities();
            this.scrollActivityHistoryToBottom();
        }
        if (this.reviewModalTab === 'codex') {
            await this.loadCodexDetail();
            this.scrollCodexChatToBottom();
        }
    }

    public codexDetailLoaded() {
        return !!(this.selectedReview && this.selectedReview.id && this.codexLoadedReviewId === this.selectedReview.id);
    }

    public async loadCodexDetail() {
        if (!this.selectedReview || !this.selectedReview.id || !this.canUseCodex()) return false;
        if (this.codexDetailLoaded()) return true;
        if (this.codexDetailLoading) return false;
        const reviewId = this.selectedReview.id;
        const requestToken = this.reviewDetailRequestToken;
        this.codexDetailLoading = true;
        await this.service.render();
        const { code, data } = await wiz.call('load_review_detail', this.requestParams({
            review_id: this.selectedReview.id,
            include_codex: '1',
            include_heavy_evidence: '0',
            include_activities: '1',
            include_attachment_data: '0'
        }));
        if (this.destroyed || requestToken !== this.reviewDetailRequestToken || !this.selectedReview || this.selectedReview.id !== reviewId) {
            this.codexDetailLoading = false;
            return false;
        }
        this.codexDetailLoading = false;
        if (code === 200 && data.user) this.currentUser = data.user || {};
        if (code === 200 && data.review) {
            if (this.selectedReview && this.selectedReview.evidence) data.review.evidence = this.selectedReview.evidence;
            this.applyReview(data.review);
            this.codexLoadedReviewId = this.selectedReview.id;
            this.activitiesLoadedReviewId = this.selectedReview.id;
            this.syncCodexStateFromReview();
            await this.service.render();
            return true;
        }
        await this.service.render();
        await this.service.modal.error((data && data.message) || '에이전트 정보를 불러오지 못했습니다.');
        return false;
    }

    public async setReviewLogTab(tab: string) {
        this.reviewLogTab = tab || 'navigation';
        await this.service.render();
    }

    public workspaceTabClass(tab: string) {
        if (this.reviewModalTab === tab) return 'border-sky-400 text-white';
        return 'border-transparent text-slate-300 hover:text-white';
    }

    public reviewRequestPaneClass() {
        if (this.isInlinePaneMode()) {
            const visibility = this.reviewModalTab === 'info' ? 'block' : 'hidden';
            return `${visibility} reviewops-modal-scroll-pane shrink-0 overflow-visible border-b border-slate-300 bg-slate-100 p-3`;
        }
        const mobile = this.reviewModalTab === 'request' ? 'block' : 'hidden';
        return `${mobile} reviewops-modal-scroll-pane min-h-0 overflow-y-auto border-b border-slate-300 bg-slate-100 p-3 lg:block lg:border-b-0 lg:border-r lg:p-6`;
    }

    public reviewWorkspacePaneClass() {
        if (this.isInlinePaneMode()) {
            const size = this.reviewModalTab === 'info' ? 'shrink-0' : 'min-h-0 flex-1';
            return `reviewops-modal-workspace-pane flex ${size} flex-col bg-slate-200`;
        }
        const mobile = this.reviewModalTab === 'request' ? 'hidden' : 'flex';
        return `${mobile} reviewops-modal-workspace-pane min-h-0 flex-col bg-slate-200 lg:flex`;
    }

    public logTabClass(tab: string) {
        if (this.reviewLogTab === tab) return 'bg-slate-900 text-white border-slate-900';
        return 'bg-white text-slate-600 hover:bg-slate-50 hover:text-slate-950';
    }

    public scrollActivityHistoryToBottom() {
        setTimeout(() => {
            const element = document.getElementById('reviewops-shared-activity-history-scroll');
            if (element) element.scrollTop = element.scrollHeight;
        }, 80);
    }

    public activityAttachments() {
        if (!this.activityForm.attachments) this.activityForm.attachments = [];
        return this.activityForm.attachments;
    }

    public activityEditAttachments() {
        if (!this.activityEditForm.attachments) this.activityEditForm.attachments = [];
        return this.activityEditForm.attachments;
    }

    public selectedReviewAttachments() {
        if (!this.selectedReview) return [];
        if (!this.selectedReview.attachments) this.selectedReview.attachments = [];
        return this.selectedReview.attachments;
    }

    public codexAttachmentRefs() {
        if (!this.codexForm.attachments || !Array.isArray(this.codexForm.attachments)) this.codexForm.attachments = [];
        return this.codexForm.attachments;
    }

    public setCodexAttachmentRefs(refs: any[]) {
        const seen: any = {};
        const attachments = (Array.isArray(refs) ? refs : []).map((ref: any) => this.codexAttachmentReference(ref)).filter((ref: any) => {
            const key = this.codexAttachmentRefKey(ref);
            if (!key || seen[key]) return false;
            seen[key] = true;
            return true;
        });
        this.codexForm = Object.assign({}, this.codexForm, { attachments });
        return attachments;
    }

    public cleanCodexProjectPath(path: any) {
        return String(path || '').replace(/\\/g, '/').trim().split('/').filter((part) => !!part && part !== '.').join('/');
    }

    public cleanCodexAbsolutePath(path: any) {
        const value = String(path || '').replace(/\\/g, '/').trim().replace(/:\d+(?::\d+)?$/, '');
        if (!value) return '';
        const absolute = value.charAt(0) === '/';
        const parts = value.split('/').filter((part) => !!part && part !== '.' && part !== '..');
        if (!parts.length) return absolute ? '/' : '';
        return `${absolute ? '/' : ''}${parts.join('/')}`;
    }

    public codexSharedFileKey(path: any) {
        const value = this.cleanCodexProjectPath(path);
        return value ? `html_project_file:${value}` : '';
    }

    public codexProjectFileKey(path: any) {
        const value = this.cleanCodexAbsolutePath(path);
        return value && value !== '/' ? `project_file:${value}` : '';
    }

    public isCodexSharedFileSource(source: any) {
        return ['html_project_file', 'project_file'].includes(String(source || '').trim());
    }

    public codexAttachmentOptionKey(source: string, attachmentIndex: number, activity: any = null, activityIndex: number = 0, projectPath: string = '') {
        if (source === 'html_project_file') return this.codexSharedFileKey(projectPath);
        if (source === 'project_file') return this.codexProjectFileKey(projectPath);
        if (source === 'html_reference' || source === 'html_resource') return `${source}:${attachmentIndex}`;
        if (source === 'activity') {
            const activityToken = activity && activity.id ? String(activity.id) : String(activityIndex + 1);
            return `activity:${activityToken}:${attachmentIndex}`;
        }
        return `review:${attachmentIndex}`;
    }

    public codexAttachmentRefKey(ref: any) {
        if (typeof ref === 'string') {
            const key = ref.trim();
            if (key.indexOf('html_project_file:') === 0) return this.codexSharedFileKey(key.slice('html_project_file:'.length));
            if (key.indexOf('project_file:') === 0) return this.codexProjectFileKey(key.slice('project_file:'.length));
            return key;
        }
        if (!ref || typeof ref !== 'object') return '';
        const explicitKey = String(ref.key || '').trim();
        if (explicitKey) return this.codexAttachmentRefKey(explicitKey);
        const source = String(ref.source || '').trim();
        const index = Number(ref.index) || 0;
        if (source === 'html_project_file') return this.codexSharedFileKey(ref.project_path || ref.path);
        if (source === 'project_file') return this.codexProjectFileKey(ref.absolute_path || ref.project_path || ref.path);
        if (source === 'html_reference' || source === 'html_resource') return `${source}:${index}`;
        if (source === 'activity') {
            const token = String(ref.activity_id || ref.activity_index || '').trim();
            return token ? `activity:${token}:${index}` : '';
        }
        if (source === 'review') return `review:${index}`;
        return '';
    }

    public codexAttachmentSourceLabel(source: string, activityIndex: number = 0) {
        if (source === 'activity') return `작업이력 ${activityIndex + 1}`;
        if (source === 'html_reference') return '참고자료';
        if (source === 'html_resource') return '리소스';
        if (source === 'html_project_file') return '공용파일';
        if (source === 'project_file') return '공용파일';
        return '리뷰 첨부';
    }

    public codexAttachmentSourceDetail(activity: any) {
        if (!activity) return '리뷰 생성 시 첨부';
        const author = activity.author && (activity.author.name || activity.author.display_name || activity.author.email) ? (activity.author.name || activity.author.display_name || activity.author.email) : '';
        const created = this.kstDateTime(activity.created);
        return [author, created && created !== '-' ? created : ''].filter((item) => !!item).join(' · ') || '작업이력 첨부';
    }

    public currentCodexProjectFileOption() {
        if (this.reviewIsHtmlProject()) return null;
        const file = this.activeProjectFile || {};
        if (!file || file.is_directory || file.type === 'directory') return null;
        const rawPath = String(file.absolute_path || file.project_path || file.path || '').trim();
        const filePath = rawPath.charAt(0) === '/' ? this.cleanCodexAbsolutePath(rawPath) : this.cleanCodexProjectPath(rawPath);
        if (!filePath || filePath === '/') return null;
        const name = String(file.name || filePath.split('/').pop() || 'file');
        return {
            key: this.codexProjectFileKey(filePath),
            source: 'project_file',
            source_label: this.codexAttachmentSourceLabel('project_file'),
            source_detail: filePath,
            index: 0,
            name,
            mime: String(file.mime || 'application/octet-stream'),
            size: Number(file.size || 0),
            path: filePath,
            project_path: filePath,
            absolute_path: rawPath.charAt(0) === '/' ? filePath : '',
            relative_path: String(file.relative_path || ''),
            is_directory: false
        };
    }

    public codexAttachmentOptions(review: any = this.selectedReview) {
        const options: any[] = [];
        const reviewAttachments = review && Array.isArray(review.attachments) ? review.attachments : [];
        reviewAttachments.forEach((attachment: any, index: number) => {
            options.push(Object.assign({}, attachment || {}, {
                key: this.codexAttachmentOptionKey('review', index),
                source: 'review',
                source_label: this.codexAttachmentSourceLabel('review'),
                source_detail: this.codexAttachmentSourceDetail(null),
                index
            }));
        });
        const activities = review && Array.isArray(review.activities) ? review.activities : [];
        activities.forEach((activity: any, activityIndex: number) => {
            const attachments = activity && Array.isArray(activity.attachments) ? activity.attachments : [];
            attachments.forEach((attachment: any, index: number) => {
                options.push(Object.assign({}, attachment || {}, {
                    key: this.codexAttachmentOptionKey('activity', index, activity, activityIndex),
                    source: 'activity',
                    source_label: this.codexAttachmentSourceLabel('activity', activityIndex),
                    source_detail: this.codexAttachmentSourceDetail(activity),
                    activity_id: activity && activity.id ? activity.id : '',
                    activity_index: activityIndex + 1,
                    index
                }));
            });
        });
        const project = review && review.project ? review.project : {};
        const projectFileGroups = [
            { source: 'html_reference', files: project && Array.isArray(project.html_reference_files) ? project.html_reference_files : [] },
            { source: 'html_resource', files: project && Array.isArray(project.html_resource_files) ? project.html_resource_files : [] }
        ];
        projectFileGroups.forEach((group: any) => {
            group.files.forEach((file: any, index: number) => {
                const path = String(file && file.path ? file.path : '');
                options.push(Object.assign({}, file || {}, {
                    key: this.codexAttachmentOptionKey(group.source, index),
                    source: group.source,
                    source_label: this.codexAttachmentSourceLabel(group.source),
                    source_detail: path || (group.source === 'html_reference' ? 'references' : 'resources'),
                    project_path: path,
                    index
                }));
            });
        });
        const activeProjectFile = this.currentCodexProjectFileOption();
        if (activeProjectFile && !options.some((option: any) => this.codexAttachmentRefKey(option) === activeProjectFile.key)) {
            options.push(activeProjectFile);
        }
        return options;
    }

    public codexAttachmentSearchText(value: any) {
        return String(value === undefined || value === null ? '' : value).toLowerCase().trim();
    }

    public filteredCodexAttachmentOptions() {
        const query = this.codexAttachmentSearchText(this.codexAttachmentSearch);
        const options = this.codexAttachmentOptions();
        if (!query) return options;
        return options.filter((option: any) => {
            const haystack = [
                option.name,
                option.mime,
                option.source_label,
                option.source_detail,
                this.attachmentSizeLabel(option)
            ].map((item) => this.codexAttachmentSearchText(item)).join(' ');
            return haystack.indexOf(query) >= 0;
        });
    }

    public codexAttachmentOptionTrack(index: number, option: any) {
        return option.key;
    }

    public allFilteredCodexAttachmentsSelected() {
        const options = this.filteredCodexAttachmentOptions();
        const selectedKeys = new Set(this.selectedCodexAttachmentKeys());
        return options.length > 0 && options.every((option: any) => selectedKeys.has(this.codexAttachmentRefKey(option)));
    }

    public async toggleAllFilteredCodexAttachments(event: any = null) {
        if (event && event.preventDefault) event.preventDefault();
        if (event && event.stopPropagation) event.stopPropagation();
        if (this.codexRunning) return;
        const options = this.filteredCodexAttachmentOptions();
        if (!options.length) return;
        const refs = this.codexAttachmentRefs();
        if (this.allFilteredCodexAttachmentsSelected()) {
            const keys = new Set(options.map((option: any) => this.codexAttachmentRefKey(option)));
            this.setCodexAttachmentRefs(refs.filter((ref: any) => !keys.has(this.codexAttachmentRefKey(ref))));
        } else {
            this.setCodexAttachmentRefs(refs.concat(options));
        }
        await this.service.render();
    }

    public selectedCodexAttachmentKeys() {
        return this.codexAttachmentRefs().map((ref: any) => this.codexAttachmentRefKey(ref)).filter((key: string) => !!key);
    }

    public isCodexAttachmentSelected(option: any) {
        const key = this.codexAttachmentRefKey(option);
        return !!key && this.selectedCodexAttachmentKeys().includes(key);
    }

    public selectedCodexAttachmentOptions() {
        const optionsByKey: any = {};
        this.codexAttachmentOptions().forEach((option: any) => {
            const key = this.codexAttachmentRefKey(option);
            if (key) optionsByKey[key] = option;
        });
        return this.codexAttachmentRefs().map((ref: any) => {
            const key = this.codexAttachmentRefKey(ref);
            if (optionsByKey[key]) return optionsByKey[key];
            if (ref && typeof ref === 'object') return this.codexAttachmentReference(ref);
            return null;
        }).filter((option: any) => !!option);
    }

    public selectedCodexUploadAttachmentOptions() {
        return this.selectedCodexAttachmentOptions().filter((option: any) => option && !this.isCodexSharedFileSource(option.source));
    }

    public selectedCodexSharedFileOptions() {
        return this.selectedCodexAttachmentOptions().filter((option: any) => option && this.isCodexSharedFileSource(option.source));
    }

    public codexLogCaptureRefs() {
        if (!this.codexForm.log_capture_ids || !Array.isArray(this.codexForm.log_capture_ids)) this.codexForm.log_capture_ids = [];
        return this.codexForm.log_capture_ids;
    }

    public codexLogCaptureOptionKey(capture: any, index: number = 0) {
        const id = this.logCaptureId(capture, index);
        return id ? `log_capture:${id}` : '';
    }

    public codexLogCaptureRefKey(ref: any) {
        if (typeof ref === 'string') {
            const key = ref.trim();
            if (!key) return '';
            return key.indexOf('log_capture:') === 0 ? key : `log_capture:${key}`;
        }
        if (!ref || typeof ref !== 'object') return '';
        const explicitKey = String(ref.key || '').trim();
        if (explicitKey) return this.codexLogCaptureRefKey(explicitKey);
        const id = String(ref.id || ref.log_capture_id || '').trim();
        if (id) return `log_capture:${id}`;
        const index = Number(ref.index);
        return Number.isFinite(index) && index >= 0 ? `log_capture:capture-${index + 1}` : '';
    }

    public codexLogCaptureReference(capture: any, index: number = 0) {
        const key = this.codexLogCaptureOptionKey(capture, index);
        return {
            key,
            id: this.logCaptureId(capture, index),
            index,
            label: this.logCaptureDisplayLabel(capture, index),
            created: String(capture && (capture.created || capture.captured_at) || ''),
            captured_at: String(capture && (capture.captured_at || capture.created) || ''),
            counts: this.logCaptureCounts(capture),
            total: this.logCaptureTotal(capture)
        };
    }

    public codexLogCaptureOptions() {
        return this.reviewLogCaptures(this.selectedReview).map((capture: any, index: number) => this.codexLogCaptureReference(capture, index)).reverse();
    }

    public selectedCodexLogCaptureKeys() {
        return this.codexLogCaptureRefs().map((ref: any) => this.codexLogCaptureRefKey(ref)).filter((key: string) => !!key);
    }

    public isCodexLogCaptureSelected(option: any) {
        const key = this.codexLogCaptureRefKey(option);
        return !!key && this.selectedCodexLogCaptureKeys().includes(key);
    }

    public setCodexLogCaptureRefs(refs: any[]) {
        const seen: any = {};
        const optionsByKey: any = {};
        this.codexLogCaptureOptions().forEach((option: any) => {
            const key = this.codexLogCaptureRefKey(option);
            if (key) optionsByKey[key] = option;
        });
        const items = (Array.isArray(refs) ? refs : []).map((ref: any) => {
            const key = this.codexLogCaptureRefKey(ref);
            return key ? (optionsByKey[key] || ref) : null;
        }).filter((ref: any) => {
            const key = this.codexLogCaptureRefKey(ref);
            if (!key || seen[key]) return false;
            seen[key] = true;
            return true;
        });
        this.codexForm = Object.assign({}, this.codexForm, { log_capture_ids: items });
        return items;
    }

    public selectedCodexLogCaptureOptions() {
        const optionsByKey: any = {};
        this.codexLogCaptureOptions().forEach((option: any) => {
            const key = this.codexLogCaptureRefKey(option);
            if (key) optionsByKey[key] = option;
        });
        return this.codexLogCaptureRefs().map((ref: any) => {
            const key = this.codexLogCaptureRefKey(ref);
            return key ? optionsByKey[key] || ref : null;
        }).filter((option: any) => !!option);
    }

    public selectedCodexLogCaptureReferences() {
        return this.selectedCodexLogCaptureOptions().map((option: any, index: number) => {
            const key = this.codexLogCaptureRefKey(option);
            return Object.assign({}, option, {
                key,
                id: String(option && option.id || key.replace(/^log_capture:/, '')),
                index: Number(option && option.index) || index
            });
        });
    }

    public codexLogCaptureButtonLabel() {
        const count = this.selectedCodexLogCaptureOptions().length;
        return count ? `로그 ${count}` : '로그';
    }

    public codexLogCapturePickerDisabled() {
        return !!(this.codexRunning || !this.selectedReview || !this.selectedReview.id);
    }

    public codexLogCaptureOptionClass(option: any) {
        const base = 'flex min-w-0 max-w-full flex-1 items-center gap-3 overflow-hidden px-3 py-2 text-left ';
        return this.isCodexLogCaptureSelected(option)
            ? base + 'bg-slate-900 text-white'
            : base + 'bg-white text-slate-700 hover:bg-slate-50';
    }

    public codexAttachmentReference(option: any) {
        const key = this.codexAttachmentRefKey(option);
        const keyParts = key.split(':');
        const keySource = ['review', 'activity', 'html_reference', 'html_resource', 'project_file'].includes(keyParts[0]) ? keyParts[0] : '';
        const source = String(option && option.source ? option.source : (key.indexOf('html_project_file:') === 0 ? 'html_project_file' : keySource)).trim();
        const index = Number(option && typeof option.index !== 'undefined' ? option.index : Number(keyParts[keyParts.length - 1]) || 0);
        const activityIndex = Number(option && option.activity_index ? option.activity_index : source === 'activity' ? Number(keyParts[1]) || 0 : 0);
        const projectPath = source === 'html_project_file'
            ? this.cleanCodexProjectPath(option && (option.project_path || option.path || key.slice('html_project_file:'.length)))
            : source === 'project_file'
                ? this.cleanCodexAbsolutePath(option && (option.absolute_path || option.project_path || option.path || key.slice('project_file:'.length)))
            : String(option && option.project_path ? option.project_path : option && option.path ? option.path : '');
        const fallbackDetail = this.isCodexSharedFileSource(source) ? projectPath : '';
        return {
            key,
            source,
            index,
            activity_id: String(option && option.activity_id ? option.activity_id : ''),
            activity_index: activityIndex,
            name: String(option && option.name ? option.name : projectPath || key),
            source_label: String(option && option.source_label ? option.source_label : this.codexAttachmentSourceLabel(source, Math.max(activityIndex - 1, 0))),
            source_detail: String(option && option.source_detail ? option.source_detail : fallbackDetail),
            project_path: projectPath,
            path: projectPath || String(option && option.path ? option.path : ''),
            absolute_path: source === 'project_file' ? projectPath : String(option && option.absolute_path ? option.absolute_path : ''),
            relative_path: String(option && option.relative_path ? option.relative_path : ''),
            mime: String(option && option.mime ? option.mime : ''),
            size: Number(option && option.size ? option.size : 0),
            is_directory: !!(option && option.is_directory)
        };
    }

    public codexAttachmentButtonLabel() {
        const count = this.selectedCodexUploadAttachmentOptions().length;
        return count ? `첨부파일 ${count}` : '첨부파일';
    }

    public codexSharedFileButtonLabel() {
        const count = this.selectedCodexSharedFileOptions().length;
        return count ? `공용파일 ${count}` : '공용파일';
    }

    private closeCodexScreenshotPicker() {
        this.codexScreenshotPickerOpen = false;
    }

    private closeCodexLogCapturePicker() {
        this.codexLogCapturePickerOpen = false;
    }

    public codexAttachmentOptionClass(option: any) {
        const base = 'flex min-w-0 max-w-full flex-1 items-center gap-3 overflow-hidden px-3 py-2 text-left ';
        return this.isCodexAttachmentSelected(option)
            ? base + 'bg-slate-900 text-white'
            : base + 'bg-white text-slate-700 hover:bg-slate-50';
    }

    private closeCodexAttachmentPicker() {
        this.codexAttachmentPickerOpen = false;
    }

    private closeCodexSharedFilePicker() {
        this.codexSharedFilePickerOpen = false;
    }

    public async closeCodexPicker(event: any = null) {
        if (event && event.preventDefault) event.preventDefault();
        if (event && event.stopPropagation) event.stopPropagation();
        this.closeCodexScreenshotPicker();
        this.closeCodexLogCapturePicker();
        this.closeCodexAttachmentPicker();
        this.closeCodexSharedFilePicker();
        await this.service.render();
    }

    public async toggleCodexScreenshotPicker(event: any = null) {
        if (event && event.preventDefault) event.preventDefault();
        if (event && event.stopPropagation) event.stopPropagation();
        if (this.codexRunning || !this.selectedReview || !this.selectedReview.id) return;
        if (this.codexScreenshotPickerOpen) {
            this.closeCodexScreenshotPicker();
            await this.service.render();
            return;
        }
        this.closeCodexLogCapturePicker();
        this.closeCodexAttachmentPicker();
        this.closeCodexSharedFilePicker();
        this.codexScreenshotPickerOpen = true;
        await this.service.render();
        this.scrollCodexScreenshotPickerIntoView();
        if (!this.hasReviewScreenshot() && !this.reviewEvidenceAssetsLoaded() && !this.reviewEvidenceAssetLoading) {
            await this.loadReviewEvidenceAssets(false);
            this.ensureScreenshotPage();
            await this.service.render();
            this.scrollCodexScreenshotPickerIntoView();
        }
    }

    private scrollCodexScreenshotPickerIntoView() {
        this.scrollCodexPickerIntoView();
    }

    private scrollCodexPickerIntoView() {
        window.setTimeout(() => {
            if (this.destroyed || !this.codexPickerOpen()) return;
            const element = document.querySelector('.reviewops-codex-picker-panel') || document.getElementById('reviewops-codex-screenshot-picker');
            if (element && element.scrollIntoView) {
                element.scrollIntoView({ block: 'nearest' });
            }
        }, 0);
    }

    public async selectCodexScreenshot(index: number, event: any = null) {
        if (event && event.preventDefault) event.preventDefault();
        if (event && event.stopPropagation) event.stopPropagation();
        if (this.codexRunning || !this.hasReviewScreenshot()) return;
        const total = this.reviewScreenshotTotal(this.selectedReview);
        const page = Math.min(Math.max(Number(index) || 1, 1), total || 1);
        this.codexForm.include_screenshot = true;
        this.codexForm.screenshot_index = page;
        this.closeCodexScreenshotPicker();
        await this.service.render();
    }

    public async clearCodexScreenshotSelection(event: any = null) {
        if (event && event.preventDefault) event.preventDefault();
        if (event && event.stopPropagation) event.stopPropagation();
        if (this.codexRunning) return;
        this.codexForm.include_screenshot = false;
        this.codexForm.screenshot_index = 1;
        this.closeCodexScreenshotPicker();
        await this.service.render();
    }

    public async openCodexScreenshotPreview(screenshot: any, index: number = 0, event: any = null) {
        if (event && event.preventDefault) event.preventDefault();
        if (event && event.stopPropagation) event.stopPropagation();
        let selectedScreenshot = screenshot;
        let dataUrl = this.timelineScreenshotDataUrlValue(selectedScreenshot);
        if (!dataUrl && !this.reviewEvidenceAssetsLoaded()) {
            await this.loadReviewEvidenceAssets(false);
            selectedScreenshot = this.codexScreenshotOptions()[index] || screenshot;
            dataUrl = this.timelineScreenshotDataUrlValue(selectedScreenshot);
        }
        if (!dataUrl) {
            await this.service.modal.error('스크린샷 미리보기를 불러오지 못했습니다.');
            return;
        }
        const page = Number(index) + 1;
        this.screenshotPreviewUrl = dataUrl;
        this.screenshotPreviewIndex = page;
        this.screenshotPreviewTitle = `${this.codexScreenshotOptionLabel(selectedScreenshot, index)} · ${this.kstDateTime(selectedScreenshot && selectedScreenshot.created)}`;
        this.syncModalScrollLock();
        await this.service.render();
    }

    public async toggleCodexAttachmentPicker() {
        if (this.codexRunning || this.codexAttachmentOptions().length === 0) return;
        if (this.codexAttachmentPickerOpen) {
            this.closeCodexAttachmentPicker();
            await this.service.render();
            return;
        }
        this.closeCodexScreenshotPicker();
        this.closeCodexLogCapturePicker();
        this.closeCodexSharedFilePicker();
        this.codexAttachmentPickerOpen = true;
        await this.service.render();
        this.scrollCodexPickerIntoView();
    }

    public async onCodexAttachmentSearchChange() {
        await this.service.render();
    }

    public async toggleCodexAttachmentSelection(option: any, event: any = null) {
        if (event && event.preventDefault) event.preventDefault();
        if (event && event.stopPropagation) event.stopPropagation();
        const key = this.codexAttachmentRefKey(option);
        if (this.codexRunning || !option || !key) return;
        const refs = this.codexAttachmentRefs();
        if (this.isCodexAttachmentSelected(option)) {
            this.setCodexAttachmentRefs(refs.filter((ref: any) => this.codexAttachmentRefKey(ref) !== key));
        } else {
            this.setCodexAttachmentRefs(refs.concat([this.codexAttachmentReference(option)]));
        }
        this.closeCodexScreenshotPicker();
        this.closeCodexLogCapturePicker();
        this.closeCodexAttachmentPicker();
        await this.service.render();
    }

    public async removeCodexAttachmentSelection(option: any, event: any = null) {
        if (event && event.preventDefault) event.preventDefault();
        if (event && event.stopPropagation) event.stopPropagation();
        const key = this.codexAttachmentRefKey(option);
        if (!key || this.codexRunning) return;
        this.setCodexAttachmentRefs(this.codexAttachmentRefs().filter((ref: any) => this.codexAttachmentRefKey(ref) !== key));
        await this.service.render();
    }

    public pruneCodexAttachmentRefs() {
        const optionsByKey: any = {};
        this.codexAttachmentOptions().forEach((option: any) => {
            const key = this.codexAttachmentRefKey(option);
            if (key) optionsByKey[key] = option;
        });
        this.setCodexAttachmentRefs(this.codexAttachmentRefs().map((ref: any) => {
            const key = this.codexAttachmentRefKey(ref);
            if (!key) return null;
            return this.codexAttachmentReference(optionsByKey[key] || ref);
        }).filter((ref: any) => !!(ref && ref.key)));
    }

    public selectedCodexAttachmentReferences() {
        const optionsByKey: any = {};
        this.codexAttachmentOptions().forEach((option: any) => {
            const key = this.codexAttachmentRefKey(option);
            if (key) optionsByKey[key] = option;
        });
        return this.codexAttachmentRefs().map((ref: any) => {
            const key = this.codexAttachmentRefKey(ref);
            if (!key) return null;
            return this.codexAttachmentReference(optionsByKey[key] || ref);
        }).filter((ref: any) => !!(ref && ref.key));
    }

    public pruneCodexLogCaptureRefs() {
        this.setCodexLogCaptureRefs(this.codexLogCaptureRefs());
    }

    public showCaptureLogButton() {
        return !!(this.selectedReview && typeof this.captureLogs === 'function' && (this.selectedReview.can_change_status || this.selectedReview.can_edit));
    }

    public canCaptureReviewLogs() {
        return this.showCaptureLogButton() && !this.capturingLogCapture && !this.reviewDetailLoading && !this.reviewEvidenceLoading;
    }

    public latestLogCaptureId(review: any = this.selectedReview) {
        const captures = this.reviewLogCaptures(review);
        if (!captures.length) return '';
        return this.logCaptureId(captures[captures.length - 1], captures.length - 1);
    }

    public async captureReviewLogs(event: any = null, options: any = {}) {
        if (event && event.preventDefault) event.preventDefault();
        if (event && event.stopPropagation) event.stopPropagation();
        if (!this.canCaptureReviewLogs()) return;
        if (!(options && options.confirmed)) {
            const ok = await this.service.modal.show({
                title: '로그 저장',
                message: '현재 로그 정보를 저장할까요?',
                action: '저장',
                cancel: '취소',
                status: 'warning',
                actionBtn: 'success'
            });
            if (!ok || !this.canCaptureReviewLogs()) return;
        }
        this.capturingLogCapture = true;
        await this.service.render();
        try {
            const capture = await this.captureLogs(this.selectedReview);
            const { code, data } = await wiz.call('add_review_log_capture', this.requestParams({
                review_id: this.selectedReview.id,
                data: JSON.stringify(capture || {})
            }));
            if (code === 200 && data.review) {
                this.applyReview(data.review);
                this.reviewLogVersionId = this.latestLogCaptureId(this.selectedReview) || 'current';
                await this.service.modal.success('로그가 저장되었습니다.');
            } else {
                await this.service.modal.error(data.message || '로그를 저장하지 못했습니다.');
            }
        } catch (e) {
            await this.service.modal.error('로그를 저장하지 못했습니다.');
        }
        this.capturingLogCapture = false;
        await this.service.render();
    }

    public async toggleCodexLogCapturePicker() {
        if (this.codexLogCapturePickerDisabled()) return;
        if (this.codexLogCapturePickerOpen) {
            this.closeCodexLogCapturePicker();
            await this.service.render();
            return;
        }
        this.closeCodexScreenshotPicker();
        this.closeCodexAttachmentPicker();
        this.closeCodexSharedFilePicker();
        this.codexLogCapturePickerOpen = true;
        await this.service.render();
        this.scrollCodexPickerIntoView();
        if (!this.reviewEvidenceLoaded() && !this.reviewEvidenceLoading) {
            await this.loadReviewEvidence(false);
            this.pruneCodexLogCaptureRefs();
            await this.service.render();
            this.scrollCodexPickerIntoView();
        }
    }

    public async toggleCodexLogCaptureSelection(option: any, event: any = null) {
        if (event && event.preventDefault) event.preventDefault();
        if (event && event.stopPropagation) event.stopPropagation();
        const key = this.codexLogCaptureRefKey(option);
        if (this.codexRunning || !option || !key) return;
        const refs = this.codexLogCaptureRefs();
        if (this.isCodexLogCaptureSelected(option)) {
            this.setCodexLogCaptureRefs(refs.filter((ref: any) => this.codexLogCaptureRefKey(ref) !== key));
        } else {
            this.setCodexLogCaptureRefs(refs.concat([option]));
        }
        this.closeCodexLogCapturePicker();
        await this.service.render();
    }

    public async removeCodexLogCaptureSelection(option: any, event: any = null) {
        if (event && event.preventDefault) event.preventDefault();
        if (event && event.stopPropagation) event.stopPropagation();
        const key = this.codexLogCaptureRefKey(option);
        if (!key || this.codexRunning) return;
        this.setCodexLogCaptureRefs(this.codexLogCaptureRefs().filter((ref: any) => this.codexLogCaptureRefKey(ref) !== key));
        await this.service.render();
    }

    public codexSharedFileItems() {
        return (this.codexSharedFileBrowser && this.codexSharedFileBrowser.items) || [];
    }

    public codexSharedFileBreadcrumbs() {
        const breadcrumbs = (this.codexSharedFileBrowser && this.codexSharedFileBrowser.breadcrumbs && this.codexSharedFileBrowser.breadcrumbs.length)
            ? this.codexSharedFileBrowser.breadcrumbs
            : [{ label: 'root', path: '' }];
        return breadcrumbs.map((item: any, index: number) => index === 0 ? Object.assign({}, item, { label: '' }) : item);
    }

    public codexSharedFileParentPath() {
        const current = String(this.codexSharedFileBrowser && this.codexSharedFileBrowser.path || '').split('/').filter((part) => !!part);
        current.pop();
        return current.join('/');
    }

    public canOpenCodexSharedFileParent() {
        return !!String(this.codexSharedFileBrowser && this.codexSharedFileBrowser.path || '');
    }

    public async toggleCodexSharedFilePicker() {
        if (this.codexRunning || !this.canUseCodexSharedFiles()) return;
        if (this.codexSharedFilePickerOpen) {
            this.closeCodexSharedFilePicker();
            await this.service.render();
            return;
        }
        this.closeCodexScreenshotPicker();
        this.closeCodexLogCapturePicker();
        this.closeCodexAttachmentPicker();
        this.codexSharedFilePickerOpen = true;
        await this.service.render();
        this.scrollCodexPickerIntoView();
        await this.loadCodexSharedFiles(this.codexSharedFileBrowser.path || '');
    }

    public async loadCodexSharedFiles(path: any = '') {
        if (!this.canUseCodexSharedFiles()) return;
        this.codexSharedFileLoading = true;
        this.codexSharedFileError = '';
        this.codexSharedFileBrowser = Object.assign({}, this.codexSharedFileBrowser || {}, {
            path: String(path || ''),
            items: []
        });
        await this.service.render();
        const { code, data } = await wiz.call('load_codex_shared_files', this.requestParams({
            project_id: this.currentProjectId(),
            path: String(path || '')
        }));
        this.codexSharedFileLoading = false;
        if (code === 200) {
            this.codexSharedFileBrowser = data.browser || { path: '', root_label: 'root', breadcrumbs: [{ label: 'root', path: '' }], items: [] };
        } else {
            this.codexSharedFileError = (data && data.message) || '공용파일 목록을 불러오지 못했습니다.';
        }
        await this.service.render();
    }

    public async openCodexSharedFileItem(item: any, event: any = null) {
        if (!item) return;
        if (item.is_directory || item.type === 'directory') {
            await this.loadCodexSharedFiles(item.path || '');
            return;
        }
        await this.addCodexSharedFileContext(item, event);
    }

    public async addCurrentCodexProjectFileContext(event: any = null) {
        if (event && event.preventDefault) event.preventDefault();
        if (event && event.stopPropagation) event.stopPropagation();
        if (this.codexRunning) return;
        const ref = this.currentCodexProjectFileOption();
        if (!ref || !ref.key) return;
        const refs = this.codexAttachmentRefs();
        if (!refs.some((current: any) => this.codexAttachmentRefKey(current) === ref.key)) {
            this.setCodexAttachmentRefs(refs.concat([this.codexAttachmentReference(ref)]));
        }
        this.closeCodexScreenshotPicker();
        this.closeCodexAttachmentPicker();
        this.closeCodexSharedFilePicker();
        await this.service.render();
    }

    public codexSharedFileReference(item: any) {
        const itemSource = String(item && item.source ? item.source : '').trim();
        const source = itemSource || (this.reviewIsHtmlProject() ? 'html_project_file' : 'project_file');
        const rawPath = item && (item.absolute_path || item.project_path || item.path) ? (item.absolute_path || item.project_path || item.path) : '';
        const path = source === 'project_file'
            ? this.cleanCodexAbsolutePath(rawPath)
            : this.cleanCodexProjectPath(rawPath);
        const relativePath = String(item && item.relative_path ? item.relative_path : source === 'project_file' ? item && item.path ? item.path : '' : path).replace(/^\/+/, '');
        const key = source === 'project_file' ? this.codexProjectFileKey(path) : this.codexSharedFileKey(path);
        return {
            key,
            source,
            index: 0,
            name: String(item && item.name ? item.name : path || 'file'),
            source_label: '공용파일',
            source_detail: item && item.is_directory ? '폴더' : source === 'project_file' ? path : String(item && item.mime ? item.mime : 'file'),
            project_path: path,
            path,
            absolute_path: source === 'project_file' ? path : '',
            relative_path: this.cleanCodexProjectPath(relativePath),
            mime: item && item.is_directory ? 'inode/directory' : String(item && item.mime ? item.mime : 'application/octet-stream'),
            size: Number(item && item.size ? item.size : 0),
            is_directory: !!(item && item.is_directory)
        };
    }

    public async addCodexSharedFileContext(item: any, event: any = null) {
        if (event && event.preventDefault) event.preventDefault();
        if (event && event.stopPropagation) event.stopPropagation();
        if (!item || !this.canUseCodexSharedFiles() || this.codexRunning) return;
        const ref = this.codexSharedFileReference(item);
        if (!ref.key || !ref.project_path) return;
        const refs = this.codexAttachmentRefs();
        if (!refs.some((current: any) => this.codexAttachmentRefKey(current) === ref.key)) {
            this.setCodexAttachmentRefs(refs.concat([ref]));
        }
        this.closeCodexScreenshotPicker();
        this.closeCodexSharedFilePicker();
        await this.service.render();
    }

    public isCodexSharedFileSelected(item: any) {
        const key = this.codexAttachmentRefKey(this.codexSharedFileReference(item));
        return !!key && this.selectedCodexAttachmentKeys().includes(key);
    }

    public codexSharedFileRowClass(item: any) {
        const base = 'flex min-w-0 max-w-full flex-1 items-center gap-3 overflow-hidden px-3 py-2 text-left ';
        return this.isCodexSharedFileSelected(item)
            ? base + 'bg-slate-900 text-white'
            : base + 'bg-white text-slate-700 hover:bg-slate-50';
    }

    public codexAttachmentDownloadPath(option: any) {
        if (!option) return '';
        const source = String(option.source || '').trim();
        if (source === 'project_file') return this.cleanCodexAbsolutePath(option.absolute_path || option.project_path || option.path);
        if (source === 'html_project_file' || source === 'html_reference' || source === 'html_resource') {
            return this.cleanCodexProjectPath(option.project_path || option.path);
        }
        return '';
    }

    public canPreviewCodexAttachmentOption(option: any) {
        if (!option || option.is_directory) return false;
        const source = String(option.source || '').trim();
        const fileName = String(option.name || option.path || 'attachment');
        const mime = String(option.mime || this.dataUrlMime(option.data_url) || '');
        if (!this.codexPreviewType(fileName, mime)) return false;
        if (source === 'review' || source === 'activity') return true;
        return !!this.codexAttachmentDownloadPath(option);
    }

    public async openCodexAttachmentPreview(option: any, event: any = null) {
        if (event && event.preventDefault) event.preventDefault();
        if (event && event.stopPropagation) event.stopPropagation();
        if (!this.canPreviewCodexAttachmentOption(option)) return;
        const source = String(option.source || '').trim();
        if (source === 'review' || source === 'activity') {
            const activityRef = source === 'activity' ? { id: option.activity_id || '' } : null;
            const loaded = await this.loadAttachmentData(option, source, Number(option.index) || 0, activityRef, Math.max(Number(option.activity_index || 1) - 1, 0));
            const dataUrl = String(loaded && loaded.data_url || '');
            if (!dataUrl) {
                await this.service.modal.error('파일 미리보기를 불러오지 못했습니다.');
                return;
            }
            await this.openDataUrlFilePreview(dataUrl, loaded.name || option.name || '첨부 파일', loaded.mime || this.dataUrlMime(dataUrl));
            return;
        }
        const downloadUrl = this.codexMarkdownFileDownloadUrl(this.codexAttachmentDownloadPath(option));
        if (!downloadUrl) return;
        await this.openCodexFilePreview(downloadUrl);
    }

    public codexSharedFileDownloadPath(item: any) {
        const ref = this.codexSharedFileReference(item);
        if (ref.source === 'project_file') return ref.absolute_path || ref.project_path || ref.path;
        return ref.project_path || ref.path;
    }

    public canPreviewCodexSharedFile(item: any) {
        if (!item || item.is_directory || item.type === 'directory') return false;
        const path = this.codexSharedFileDownloadPath(item);
        const fileName = String(item.name || path || 'file');
        return !!(path && this.codexPreviewType(fileName, item.mime || ''));
    }

    public async openCodexSharedFilePreview(item: any, event: any = null) {
        if (event && event.preventDefault) event.preventDefault();
        if (event && event.stopPropagation) event.stopPropagation();
        if (!this.canPreviewCodexSharedFile(item)) return;
        const downloadUrl = this.codexMarkdownFileDownloadUrl(this.codexSharedFileDownloadPath(item));
        if (!downloadUrl) return;
        await this.openCodexFilePreview(downloadUrl);
    }

    public attachmentTotalSize(attachments: any[]) {
        return (attachments || []).reduce((sum, attachment) => sum + (Number(attachment && attachment.size) || this.dataUrlBytes(attachment && attachment.data_url)), 0);
    }

    public activityAttachmentTotalSize() { return this.attachmentTotalSize(this.activityAttachments()); }
    public activityEditAttachmentTotalSize() { return this.attachmentTotalSize(this.activityEditAttachments()); }
    public selectedReviewAttachmentTotalSize() { return this.attachmentTotalSize(this.selectedReviewAttachments()); }

    public attachmentSizeLabel(attachment: any) {
        return this.networkSizeLabel(Number(attachment && attachment.size) || this.dataUrlBytes(attachment && attachment.data_url));
    }

    public canAddActivityAttachments() { return this.activityAttachments().length < this.activityAttachmentLimits.files; }
    public canAddActivityEditAttachments() { return this.activityEditAttachments().length < this.activityAttachmentLimits.files; }
    public canAddSelectedReviewAttachments() { return this.selectedReviewAttachments().length < this.reviewAttachmentLimits.files; }

    public activityUploadDisabled() {
        return this.sendingActivity || this.activityAttachmentBusy || !this.canAddActivityAttachments();
    }

    public activityEditUploadDisabled() {
        return this.savingActivityEdit || this.activityEditAttachmentBusy || !this.canAddActivityEditAttachments();
    }

    public uploadButtonClass(disabled: boolean, compact: boolean = false) {
        const size = compact ? 'h-8 gap-1.5 px-2 text-[11px]' : 'h-9 gap-2 px-3 text-[12px]';
        const base = `inline-flex ${size} shrink-0 items-center rounded-md border font-semibold `;
        return disabled ? base + 'cursor-not-allowed border-slate-200 bg-slate-100 text-slate-400' : base + 'cursor-pointer border-slate-300 bg-white text-slate-700 hover:bg-slate-50';
    }

    public hasUploadFiles(event: any) {
        const transfer = event && event.dataTransfer ? event.dataTransfer : null;
        if (!transfer) return false;
        if (transfer.files && transfer.files.length) return true;
        const types = transfer.types ? Array.prototype.slice.call(transfer.types) : [];
        if (types.indexOf('Files') >= 0) return true;
        const items = transfer.items ? Array.prototype.slice.call(transfer.items) : [];
        return items.some((item: any) => item && item.kind === 'file');
    }

    public uploadEventFiles(event: any): File[] {
        const transfer = event && event.dataTransfer ? event.dataTransfer : null;
        if (transfer && !this.hasUploadFiles(event)) return [];
        if (transfer) {
            event.preventDefault();
            event.stopPropagation();
        }
        const input = event && event.target ? event.target : null;
        const source = transfer && transfer.files && transfer.files.length ? transfer.files : input && input.files ? input.files : [];
        const files = Array.prototype.slice.call(source || []).filter((file: File) => !!file && !String((file as any).type || '').startsWith('inode/'));
        if (input && input.value !== undefined) input.value = '';
        this.clearUploadDropTarget();
        return files;
    }

    public attachmentDropClass(key: string, base: string, disabled: boolean = false) {
        if (disabled) return `${base} cursor-not-allowed opacity-60`;
        if (this.uploadDropTarget !== key) return base;
        return `${base} border-slate-900 bg-white ring-2 ring-inset ring-slate-900`;
    }

    public async onUploadDragOver(event: any, key: string, disabled: boolean = false) {
        if (!this.hasUploadFiles(event)) return;
        event.preventDefault();
        event.stopPropagation();
        if (disabled) {
            if (event.dataTransfer) event.dataTransfer.dropEffect = 'none';
            if (this.uploadDropTarget === key) {
                this.uploadDropTarget = '';
                await this.service.render();
            }
            return;
        }
        if (event.dataTransfer) event.dataTransfer.dropEffect = 'copy';
        if (this.uploadDropTarget !== key) {
            this.uploadDropTarget = key;
            await this.service.render();
        }
    }

    public async onUploadDragLeave(event: any, key: string) {
        const current = event && event.currentTarget ? event.currentTarget : null;
        const related = event && event.relatedTarget ? event.relatedTarget : null;
        if (current && related && current.contains && current.contains(related)) return;
        if (current && current.getBoundingClientRect) {
            const rect = current.getBoundingClientRect();
            const clientX = Number(event && event.clientX);
            const clientY = Number(event && event.clientY);
            const inside = Number.isFinite(clientX) && Number.isFinite(clientY)
                && clientX >= rect.left && clientX <= rect.right
                && clientY >= rect.top && clientY <= rect.bottom;
            if (inside) return;
        }
        if (this.uploadDropTarget === key) {
            this.uploadDropTarget = '';
            await this.service.render();
        }
    }

    public clearUploadDropTarget(key: string = '') {
        if (!key || this.uploadDropTarget === key) this.uploadDropTarget = '';
    }

    public activityUploadButtonClass() {
        return this.uploadButtonClass(this.activityUploadDisabled(), true);
    }

    public activityEditUploadButtonClass() {
        return this.uploadButtonClass(this.activityEditUploadDisabled());
    }

    public selectedReviewUploadButtonClass() {
        const disabled = this.selectedReviewAttachmentBusy || !this.selectedReview || !this.selectedReview.can_edit || !this.canAddSelectedReviewAttachments();
        return this.uploadButtonClass(disabled);
    }

    public uploadProgressState(key: string) {
        return (this.uploadProgress && this.uploadProgress[key]) || {};
    }

    public uploadProgressVisible(key: string) {
        return !!this.uploadProgressState(key).visible;
    }

    public startUploadProgress(key: string, title: string, files: File[], phase: string = 'reading') {
        const list = files || [];
        const totalBytes = list.reduce((sum, file) => sum + Number(file && file.size || 0), 0);
        this.uploadProgress = Object.assign({}, this.uploadProgress || {}, {
            [key]: {
                visible: true,
                title,
                phase,
                status: 'running',
                totalFiles: list.length,
                completedFiles: 0,
                currentIndex: 0,
                currentFileName: '',
                currentPercent: 0,
                totalBytes,
                processedBytes: 0,
                currentLoaded: 0,
                currentTotal: 0,
                message: '',
                renderedAt: 0
            }
        });
    }

    public async updateUploadProgress(key: string, partial: any = {}, forceRender: boolean = false) {
        const current = this.uploadProgressState(key);
        this.uploadProgress = Object.assign({}, this.uploadProgress || {}, {
            [key]: Object.assign({}, current, partial || {}, { visible: true })
        });
        const state = this.uploadProgressState(key);
        const now = Date.now();
        if (forceRender || now - Number(state.renderedAt || 0) > 120) {
            state.renderedAt = now;
            this.uploadProgress = Object.assign({}, this.uploadProgress || {}, { [key]: state });
            await this.service.render();
        }
    }

    public finishUploadProgress(key: string, success: boolean = true, message: string = '') {
        const current = this.uploadProgressState(key);
        const totalFiles = Number(current.totalFiles || 0);
        const totalBytes = Number(current.totalBytes || 0);
        this.uploadProgress = Object.assign({}, this.uploadProgress || {}, {
            [key]: Object.assign({}, current, {
                visible: true,
                status: success ? 'done' : 'error',
                phase: success ? 'done' : 'error',
                completedFiles: success ? totalFiles : Number(current.completedFiles || 0),
                currentPercent: success ? 100 : Number(current.currentPercent || 0),
                processedBytes: success ? totalBytes : Number(current.processedBytes || 0),
                message: message || (success ? '완료되었습니다.' : '처리하지 못했습니다.')
            })
        });
        if (success) {
            window.setTimeout(async () => {
                const latest = this.uploadProgressState(key);
                if (latest.status === 'done') {
                    this.uploadProgress = Object.assign({}, this.uploadProgress || {}, {
                        [key]: Object.assign({}, latest, { visible: false })
                    });
                    await this.service.render();
                }
            }, 1400);
        }
    }

    public uploadProgressTitle(key: string) {
        const state = this.uploadProgressState(key);
        if (state.status === 'done') return '완료';
        if (state.status === 'error') return '오류';
        if (state.phase === 'saving') return `${state.title || '파일'} 저장 중`;
        return `${state.title || '파일'} 읽는 중`;
    }

    public uploadProgressPercent(key: string) {
        const state = this.uploadProgressState(key);
        const totalBytes = Number(state.totalBytes || 0);
        if (totalBytes > 0) {
            return Math.max(0, Math.min(100, Math.round(Number(state.processedBytes || 0) / totalBytes * 100)));
        }
        const totalFiles = Number(state.totalFiles || 0);
        if (totalFiles > 0) {
            return Math.max(0, Math.min(100, Math.round(Number(state.completedFiles || 0) / totalFiles * 100)));
        }
        return Math.max(0, Math.min(100, Math.round(Number(state.currentPercent || 0))));
    }

    public uploadProgressMeta(key: string) {
        const state = this.uploadProgressState(key);
        const count = `${Number(state.completedFiles || 0)}/${Number(state.totalFiles || 0)}`;
        const size = Number(state.totalBytes || 0) > 0
            ? `${this.networkSizeLabel(state.processedBytes || 0)} / ${this.networkSizeLabel(state.totalBytes || 0)}`
            : '';
        return size ? `${count} · ${size}` : count;
    }

    public uploadProgressCurrentFile(key: string) {
        const state = this.uploadProgressState(key);
        return state.currentFileName || state.message || '-';
    }

    public isImageAttachment(attachment: any) {
        const mime = String(attachment && attachment.mime ? attachment.mime : '').toLowerCase();
        const dataUrl = String(attachment && attachment.data_url ? attachment.data_url : '');
        return ['image/png', 'image/jpeg', 'image/gif', 'image/webp', 'image/svg+xml', 'image/bmp'].includes(mime) && /^data:image\/(png|jpeg|jpg|gif|webp|svg\+xml|bmp);base64,/i.test(dataUrl);
    }

    public isPreviewableAttachment(attachment: any) {
        const name = String(attachment && attachment.name ? attachment.name : 'attachment');
        const mime = String(attachment && attachment.mime ? attachment.mime : this.dataUrlMime(attachment && attachment.data_url)).toLowerCase();
        return !!this.codexPreviewType(name, mime);
    }

    public isPreviewableImageAttachment(attachment: any) {
        return this.isPreviewableAttachment(attachment);
    }

    public attachmentTypeLabel(attachment: any) {
        const mime = String(attachment && attachment.mime ? attachment.mime : '').toLowerCase();
        if (!mime) return 'file';
        if (mime.indexOf('image/') === 0) return '이미지';
        if (mime === 'application/pdf') return 'PDF';
        if (mime.indexOf('text/') === 0) return '텍스트';
        if (mime.indexOf('zip') >= 0 || mime.indexOf('compressed') >= 0) return '압축';
        const subtype = mime.split('/').pop() || mime;
        return subtype.toUpperCase();
    }

    public safeAttachmentName(name: any) {
        const value = String(name || 'attachment').replace(/[\\/:*?"<>|]+/g, '-').replace(/\s+/g, ' ').trim().slice(0, 160);
        return value || 'attachment';
    }

    public readFileAsDataUrl(file: File, progress: any = null): Promise<string> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(String(reader.result || ''));
            reader.onerror = () => reject(reader.error || new Error('file-read-failed'));
            reader.onprogress = async (event: any) => {
                if (progress && event && event.lengthComputable) {
                    await progress(Number(event.loaded || 0), Number(event.total || file.size || 0));
                }
            };
            reader.readAsDataURL(file);
        });
    }

    public async fileToAttachment(file: File, progress: any = null) {
        const dataUrl = await this.readFileAsDataUrl(file, progress);
        const mime = file.type || this.dataUrlMime(dataUrl) || 'application/octet-stream';
        return {
            name: this.safeAttachmentName(file.name),
            mime,
            size: file.size || this.dataUrlBytes(dataUrl),
            kind: this.isImageAttachment({ mime, data_url: dataUrl }) ? 'image' : 'file',
            data_url: dataUrl
        };
    }

    public attachmentValidationMessage(files: File[], current: any[], limits: any) {
        if (!files || !files.length) return '';
        if ((current || []).length + files.length > limits.files) return `첨부는 최대 ${limits.files}개까지 가능합니다.`;
        const currentSize = this.attachmentTotalSize(current || []);
        const nextSize = files.reduce((sum, file) => sum + (file.size || 0), 0);
        for (const file of files) {
            if ((file.size || 0) > limits.fileBytes) return `파일당 최대 ${this.networkSizeLabel(limits.fileBytes)}까지 첨부할 수 있습니다.`;
        }
        if (limits.totalBytes && currentSize + nextSize > limits.totalBytes) return `첨부 총 용량은 최대 ${this.networkSizeLabel(limits.totalBytes)}까지 가능합니다.`;
        const policyKey = limits === this.reviewAttachmentLimits ? 'review_attachment' : 'activity_attachment';
        const formatMessage = this.uploadPolicyFormatMessage(policyKey, files);
        if (formatMessage) return formatMessage;
        return '';
    }

    public async filesToAttachments(files: File[], progressKey: string = '', title: string = '첨부 파일') {
        const attachments = [];
        let processedBefore = 0;
        if (progressKey) this.startUploadProgress(progressKey, title, files || [], 'reading');
        for (let index = 0; index < (files || []).length; index++) {
            const file = files[index];
            if (progressKey) {
                await this.updateUploadProgress(progressKey, {
                    phase: 'reading',
                    currentIndex: index + 1,
                    currentFileName: file.name || 'file',
                    currentPercent: 0,
                    currentLoaded: 0,
                    currentTotal: file.size || 0,
                    processedBytes: processedBefore
                }, true);
            }
            attachments.push(await this.fileToAttachment(file, async (loaded: number, total: number) => {
                if (!progressKey) return;
                await this.updateUploadProgress(progressKey, {
                    currentPercent: total ? Math.round(loaded / total * 10000) / 100 : 0,
                    currentLoaded: loaded,
                    currentTotal: total || file.size || 0,
                    processedBytes: processedBefore + loaded
                });
            }));
            processedBefore += Number(file.size || 0);
            if (progressKey) {
                await this.updateUploadProgress(progressKey, {
                    completedFiles: index + 1,
                    currentPercent: 100,
                    currentLoaded: file.size || 0,
                    currentTotal: file.size || 0,
                    processedBytes: processedBefore
                }, true);
            }
        }
        if (progressKey) this.finishUploadProgress(progressKey, true, '파일 준비가 완료되었습니다.');
        return attachments;
    }

    public async selectActivityFiles(event: any) {
        const files = this.uploadEventFiles(event);
        if (this.activityUploadDisabled()) return;
        if (!files.length) return;
        const message = this.attachmentValidationMessage(files, this.activityAttachments(), this.activityAttachmentLimits);
        if (message) await this.service.modal.error(message);
        else {
            this.activityAttachmentBusy = true;
            await this.service.render();
            try {
                this.activityForm.attachments = this.activityAttachments().concat(await this.filesToAttachments(files, 'activity-attachments', '작업이력 첨부'));
            } catch (e) {
                this.finishUploadProgress('activity-attachments', false, '첨부 파일을 읽지 못했습니다.');
                await this.service.modal.error('첨부 파일을 읽지 못했습니다.');
            }
            this.activityAttachmentBusy = false;
            await this.service.render();
        }
    }

    public async removeActivityAttachment(index: number) {
        this.activityForm.attachments = this.activityAttachments().filter((_: any, itemIndex: number) => itemIndex !== index);
        await this.service.render();
    }

    public async selectActivityEditFiles(event: any) {
        const files = this.uploadEventFiles(event);
        if (this.activityEditUploadDisabled()) return;
        if (!files.length) return;
        const message = this.attachmentValidationMessage(files, this.activityEditAttachments(), this.activityAttachmentLimits);
        if (message) await this.service.modal.error(message);
        else {
            this.activityEditAttachmentBusy = true;
            await this.service.render();
            try {
                this.activityEditForm.attachments = this.activityEditAttachments().concat(await this.filesToAttachments(files, 'activity-edit-attachments', '작업이력 첨부'));
            } catch (e) {
                this.finishUploadProgress('activity-edit-attachments', false, '첨부 파일을 읽지 못했습니다.');
                await this.service.modal.error('첨부 파일을 읽지 못했습니다.');
            }
            this.activityEditAttachmentBusy = false;
            await this.service.render();
        }
    }

    public async removeActivityEditAttachment(index: number) {
        this.activityEditForm.attachments = this.activityEditAttachments().filter((_: any, itemIndex: number) => itemIndex !== index);
        await this.service.render();
    }

    public async selectSelectedReviewFiles(event: any) {
        const files = this.uploadEventFiles(event);
        if (this.selectedReviewAttachmentBusy || !this.selectedReview || !this.selectedReview.can_edit || !this.canAddSelectedReviewAttachments()) return;
        if (!files.length) return;
        const message = this.attachmentValidationMessage(files, this.selectedReviewAttachments(), this.reviewAttachmentLimits);
        if (message) await this.service.modal.error(message);
        else {
            this.selectedReviewAttachmentBusy = true;
            await this.service.render();
            try {
                const attachments = await this.filesToAttachments(files, 'selected-review-attachments', '리뷰 첨부');
                await this.updateUploadProgress('selected-review-attachments', {
                    status: 'running',
                    phase: 'saving',
                    message: '첨부 정보를 저장하는 중입니다.'
                }, true);
                await this.saveSelectedReviewAttachments(this.selectedReviewAttachments().concat(attachments), false);
            } catch (e) {
                this.finishUploadProgress('selected-review-attachments', false, '첨부 파일을 저장하지 못했습니다.');
                await this.service.modal.error('첨부 파일을 읽지 못했습니다.');
            }
            this.selectedReviewAttachmentBusy = false;
            await this.service.render();
        }
    }

    public async removeSelectedReviewAttachment(index: number) {
        await this.saveSelectedReviewAttachments(this.selectedReviewAttachments().filter((_: any, itemIndex: number) => itemIndex !== index));
    }

    public async saveSelectedReviewAttachments(attachments: any[], manageBusy: boolean = true) {
        if (!this.selectedReview || !this.selectedReview.can_edit) return;
        if (manageBusy) {
            this.selectedReviewAttachmentBusy = true;
            await this.service.render();
        }
        const { code, data } = await wiz.call('update_review', this.requestParams({
            review_id: this.selectedReview.id,
            data: JSON.stringify({ attachments })
        }));
        if (manageBusy) this.selectedReviewAttachmentBusy = false;
        const hasUploadProgress = this.uploadProgressVisible('selected-review-attachments');
        if (code === 200) {
            this.applyReview(data.review);
            if (hasUploadProgress) this.finishUploadProgress('selected-review-attachments', true, '첨부 파일이 저장되었습니다.');
        } else {
            if (hasUploadProgress) this.finishUploadProgress('selected-review-attachments', false, data.message || '첨부 파일을 저장하지 못했습니다.');
            await this.service.modal.error(data.message || '첨부 파일을 저장하지 못했습니다.');
        }
        await this.service.render();
    }

    public resetCodexState() {
        this.codexPollRequestSeq++;
        this.codexPollLoading = false;
        this.codexPollErrorCount = 0;
        this.codexLastLogPollAt = 0;
        this.clearCodexPoll();
        this.clearCodexClock();
        this.codexLoadedReviewId = '';
        this.codexDetailLoading = false;
        this.codexComposerExpanded = false;
        this.codexForm = { message: '', include_screenshot: false, screenshot_index: 1, include_agent_instruction: false, attachments: [], log_capture_ids: [] };
        this.resetCodexContextViewer();
        this.closeCodexScreenshotPicker();
        this.closeCodexLogCapturePicker();
        this.closeCodexAttachmentPicker();
        this.closeCodexSharedFilePicker();
        this.codexAttachmentSearch = '';
        this.codexSharedFileError = '';
        this.codexSharedFileLoading = false;
        this.codexSharedFileBrowser = { path: '', root_label: 'root', breadcrumbs: [{ label: 'root', path: '' }], items: [] };
        this.codexMessages = [];
        this.expandedCodexMessageProgress = {};
        this.codexRunning = false;
        this.codexJobId = '';
        this.codexJobStatus = '';
        this.codexJobMessage = '';
        this.codexJobStarted = 0;
        this.codexElapsedSeconds = 0;
        this.codexProgressLog = '';
        this.stoppingCodexJob = false;
        this.checkingCodexSession = false;
        this.codexIndependentExecution = false;
    }

    public reviewCodexHistory(review: any = this.selectedReview) {
        const history = review && Array.isArray(review.codex_history) ? review.codex_history : [];
        return this.dedupeCodexMessages(history);
    }

    private codexMessageIdentity(message: any, index: number = 0) {
        if (!message || typeof message !== 'object') return `empty:${index}`;
        const role = message.role === 'user' ? 'user' : 'assistant';
        const jobId = String(message.job_id || '').trim();
        if (jobId) return `${role}:job:${jobId}`;
        const key = String(message.key || message.history_key || '').trim();
        if (key) return `key:${key}`;
        const id = String(message.id || message.message_id || '').trim();
        if (id) return `id:${id}`;
        const content = String(message.content || '').trim().replace(/\s+/g, ' ').slice(0, 1000);
        const created = String(message.created || '').trim().slice(0, 19);
        return `${role}:${message.error ? '1' : '0'}:${created}:${content}`;
    }

    private mergeCodexMessage(existing: any, incoming: any) {
        const current = existing && typeof existing === 'object' ? existing : {};
        const next = incoming && typeof incoming === 'object' ? incoming : {};
        const currentError = !!current.error;
        const nextError = !!next.error;
        const currentContent = String(current.content || '');
        const nextContent = String(next.content || '');
        const preferIncoming = (currentError && !nextError) || (
            currentError === nextError &&
            nextContent.length > currentContent.length &&
            currentContent.trim() !== nextContent.trim()
        );
        const merged = preferIncoming ? Object.assign({}, current, next) : Object.assign({}, next, current);
        const currentContext = current.context && typeof current.context === 'object' && !Array.isArray(current.context) ? current.context : {};
        const nextContext = next.context && typeof next.context === 'object' && !Array.isArray(next.context) ? next.context : {};
        if (Object.keys(currentContext).length || Object.keys(nextContext).length) {
            merged.context = Object.assign({}, currentContext, nextContext);
        }
        return merged;
    }

    public dedupeCodexMessages(messages: any[]) {
        const source = Array.isArray(messages) ? messages : [];
        const result: any[] = [];
        const indexes: any = {};
        source.forEach((message: any, index: number) => {
            const item = Object.assign({}, message || {});
            const identity = this.codexMessageIdentity(item, index);
            if (typeof indexes[identity] === 'number') {
                const cursor = indexes[identity];
                result[cursor] = this.mergeCodexMessage(result[cursor], item);
                return;
            }
            indexes[identity] = result.length;
            result.push(item);
        });
        return result;
    }

    private syncSelectedReviewCodexHistory() {
        this.codexMessages = this.dedupeCodexMessages(this.codexMessages);
        if (this.selectedReview) {
            this.selectedReview.codex_history = this.codexMessages.map((item: any) => Object.assign({}, item));
        }
    }

    private appendCodexMessage(message: any) {
        this.codexMessages.push(Object.assign({}, message || {}));
        this.syncSelectedReviewCodexHistory();
    }

    public syncCodexStateFromReview() {
        this.clearCodexPoll();
        this.codexMessages = this.reviewCodexHistory(this.selectedReview);
        const status = this.selectedReview && ['queued', 'running'].includes(this.selectedReview.codex_job_status) ? this.selectedReview.codex_job_status : '';
        this.codexJobId = this.selectedReview && this.selectedReview.codex_job_id ? this.selectedReview.codex_job_id : '';
        this.codexJobStarted = this.selectedReview && this.selectedReview.codex_job_started ? this.selectedReview.codex_job_started : 0;
        this.syncCodexElapsedFromJob({ started: this.codexJobStarted });
        this.codexJobStatus = status;
        this.codexJobMessage = this.selectedReview && this.selectedReview.codex_job_message ? this.selectedReview.codex_job_message : '';
        this.codexRunning = !!status;
        if (this.codexRunning && this.codexJobId) {
            this.ensureCodexClock();
            this.scheduleCodexPoll();
        }
    }

    public clearCodexPoll() {
        if (this.codexPollTimer) {
            window.clearTimeout(this.codexPollTimer);
            this.codexPollTimer = null;
        }
    }

    public codexContextOptionClass(enabled: boolean, disabled: boolean = false) {
        const base = 'inline-flex h-7 shrink-0 items-center gap-1.5 rounded-md border px-2 text-[11px] font-semibold transition-colors ';
        if (disabled) return base + 'cursor-not-allowed border-slate-600 bg-slate-700 text-slate-400';
        return enabled ? base + 'border-sky-300 bg-sky-100 text-sky-950' : base + 'border-slate-300 bg-white text-slate-700 hover:bg-slate-50 hover:text-slate-950';
    }

    public async toggleCodexContext(key: string) {
        if (this.codexRunning) return;
        if (key === 'include_screenshot' && !this.hasReviewScreenshot()) return;
        this.codexForm[key] = !this.codexForm[key];
        if (key === 'include_screenshot' && this.codexForm.include_screenshot) {
            this.codexForm.screenshot_index = this.selectedCodexScreenshotIndex(this.selectedReview) || this.currentScreenshotNumber(this.selectedReview);
        }
        await this.service.render();
    }

    private defaultCodexModelOptionRows() {
        return reviewOpsCodexBuiltinModelOptionRows();
    }

    private applyCodexModelOptions(value: any) {
        const allowedEfforts = REVIEWOPS_CODEX_ALLOWED_REASONING_EFFORTS;
        const defaultRows = this.defaultCodexModelOptionRows();
        const defaultOrder: any = {};
        const defaultByValue: any = {};
        const rowsByValue: any = {};
        defaultRows.forEach((item: any, index: number) => {
            defaultOrder[item.value] = index;
            defaultByValue[item.value] = item;
            rowsByValue[item.value] = item;
        });
        const sourceRows = Array.isArray(value) ? value : [];
        const customRows: any[] = [];
        const customSeen: any = {};
        const cleanTokens = (input: any) => {
            const tokens = Number(input);
            return Number.isFinite(tokens) && tokens > 0 ? Math.floor(tokens) : 0;
        };
        sourceRows.forEach((item: any) => {
            const option = item && typeof item === 'object' ? item : {};
            const configId = String(option.value || '').trim().toLowerCase();
            const defaultDefinition = defaultByValue[configId] || null;
            const rawProvider = String(option.provider || '').trim().toLowerCase();
            const provider = defaultDefinition ? 'openai' : (rawProvider || (configId.startsWith('custom:') ? 'custom' : 'openai'));
            const model = String(defaultDefinition ? defaultDefinition.model : (option.model || configId)).trim();
            if (!configId || !/^[a-z0-9:._-]{1,100}$/.test(configId) || !['openai', 'custom'].includes(provider)) return;
            if (defaultDefinition) {
                rowsByValue[configId] = Object.assign({}, defaultDefinition, {
                    context_window: cleanTokens(option.context_window),
                    auto_compact_token_limit: cleanTokens(option.auto_compact_token_limit),
                    runtime_key: option.runtime_key || defaultDefinition.runtime_key
                });
                return;
            }
            if (provider !== 'custom' || !configId.startsWith('custom:') || customSeen[configId]) return;
            if (!model || model.length > 200) return;
            customSeen[configId] = true;
            const defaultReasoning = ['low', 'medium', 'high'];
            const reasoningSource = Array.isArray(option.reasoning) ? option.reasoning : defaultReasoning;
            const reasoning = reasoningSource
                .map((entry: any) => String(entry || '').trim().toLowerCase())
                .filter((entry: string, index: number, rows: string[]) => allowedEfforts.includes(entry) && rows.indexOf(entry) === index);
            customRows.push({
                value: configId,
                provider,
                model,
                label: String(option.label || model).trim().slice(0, 100),
                reasoning: reasoning.length ? reasoning : defaultReasoning,
                context_window: cleanTokens(option.context_window),
                auto_compact_token_limit: cleanTokens(option.auto_compact_token_limit),
                runtime_key: String(option.runtime_key || '').trim().slice(0, 120)
            });
        });
        const options = defaultRows.map((item: any) => rowsByValue[item.value] || item).concat(customRows);
        options.sort((left: any, right: any) => {
            const leftOrder = Object.prototype.hasOwnProperty.call(defaultOrder, left.value) ? defaultOrder[left.value] : 100000;
            const rightOrder = Object.prototype.hasOwnProperty.call(defaultOrder, right.value) ? defaultOrder[right.value] : 100000;
            return leftOrder === rightOrder ? 0 : leftOrder - rightOrder;
        });
        const reasoningMap: any = {};
        options.forEach((option: any) => {
            reasoningMap[option.value] = reviewOpsCodexReasoningSelectOptions(option.reasoning || []);
        });
        this.codexModelOptions = options;
        this.codexReasoningOptionMap = reasoningMap;
        this.codexModel = this.normalizeCodexModel(this.codexModel, this.codexDefaultModel);
        this.codexReasoningEffort = this.normalizeCodexReasoningEffort(
            this.codexReasoningEffort,
            this.codexModel,
            this.codexDefaultReasoningEffortForModel(this.codexModel)
        );
        this.loadCodexRuntimePreference();
    }

    public normalizeCodexModel(value: any, fallback: string = this.codexDefaultModel) {
        const text = String(value || '').trim().toLowerCase();
        const aliases: any = reviewOpsCodexModelAliases();
        const migratedText = text.startsWith('ollama:') ? `custom:${text.slice('ollama:'.length)}` : text;
        const model = aliases[migratedText] || migratedText;
        if (this.codexModelOptions.some((option: any) => option.value === model)) return model;
        const fallbackText = String(fallback || '').trim().toLowerCase();
        const fallbackModel = aliases[fallbackText] || fallbackText;
        if (this.codexModelOptions.some((option: any) => option.value === fallbackModel)) return fallbackModel;
        return fallback ? this.codexDefaultModel : '';
    }

    public codexReasoningOptions(model: any = this.codexModel) {
        const normalizedModel = this.normalizeCodexModel(model, this.codexDefaultModel);
        return this.codexReasoningOptionMap[normalizedModel] || this.codexReasoningOptionMap[this.codexDefaultModel] || [];
    }

    public codexDefaultReasoningEffortForModel(model: any = this.codexModel) {
        const normalizedModel = this.normalizeCodexModel(model, this.codexDefaultModel);
        const options = this.codexReasoningOptions(normalizedModel);
        const preferred = this.codexDefaultReasoningEffort;
        if (options.some((option: any) => option.value === preferred)) return preferred;
        return options.length ? options[0].value : '';
    }

    public codexOneTimeReasoningSelected(value: any = this.codexReasoningEffort) {
        const effort = String(value || '').trim().toLowerCase();
        return effort === 'max' || effort === 'ultra';
    }

    public normalizeCodexReasoningEffort(value: any, model: any = this.codexModel, fallback?: any) {
        const normalizedModel = this.normalizeCodexModel(model, this.codexDefaultModel);
        const options = this.codexReasoningOptions(normalizedModel);
        const normalize = (source: any) => {
            const text = String(source || '').trim().toLowerCase().replace(/[_-]+/g, ' ');
            const aliases: any = {
                'extra high': 'xhigh',
                'x high': 'xhigh',
                'xhigh': 'xhigh',
                'low': 'low',
                'medium': 'medium',
                'high': 'high',
                'max': 'max',
                'ultra': 'ultra'
            };
            return aliases[text] || text.replace(/\s+/g, '');
        };
        const effort = normalize(value);
        if (options.some((option: any) => option.value === effort)) return effort;
        const fallbackEffort = normalize(typeof fallback === 'undefined' ? this.codexDefaultReasoningEffortForModel(normalizedModel) : fallback);
        if (options.some((option: any) => option.value === fallbackEffort)) return fallbackEffort;
        return '';
    }

    public codexModelLabel(model: any = this.codexModel) {
        const normalizedModel = this.normalizeCodexModel(model, '');
        const option = this.codexModelOptions.find((item: any) => item.value === normalizedModel);
        return option ? option.label : normalizedModel;
    }

    public codexReasoningEffortLabel(effort: any = this.codexReasoningEffort, model: any = this.codexModel) {
        const normalizedEffort = this.normalizeCodexReasoningEffort(effort, model, '');
        const option = this.codexReasoningOptions(model).find((item: any) => item.value === normalizedEffort);
        return option ? option.label : normalizedEffort;
    }

    private codexRuntimeContext(model: any, effort: any) {
        const modelConfigId = this.normalizeCodexModel(model, this.codexDefaultModel);
        const option = this.codexModelOptions.find((item: any) => item.value === modelConfigId) || {};
        const normalizedEffort = this.normalizeCodexReasoningEffort(effort, modelConfigId);
        return {
            model: String(option.model || modelConfigId).trim(),
            model_config_id: modelConfigId,
            model_label: String(option.label || this.codexModelLabel(modelConfigId)).trim(),
            model_provider: String(option.provider || 'openai').trim(),
            model_runtime_key: String(option.runtime_key || '').trim(),
            model_context_window: Number(option.context_window) || 0,
            model_auto_compact_token_limit: Number(option.auto_compact_token_limit) || 0,
            model_reasoning_effort: normalizedEffort,
            model_reasoning_effort_label: this.codexReasoningEffortLabel(normalizedEffort, modelConfigId)
        };
    }

    public selectedCodexRuntimeContext() {
        const model = this.normalizeCodexModel(this.codexModel, this.codexDefaultModel);
        const effort = this.normalizeCodexReasoningEffort(this.codexReasoningEffort, model);
        return this.codexRuntimeContext(model, effort);
    }

    private persistentCodexRuntimeContext(context: any = this.selectedCodexRuntimeContext()) {
        const source = context && typeof context === 'object' ? context : {};
        const model = this.normalizeCodexModel(source.model_config_id || source.model, this.codexDefaultModel);
        let effort = this.normalizeCodexReasoningEffort(
            source.model_reasoning_effort || source.reasoning_effort || source.reasoning_level,
            model,
            this.codexDefaultReasoningEffortForModel(model)
        );
        if (this.codexOneTimeReasoningSelected(effort)) {
            effort = this.codexDefaultReasoningEffortForModel(model);
        }
        return this.codexRuntimeContext(model, effort);
    }

    private applyCodexRuntimePreference(preference: any = {}) {
        const persistentPreference = this.persistentCodexRuntimeContext(preference);
        this.codexModel = persistentPreference.model_config_id;
        this.codexReasoningEffort = persistentPreference.model_reasoning_effort;
    }

    private loadCodexRuntimePreference() {
        try {
            if (typeof window === 'undefined' || !window.sessionStorage) return;
            const raw = window.sessionStorage.getItem(this.codexRuntimePreferenceStorageKey);
            if (!raw) return;
            const preference = JSON.parse(raw);
            if (preference && typeof preference === 'object') this.applyCodexRuntimePreference(preference);
        } catch (e) {
        }
    }

    private saveCodexRuntimePreference() {
        try {
            if (typeof window === 'undefined' || !window.sessionStorage) return;
            const preference = this.persistentCodexRuntimeContext();
            window.sessionStorage.setItem(this.codexRuntimePreferenceStorageKey, JSON.stringify(preference));
        } catch (e) {
        }
    }

    public async setCodexModel(value: any) {
        if (this.codexRunning) return;
        const model = this.normalizeCodexModel(value, this.codexDefaultModel);
        this.codexModel = model;
        this.codexReasoningEffort = this.normalizeCodexReasoningEffort(
            this.codexReasoningEffort,
            model,
            this.codexDefaultReasoningEffortForModel(model)
        );
        this.saveCodexRuntimePreference();
        await this.service.render();
    }

    public async setCodexReasoningEffort(value: any) {
        if (this.codexRunning) return;
        const model = this.normalizeCodexModel(this.codexModel, this.codexDefaultModel);
        this.codexReasoningEffort = this.normalizeCodexReasoningEffort(value, model);
        this.saveCodexRuntimePreference();
        await this.service.render();
    }

    public codexContextRuntimeLabel(context: any = {}) {
        const source = context && typeof context === 'object' ? context : {};
        const model = this.normalizeCodexModel(source.model_config_id || source.model, '');
        const modelLabel = String(source.model_label || (model ? this.codexModelLabel(model) : source.model) || '').trim();
        if (!modelLabel) return '';
        const effort = model ? this.normalizeCodexReasoningEffort(source.model_reasoning_effort, model, '') : '';
        const effortLabel = String(source.model_reasoning_effort_label || (effort ? this.codexReasoningEffortLabel(effort, model) : '')).trim();
        return effortLabel ? `${modelLabel} / ${effortLabel}` : modelLabel;
    }

    public codexMessageContext(message: any) {
        return message && message.context && typeof message.context === 'object' ? message.context : {};
    }

    public codexContextAttachments(context: any = {}) {
        const source = context && typeof context === 'object' ? context : {};
        const attachments = Array.isArray(source.attachments) ? source.attachments : [];
        return attachments
            .map((attachment: any) => this.codexAttachmentReference(attachment))
            .filter((attachment: any) => !!(attachment && attachment.key));
    }

    public codexContextAttachmentGroupKey(attachment: any) {
        const source = String(attachment && attachment.source || '').trim();
        if (this.isCodexSharedFileSource(source)) return 'shared';
        if (source === 'html_reference') return 'html_reference';
        if (source === 'html_resource') return 'html_resource';
        return 'upload';
    }

    public codexContextAttachmentGroupMeta(key: string) {
        const map: any = {
            upload: { label: '첨부파일', icon: 'fa-solid fa-paperclip' },
            html_reference: { label: '참고자료', icon: 'fa-regular fa-file-lines' },
            html_resource: { label: '리소스', icon: 'fa-regular fa-file-code' },
            shared: { label: '공용파일', icon: 'fa-regular fa-folder-open' }
        };
        return map[key] || map.upload;
    }

    public codexContextAttachmentGroups(context: any = {}) {
        const order = ['upload', 'html_reference', 'html_resource', 'shared'];
        const buckets: any = {};
        const seen: any = {};
        order.forEach((key) => {
            const meta = this.codexContextAttachmentGroupMeta(key);
            buckets[key] = Object.assign({ key, items: [] }, meta);
        });
        this.codexContextAttachments(context).forEach((attachment: any) => {
            const groupKey = this.codexContextAttachmentGroupKey(attachment);
            const itemKey = `${groupKey}:${this.codexAttachmentRefKey(attachment)}`;
            if (seen[itemKey]) return;
            seen[itemKey] = true;
            buckets[groupKey].items.push(attachment);
        });
        return order.map((key) => buckets[key]).filter((group: any) => group.items.length > 0);
    }

    public codexContextLogCaptures(context: any = {}) {
        const source = Array.isArray(context && context.log_captures)
            ? context.log_captures
            : Array.isArray(context && context.log_capture_ids)
                ? context.log_capture_ids
                : [];
        return source.map((item: any, index: number) => {
            const value = item && typeof item === 'object' ? item : { id: String(item || '') };
            const ref = this.codexLogCaptureReference(value, Number(value && value.index) || index);
            return Object.assign({}, value, ref, {
                key: this.codexLogCaptureRefKey(value) || ref.key,
                id: String((value && (value.id || value.log_capture_id)) || ref.id || '').trim()
            });
        }).filter((item: any) => !!this.codexLogCaptureRefKey(item));
    }

    public fullLogCaptureForRef(ref: any) {
        const key = this.codexLogCaptureRefKey(ref);
        if (!key) return null;
        return this.reviewLogCaptures(this.selectedReview).find((capture: any, index: number) => this.codexLogCaptureOptionKey(capture, index) === key) || null;
    }

    public buildLogCaptureContextMarkdown(items: any[]) {
        const refs = Array.isArray(items) ? items : [];
        if (!refs.length) return '# 로그\n\n-';
        const lines: string[] = ['# 로그', ''];
        refs.forEach((ref: any, index: number) => {
            const capture = this.fullLogCaptureForRef(ref) || ref || {};
            lines.push(`## ${this.markdownText(this.logCaptureDisplayLabel(capture, index))}`);
            lines.push('');
            lines.push(`- 캡처 시각: ${this.markdownText(this.kstDateTime(capture && (capture.created || capture.captured_at)))}`);
            lines.push(`- 로그 건수: ${this.markdownText(this.logCaptureCountLabel(capture))}`);
            if (capture && Array.isArray(capture.console_log)) {
                lines.push('');
                lines.push('```csv');
                lines.push(this.buildAgentInstructionLogsCsv(this.selectedReview, capture));
                lines.push('```');
            }
            lines.push('');
        });
        return lines.join('\n');
    }

    public codexMessageContextActions(message: any) {
        const context = message && message.context ? message.context : {};
        const actions: any[] = [];
        const runtimeLabel = this.codexContextRuntimeLabel(context);
        if (runtimeLabel) actions.push({
            key: 'runtime',
            type: 'runtime',
            label: runtimeLabel,
            title: '에이전트 실행 설정 보기',
            icon: 'fa-solid fa-sliders'
        });
        if (context.screenshot) actions.push({
            key: 'screenshot',
            type: 'screenshot',
            label: `스크린샷 ${Number(context.screenshot_index) || 1}`,
            title: '스크린샷 보기',
            icon: 'fa-solid fa-image'
        });
        if (context.agent_instruction) actions.push({
            key: 'agent_instruction',
            type: 'agent_instruction',
            label: '작업 지시서',
            title: '작업 지시서 보기',
            icon: 'fa-solid fa-file-lines'
        });
        const logCaptures = this.codexContextLogCaptures(context);
        if (logCaptures.length) actions.push({
            key: 'log_captures',
            type: 'log_captures',
            label: `로그 ${logCaptures.length}개`,
            title: '로그 보기',
            icon: 'fa-solid fa-clipboard-list',
            items: logCaptures
        });
        if (context.html_generation_rules) actions.push({
            key: 'html_generation_rules',
            type: 'html_generation_rules',
            label: 'HTML 생성 규칙',
            title: 'HTML 생성 규칙 보기',
            icon: 'fa-solid fa-list-check'
        });
        if (context.html_project_instruction_file) actions.push({
            key: 'html_project_instruction_file',
            type: 'html_project_instruction_file',
            label: 'HTML 인스트럭션 파일',
            title: 'HTML 인스트럭션 파일 보기',
            icon: 'fa-regular fa-file-lines'
        });
        if (context.html_document_settings) actions.push({
            key: 'html_document_settings',
            type: 'html_document_settings',
            label: 'HTML 문서 설정',
            title: 'HTML 문서 설정 보기',
            icon: 'fa-solid fa-ruler-combined'
        });
        this.codexContextAttachmentGroups(context).forEach((group: any) => {
            actions.push({
                key: `attachments:${group.key}`,
                type: 'attachments',
                label: `${group.label} ${group.items.length}개`,
                title: `${group.label} 목록 보기`,
                icon: group.icon,
                items: group.items
            });
        });
        return actions;
    }

    public codexMessageContextActionTrack(index: number, action: any) {
        return action && action.key ? action.key : `context-action:${index}`;
    }

    public codexMessageContextActionIconClass(action: any) {
        return `${action && action.icon ? action.icon : 'fa-solid fa-circle-info'} text-[10px] text-slate-400`;
    }

    public codexMessageContextLabels(message: any) {
        return this.codexMessageContextActions(message).map((action: any) => action.label);
    }

    public codexMessageContextLabel(message: any) {
        const labels = this.codexMessageContextLabels(message);
        return labels.join(', ');
    }

    public resetCodexContextViewer() {
        this.codexContextViewer = { open: false, type: '', title: '', subtitle: '', content: '', items: [] };
    }

    public async closeCodexContextViewer(render: boolean = true) {
        this.resetCodexContextViewer();
        this.syncModalScrollLock();
        if (render) await this.service.render();
    }

    public async openCodexContextMarkdownViewer(title: any, content: any, subtitle: any = '', event: any = null) {
        if (event && event.preventDefault) event.preventDefault();
        if (event && event.stopPropagation) event.stopPropagation();
        this.codexContextViewer = {
            open: true,
            type: 'markdown',
            title: String(title || 'context 보기'),
            subtitle: String(subtitle || ''),
            content: String(content || '-'),
            items: []
        };
        this.syncModalScrollLock();
        await this.service.render();
    }

    public async openCodexContextAttachmentListViewer(action: any, event: any = null) {
        if (event && event.preventDefault) event.preventDefault();
        if (event && event.stopPropagation) event.stopPropagation();
        const items = action && Array.isArray(action.items) ? action.items.map((item: any) => this.codexAttachmentReference(item)) : [];
        this.codexContextViewer = {
            open: true,
            type: 'list',
            title: action && action.label ? action.label : 'context 자료',
            subtitle: `${items.length}개`,
            content: '',
            items
        };
        this.syncModalScrollLock();
        await this.service.render();
    }

    public codexContextScreenshotIndex(context: any = {}) {
        return Math.max(Number(context && context.screenshot_index) || 1, 1);
    }

    public codexContextScreenshot(context: any = {}) {
        const screenshots = this.reviewScreenshots(this.selectedReview);
        if (!screenshots.length) return null;
        const index = Math.min(this.codexContextScreenshotIndex(context), screenshots.length) - 1;
        return screenshots[index] || screenshots[0];
    }

    public async openCodexContextScreenshot(context: any = {}, event: any = null) {
        if (event && event.preventDefault) event.preventDefault();
        if (event && event.stopPropagation) event.stopPropagation();
        let screenshot = this.codexContextScreenshot(context);
        if ((!screenshot || !this.timelineScreenshotDataUrlValue(screenshot)) && !this.reviewEvidenceAssetsLoaded()) {
            await this.loadReviewEvidenceAssets(false);
            screenshot = this.codexContextScreenshot(context);
        }
        if (!screenshot || !this.timelineScreenshotDataUrlValue(screenshot)) {
            await this.service.modal.error('스크린샷 미리보기를 불러오지 못했습니다.');
            return;
        }
        await this.openCodexScreenshotPreview(screenshot, this.codexContextScreenshotIndex(context) - 1, event);
    }

    public codexRuntimeContextMarkdown(context: any = {}) {
        const rows = [
            ['모델', context.model_label || context.model_config_id || context.model],
            ['모델 ID', context.model_config_id || context.model],
            ['제공자', context.model_provider],
            ['추론수준', context.model_reasoning_effort_label || context.model_reasoning_effort],
            ['최대 context', context.model_context_window ? `${context.model_context_window} tokens` : ''],
            ['자동 압축 threshold', context.model_auto_compact_token_limit ? `${context.model_auto_compact_token_limit} tokens` : '']
        ].filter((row) => !!String(row[1] || '').trim());
        return ['# 에이전트 실행 설정', '', rows.map((row) => `- ${row[0]}: ${this.markdownText(row[1])}`).join('\n') || '-'].join('\n');
    }

    public htmlDocumentSettings(review: any = this.selectedReview) {
        const project = this.reviewProject(review);
        const raw = project && project.html_document_settings;
        if (raw && typeof raw === 'object' && !Array.isArray(raw)) return raw;
        if (typeof raw === 'string' && raw.trim()) {
            try {
                const parsed = JSON.parse(raw);
                return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
            } catch (e) {
                return {};
            }
        }
        return {};
    }

    public htmlLayoutPresetLabel(preset: any) {
        const map: any = {
            a4_portrait: 'A4 세로',
            a4_landscape: 'A4 가로',
            slide_16_9: '16:9 발표자료',
            slide_4_3: '4:3 발표자료',
            web: '웹 해상도',
            custom: '직접 입력'
        };
        return map[String(preset || '')] || String(preset || '웹 해상도');
    }

    public htmlLayoutRenderModeLabel(renderMode: any) {
        const map: any = { document: '문서 크기 기준', web: '웹 해상도 기준' };
        return map[String(renderMode || '')] || String(renderMode || '웹 해상도 기준');
    }

    public htmlLayoutGuidance(preset: any) {
        const value = String(preset || '');
        if (value === 'a4_portrait' || value === 'a4_landscape') {
            return 'A4 레이아웃은 인쇄/문서 검토 기준입니다. 여백, 표, 본문 흐름이 한 페이지 안에서 잘리지 않도록 문서형 밀도로 구성합니다.';
        }
        if (value === 'slide_16_9' || value === 'slide_4_3') {
            return '발표자료 레이아웃은 화면 발표 기준입니다. 한 페이지에 하나의 핵심 메시지를 두고 큰 제목, 시각자료, 여백을 우선합니다.';
        }
        if (value === 'custom') {
            return '직접 입력 레이아웃은 사용자가 지정한 픽셀 크기 기준입니다. 모든 페이지가 같은 크기와 비율을 유지해야 합니다.';
        }
        return '웹 해상도 레이아웃은 브라우저 화면 검토 기준입니다. 고정 화면 안에서 주요 정보가 첫 화면에 안정적으로 보이게 구성합니다.';
    }

    public htmlDocumentKindLabel(kind: any) {
        const map: any = {
            proposal: '제안서',
            proposal_presentation: '제안발표',
            lecture: '강의자료',
            report: '문서',
            custom: '직접 설정'
        };
        return map[String(kind || '')] || String(kind || '-');
    }

    public htmlDocumentLayoutContext(review: any = this.selectedReview) {
        const project = this.reviewProject(review);
        const settings = this.htmlDocumentSettings(review);
        const layout = settings && settings.layout && typeof settings.layout === 'object' ? settings.layout : {};
        return {
            preset: layout.preset || 'web',
            render_mode: layout.render_mode || 'web',
            width: Number(layout.width || project.default_viewport_width || 1440),
            height: Number(layout.height || project.default_viewport_height || 900)
        };
    }

    public htmlProjectPageLoaderRulesMarkdown() {
        return [
            '## iframe 페이지 로더 규칙',
            '',
            '- SDK, postMessage 명령, 외부 제어 API 없이 iframe 내부 HTML만으로 동작하게 만듭니다.',
            '- 페이지 이동은 iframe 안에서 발생하는 키보드 방향키, PageUp/PageDown, 클릭, 터치 같은 일반 브라우저 입력으로 처리합니다.',
            '- 현재 페이지와 전체 페이지 수는 부모 iframe에서 읽을 수 있는 `data-page`, `data-current-page`, `data-page-count` 계열 속성에 반영합니다.',
            '- 각 페이지는 `section[data-page]` 같은 명확한 페이지 단위로 나누고 현재 페이지만 보이도록 유지합니다.',
            '- 페이지별 자료는 현재 페이지 또는 사용자가 이동한 페이지 기준으로만 동적 로딩합니다.'
        ].join('\n');
    }

    public buildHtmlGenerationRulesContextMarkdown(review: any = this.selectedReview) {
        const layout = this.htmlDocumentLayoutContext(review);
        return [
            '# HTML 문서 생성 기본 규칙',
            '',
            `- 현재 선택된 레이아웃은 \`${this.htmlLayoutPresetLabel(layout.preset)}\`이고 렌더링 기준은 \`${this.htmlLayoutRenderModeLabel(layout.render_mode)}\`입니다.`,
            `- 현재 문서 레이아웃 규격은 \`${layout.width}x${layout.height}\`입니다. 이 전체 해상도 하나를 한 페이지 또는 한 슬라이드로 인식합니다.`,
            `- ${this.htmlLayoutGuidance(layout.preset)}`,
            '- 문서를 세로 스크롤로 길게 이어붙이는 방식은 금지합니다. 한 번에 한 페이지만 보이는 페이지 단위 전환 구조로 구현합니다.',
            '- 문서 페이지 내부에는 ReviewOps/브라우저 UI를 넣지 않습니다.',
            '- 기본 스타일링은 Tailwind CSS 유틸리티 클래스를 사용합니다.',
            '- 모든 로컬 참조는 HTML 프로젝트 루트 기준 상대 경로를 사용합니다.',
            '',
            this.htmlProjectPageLoaderRulesMarkdown()
        ].join('\n');
    }

    public buildHtmlDocumentSettingsContextMarkdown(review: any = this.selectedReview) {
        const settings = this.htmlDocumentSettings(review);
        const instruction = settings && settings.instruction && typeof settings.instruction === 'object' ? settings.instruction : {};
        const layout = this.htmlDocumentLayoutContext(review);
        const lines = [
            '# HTML 문서 설정',
            '',
            `- 레이아웃: ${this.htmlLayoutPresetLabel(layout.preset)}`,
            `- 렌더링 기준: ${this.htmlLayoutRenderModeLabel(layout.render_mode)}`,
            `- 해상도: ${layout.width}x${layout.height}`,
            `- 작업 유형: ${this.htmlDocumentKindLabel(instruction.document_kind)}`,
        ];
        [
            ['대상 독자', instruction.audience],
            ['작성 목표', instruction.goal],
            ['톤앤매너', instruction.tone],
            ['브랜드/시각 지침', instruction.brand_rules],
            ['구성/내용 지침', instruction.content_rules],
            ['하네스/프롬프트 지침', instruction.harness_prompt]
        ].forEach((row) => {
            const text = String(row[1] || '').trim();
            if (text) lines.push('', `## ${row[0]}`, '', text);
        });
        return lines.join('\n');
    }

    public buildHtmlProjectInstructionFileContextMarkdown(review: any = this.selectedReview) {
        const project = this.reviewProject(review);
        return [
            '# HTML 프로젝트 인스트럭션 파일',
            '',
            '- 파일: `AGENTS.md`',
            `- 프로젝트: ${this.markdownText(project && project.name)}`,
            `- 프로젝트 종류: ${this.markdownText(this.projectTypeLabel(review))}`,
            '',
            '현재 HTML 프로젝트 루트의 표준 인스트럭션 파일을 에이전트 실행 전에 프로젝트 단위 지시서로 읽고 적용합니다.'
        ].join('\n');
    }

    public async openCodexAgentInstructionContextViewer(event: any = null) {
        if (event && event.preventDefault) event.preventDefault();
        if (event && event.stopPropagation) event.stopPropagation();
        const loaded = await this.loadReviewEvidence(false);
        if (!loaded && !this.reviewEvidenceLoaded()) return;
        await this.openCodexContextMarkdownViewer('에이전트 작업 지시서', this.buildAgentInstructionCopyMarkdown(this.selectedReview), '요청 당시 포함된 지시 내용', null);
    }

    public async openCodexHtmlProjectInstructionFileContext(event: any = null) {
        if (event && event.preventDefault) event.preventDefault();
        if (event && event.stopPropagation) event.stopPropagation();
        const downloadUrl = this.codexMarkdownFileDownloadUrl('AGENTS.md');
        if (downloadUrl) {
            await this.openCodexFilePreview(downloadUrl);
            return;
        }
        await this.openCodexContextMarkdownViewer('HTML 인스트럭션 파일', this.buildHtmlProjectInstructionFileContextMarkdown(this.selectedReview), '', null);
    }

    public async openCodexMessageContextAction(message: any, action: any, event: any = null) {
        if (event && event.preventDefault) event.preventDefault();
        if (event && event.stopPropagation) event.stopPropagation();
        if (!action || !action.type) return;
        const context = this.codexMessageContext(message);
        if (action.type === 'runtime') {
            await this.openCodexContextMarkdownViewer('에이전트 실행 설정', this.codexRuntimeContextMarkdown(context), '', null);
            return;
        }
        if (action.type === 'screenshot') {
            await this.openCodexContextScreenshot(context, null);
            return;
        }
        if (action.type === 'agent_instruction') {
            await this.openCodexAgentInstructionContextViewer(null);
            return;
        }
        if (action.type === 'log_captures') {
            await this.openCodexContextMarkdownViewer('로그', this.buildLogCaptureContextMarkdown(action.items || []), '요청 당시 포함된 로그 버전', null);
            return;
        }
        if (action.type === 'html_generation_rules') {
            await this.openCodexContextMarkdownViewer('HTML 생성 규칙', this.buildHtmlGenerationRulesContextMarkdown(this.selectedReview), '요청 당시 포함된 생성 규칙', null);
            return;
        }
        if (action.type === 'html_document_settings') {
            await this.openCodexContextMarkdownViewer('HTML 문서 설정', this.buildHtmlDocumentSettingsContextMarkdown(this.selectedReview), '요청 당시 포함된 문서 설정 항목', null);
            return;
        }
        if (action.type === 'html_project_instruction_file') {
            await this.openCodexHtmlProjectInstructionFileContext(null);
            return;
        }
        if (action.type === 'attachments') {
            await this.openCodexContextAttachmentListViewer(action, null);
        }
    }

    public codexContextAttachmentTrack(index: number, attachment: any) {
        return this.codexAttachmentRefKey(attachment) || `context-attachment:${index}`;
    }

    public codexContextAttachmentIconClass(attachment: any) {
        const source = String(attachment && attachment.source || '').trim();
        const previewType = this.codexPreviewType(String(attachment && (attachment.name || attachment.path) || ''), String(attachment && attachment.mime || ''));
        if (this.isCodexSharedFileSource(source)) return 'fa-regular fa-folder-open text-[13px] text-slate-500';
        if (source === 'html_reference') return 'fa-regular fa-file-lines text-[13px] text-slate-500';
        if (source === 'html_resource') return 'fa-regular fa-file-code text-[13px] text-slate-500';
        if (previewType === 'image') return 'fa-regular fa-image text-[13px] text-slate-500';
        if (previewType === 'pdf') return 'fa-regular fa-file-pdf text-[13px] text-slate-500';
        return 'fa-regular fa-file text-[13px] text-slate-500';
    }

    public codexContextAttachmentMeta(attachment: any) {
        const parts = [
            attachment && attachment.source_label,
            attachment && attachment.source_detail,
            attachment && attachment.mime,
            this.attachmentSizeLabel(attachment)
        ].map((item: any) => String(item || '').trim()).filter((item: string) => !!item && item !== '-' && item !== '0 B');
        return parts.join(' · ') || 'context 자료';
    }

    public codexRequesterFromUser(user: any) {
        if (!user) return {};
        const displayName = String(user.display_name || '').trim();
        const name = String(user.name || '').trim();
        const email = String(user.email || '').trim();
        const label = displayName || name || email;
        const requester: any = {
            id: String(user.id || '').trim(),
            display_name: displayName,
            name,
            email,
            label
        };
        Object.keys(requester).forEach((key) => {
            if (!requester[key]) delete requester[key];
        });
        return requester;
    }

    public codexMessageRequesterLabel(message: any) {
        const requester = message && message.requester && typeof message.requester === 'object' ? message.requester : {};
        return String(
            requester.label ||
            requester.display_name ||
            requester.name ||
            requester.email ||
            (message && (message.requester_label || message.requester_name)) ||
            ''
        ).trim();
    }

    public codexMessageFinishedAt(message: any) {
        if (!message || typeof message !== 'object') return '';
        return this.codexMessageTransferredAt(message) || message.finished_at || message.ended_at || message.completed_at || message.created || '';
    }

    public codexMessageTransferredAt(message: any) {
        if (!message || typeof message !== 'object') return '';
        return message.activity_created || message.transferred_at || '';
    }

    public codexWorkDurationLabel(value: any) {
        const seconds = Math.max(0, Math.floor(Number(value) || 0));
        if (!seconds) return '';
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const remain = seconds % 60;
        if (hours > 0) return `${hours}시간 ${minutes}분 ${remain}초`;
        if (minutes > 0) return `${minutes}분 ${remain}초`;
        return `${remain}초`;
    }

    public codexMessageTimeLabel(message: any) {
        const isUser = !!(message && message.role === 'user');
        const isError = !!(message && message.error);
        const transferred = !isUser && !isError && !!this.codexMessageTransferredAt(message);
        const prefix = isUser ? '요청' : (isError ? '오류' : (transferred ? '작업이력 등록' : '작업 종료'));
        const timeSource = isUser ? (message && message.created) : this.codexMessageFinishedAt(message);
        const time = this.kstDateTime(timeSource);
        const timeLabel = time && time !== '-' ? `${prefix} ${time}` : prefix;
        const parts = [timeLabel];
        if (!isUser && !isError) {
            const duration = this.codexWorkDurationLabel(message && message.work_duration_seconds);
            if (duration) parts.push(`작업시간 ${duration}`);
        }
        if (isUser) {
            const requester = this.codexMessageRequesterLabel(message);
            parts.push(`요청자 ${requester || '미상'}`);
            return parts.join(' · ');
        }
        const requester = this.codexMessageRequesterLabel(message);
        if (requester) parts.push(`요청자 ${requester}`);
        return parts.join(' · ');
    }

    private codexMessageProgressContext(message: any) {
        const context = message && message.context && typeof message.context === 'object' && !Array.isArray(message.context) ? message.context : {};
        return context;
    }

    private codexProgressState(value: any) {
        const state = String(value || '').trim();
        return ['queued', 'running', 'completed', 'error'].includes(state) ? state : 'running';
    }

    private normalizeCodexProgressStepItem(item: any, index: number = 0) {
        const source = item && typeof item === 'object' && !Array.isArray(item) ? item : { label: item };
        const label = source.label || source.message || source.text || source.content || '';
        const state = this.codexProgressState(source.state || source.status);
        const step: any = this.codexProgressStep(label, state, source.key || `saved:${index}:${state}:${label}`);
        if (!step) return null;
        step.current = !!source.current;
        return step;
    }

    private compactCodexProgressSteps(steps: any[], limit: number = 7, markCurrent: boolean = false) {
        const compacted: any[] = [];
        const source = Array.isArray(steps) ? steps : [];
        source.forEach((rawStep: any, index: number) => {
            const step = this.normalizeCodexProgressStepItem(rawStep, index);
            if (!step || !step.label) return;
            const previous = compacted[compacted.length - 1];
            if (previous && previous.label === step.label && previous.state === step.state) {
                previous.key = step.key;
                return;
            }
            compacted.push(step);
        });
        const count = Math.max(1, Math.floor(Number(limit) || 7));
        const visible = compacted.slice(-count);
        return visible.map((step: any, index: number) => Object.assign({}, step, {
            current: !!(markCurrent && index === visible.length - 1 && !['completed', 'error'].includes(step.state))
        }));
    }

    public codexMessageProgressSteps(message: any, limit: number = 12) {
        if (!message || message.role !== 'assistant') return [];
        const context = this.codexMessageProgressContext(message);
        const savedSteps = Array.isArray(message.progress_steps)
            ? message.progress_steps
            : (Array.isArray(context.progress_steps) ? context.progress_steps : []);
        if (savedSteps.length) return this.compactCodexProgressSteps(savedSteps, limit, false);
        const progressLog = String(message.progress_log || context.progress_log || '').trim();
        if (!progressLog) return [];
        return this.compactCodexProgressSteps(this.codexProgressLogStepsFromText(progressLog), limit, false);
    }

    public codexMessageProgressSummary(steps: any[] = []) {
        const source = Array.isArray(steps) ? steps : [];
        if (!source.length) return '';
        const last = source[source.length - 1] || {};
        const label = String(last.label || '').trim();
        return label ? `${source.length}단계 · ${label}` : `${source.length}단계`;
    }

    public codexMessageProgressKey(message: any, index: number = 0) {
        const reviewId = String(this.selectedReview && this.selectedReview.id ? this.selectedReview.id : 'review');
        return `${reviewId}:${this.codexMessageIdentity(message, index)}`;
    }

    public codexMessageProgressContentId(message: any, index: number = 0) {
        const key = this.codexMessageProgressKey(message, index).replace(/[^a-zA-Z0-9_-]+/g, '-');
        return `reviewops-codex-message-progress-${key}`;
    }

    public isCodexMessageProgressExpanded(message: any, index: number = 0) {
        return !!this.expandedCodexMessageProgress[this.codexMessageProgressKey(message, index)];
    }

    public async toggleCodexMessageProgress(message: any, index: number = 0) {
        if (!this.codexMessageProgressSteps(message).length) return;
        const key = this.codexMessageProgressKey(message, index);
        this.expandedCodexMessageProgress = Object.assign({}, this.expandedCodexMessageProgress, {
            [key]: !this.expandedCodexMessageProgress[key]
        });
        await this.service.render();
    }

    private codexProgressSnapshotContext(limit: number = 12) {
        const steps = this.codexProgressSteps(limit).map((step: any) => ({
            label: step.label,
            state: step.state,
            key: step.key
        })).filter((step: any) => !!step.label);
        if (!steps.length) return {};
        return {
            progress_steps: steps,
            progress_current: steps[steps.length - 1].label,
            progress_step_count: steps.length
        };
    }

    private codexMessageWithProgressSnapshot(message: any) {
        const progress = this.codexProgressSnapshotContext();
        if (!Object.keys(progress).length) return Object.assign({}, message || {});
        const context = Object.assign({}, this.codexMessageProgressContext(message), progress);
        return Object.assign({}, message || {}, {
            context,
            progress_steps: progress.progress_steps,
            progress_current: progress.progress_current
        });
    }

    public codexMessageTransferKey(message: any, index: number = 0) {
        if (!message) return '';
        return String(message.key || (message.id ? `id:${message.id}` : '')).trim();
    }

    public codexMessageActivityId(message: any) {
        if (!message) return '';
        return String(message.activity_id || message.transferred_activity_id || '').trim();
    }

    public canTransferCodexMessage(message: any, index: number = 0) {
        return !!(
            this.selectedReview &&
            message &&
            message.role === 'assistant' &&
            !message.error &&
            String(message.content || '').trim() &&
            this.codexMessageTransferKey(message, index) &&
            !this.codexMessageActivityId(message)
        );
    }

    public normalizeCodexContext(context: any = {}) {
        const source = context && typeof context === 'object' ? context : {};
        const result: any = {
            screenshot: !!source.screenshot,
            screenshot_index: Number(source.screenshot_index) || 0,
            agent_instruction: !!source.agent_instruction,
            html_generation_rules: !!source.html_generation_rules,
            html_project_instruction_file: !!source.html_project_instruction_file,
            html_document_settings: !!source.html_document_settings,
            log_captures: Array.isArray(source.log_captures)
                ? source.log_captures.map((capture: any) => capture && typeof capture === 'object' ? Object.assign({}, capture) : String(capture || ''))
                : Array.isArray(source.log_capture_ids)
                    ? source.log_capture_ids.map((capture: any) => capture && typeof capture === 'object' ? Object.assign({}, capture) : String(capture || ''))
                    : [],
            attachments: Array.isArray(source.attachments)
                ? source.attachments.map((attachment: any) => Object.assign({}, attachment))
                : []
        };
        const model = this.normalizeCodexModel(source.model_config_id || source.model, '');
        if (model) {
            const effort = this.normalizeCodexReasoningEffort(source.model_reasoning_effort, model);
            Object.assign(result, this.codexRuntimeContext(model, effort));
        }
        return result;
    }

    public codexRetrySourceMessage(message: any, index: number = 0) {
        if (!message || message.role !== 'assistant' || !message.error) return null;
        const jobId = String(message.job_id || '').trim();
        let fallback: any = null;
        for (let cursor = Math.min(index - 1, this.codexMessages.length - 1); cursor >= 0; cursor--) {
            const item = this.codexMessages[cursor];
            if (!item || item.role !== 'user' || !String(item.content || '').trim()) continue;
            if (!fallback) fallback = item;
            if (!jobId || String(item.job_id || '').trim() === jobId) return item;
        }
        return fallback;
    }

    public canRetryCodexMessage(message: any, index: number = 0) {
        return !!(
            this.selectedReview &&
            this.canUseCodex() &&
            !this.codexRunning &&
            this.codexRetrySourceMessage(message, index)
        );
    }

    public async retryCodexMessage(message: any, index: number = 0) {
        if (!this.canRetryCodexMessage(message, index)) return;
        const source = this.codexRetrySourceMessage(message, index);
        if (!source) {
            await this.service.modal.error('재실행할 에이전트 요청을 찾지 못했습니다.');
            return;
        }
        const context = Object.assign(
            {},
            this.normalizeCodexContext(source.context),
            this.selectedCodexRuntimeContext()
        );
        await this.startCodexRequest(String(source.content || ''), context);
    }

    public async transferCodexMessageToActivity(message: any, index: number = 0) {
        if (!this.canTransferCodexMessage(message, index)) return;
        const key = this.codexMessageTransferKey(message, index);
        if (!key || this.savingCodexActivityKey) return;
        this.savingCodexActivityKey = key;
        await this.service.render();
        const { code, data } = await wiz.call('add_review_activity', this.requestParams({
            review_id: this.selectedReview.id,
            data: JSON.stringify({
                message: String(message.content || '').trim(),
                attachments: [],
                codex_history_key: key
            })
        }));
        this.savingCodexActivityKey = '';
        if (code === 200 && data.review) {
            this.applyReview(data.review);
            this.codexMessages = this.reviewCodexHistory(this.selectedReview);
        } else {
            await this.service.modal.error((data && data.message) || '에이전트 메시지를 작업이력으로 넘기지 못했습니다.');
        }
        await this.service.render();
    }

    public async toggleScreenshotActionMenu(event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.screenshotActionMenuOpen = !this.screenshotActionMenuOpen;
        await this.service.render();
    }

    public async closeScreenshotActionMenu(render: boolean = true) {
        if (!this.screenshotActionMenuOpen) return;
        this.screenshotActionMenuOpen = false;
        if (render) await this.service.render();
    }

    private blankCapturePrompt() {
        return { open: false, type: '', mode: this.normalizeScreenshotCaptureMode(this.screenshotCaptureMode), message: '' };
    }

    public capturePromptTitle() {
        if (this.capturePrompt && this.capturePrompt.type === 'screenshot') return '스크린샷 캡처';
        return '캡처 확인';
    }

    public capturePromptMessagePlaceholder() {
        return '작업이력 메시지';
    }

    public capturePromptActionLabel() {
        if (this.capturePrompt && this.capturePrompt.type === 'screenshot') return '캡처';
        return '확인';
    }

    public capturePromptModeButtonClass(value: string) {
        const base = 'inline-flex h-8 items-center justify-center gap-1.5 rounded-md border px-2 text-[11px] font-semibold transition-colors ';
        if (this.normalizeScreenshotCaptureMode(this.capturePrompt && this.capturePrompt.mode) === value) return base + 'border-slate-900 bg-slate-900 text-white';
        return base + 'border-slate-300 bg-white text-slate-600 hover:bg-slate-50 hover:text-slate-950';
    }

    public async setCapturePromptMode(mode: any) {
        this.capturePrompt.mode = this.normalizeScreenshotCaptureMode(mode);
        await this.service.render();
    }

    private stopCapturePromptEvent(event: any = null) {
        if (event && event.preventDefault) event.preventDefault();
        if (event && event.stopPropagation) event.stopPropagation();
    }

    public async openActivityScreenshotCaptureDialog(event: any = null) {
        this.stopCapturePromptEvent(event);
        if (!this.canCaptureReviewScreenshot()) return;
        this.capturePrompt = {
            open: true,
            type: 'screenshot',
            mode: this.normalizeScreenshotCaptureMode(this.screenshotCaptureMode),
            message: String(this.activityForm && this.activityForm.message || '')
        };
        this.syncModalScrollLock();
        await this.service.render();
    }

    public async closeCapturePrompt(event: any = null, render: boolean = true) {
        this.stopCapturePromptEvent(event);
        if (!(this.capturePrompt && this.capturePrompt.open)) return;
        this.capturePrompt = this.blankCapturePrompt();
        this.syncModalScrollLock();
        if (render) await this.service.render();
    }

    public async submitCapturePrompt() {
        if (!(this.capturePrompt && this.capturePrompt.open)) return;
        const prompt = Object.assign({}, this.capturePrompt);
        await this.closeCapturePrompt(null, true);
        if (prompt.type === 'screenshot') {
            await this.captureReviewScreenshot({ mode: prompt.mode, activity_message: prompt.message });
        }
    }

    public async selectScreenshotAction(action: string, event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        await this.closeScreenshotActionMenu();
        if (action === 'delete') {
            await this.deleteCurrentReviewScreenshot();
        } else if (action === 'download') {
            this.downloadReviewScreenshot(this.selectedReview);
        } else if (action === 'refresh') {
            await this.refreshReviewScreenshots();
        } else if (action === 'codex') {
            await this.useCurrentScreenshotForCodex();
        } else if (action === 'capture') {
            await this.captureReviewScreenshot();
        }
    }

    public showCaptureScreenshotButton() {
        return !!(this.selectedReview && typeof this.captureScreenshot === 'function' && (this.selectedReview.can_change_status || this.selectedReview.can_edit));
    }

    public normalizeScreenshotCaptureMode(mode: any) {
        return String(mode || '').trim() === 'auto' ? 'auto' : 'browser-partial';
    }

    public screenshotCaptureModeLabel(mode: any) {
        const value = this.normalizeScreenshotCaptureMode(mode);
        const option = this.screenshotCaptureModeOptions.find((item) => item.value === value);
        return option ? option.label : value;
    }

    public screenshotCaptureModeButtonClass(value: string) {
        const base = 'inline-flex h-8 items-center justify-center gap-1.5 rounded-md border px-2 text-[11px] font-semibold transition-colors ';
        if (this.normalizeScreenshotCaptureMode(this.screenshotCaptureMode) === value) return base + 'border-slate-900 bg-slate-900 text-white';
        return base + 'border-slate-200 bg-white text-slate-600 hover:bg-slate-50 hover:text-slate-950';
    }

    public async setScreenshotCaptureMode(mode: any) {
        this.screenshotCaptureMode = this.normalizeScreenshotCaptureMode(mode);
        await this.service.render();
    }

    public canCaptureReviewScreenshot() {
        return this.showCaptureScreenshotButton() && !this.capturingScreenshot && !this.reviewDetailLoading;
    }

    private waitForCaptureVisibilityPaint() {
        return new Promise<void>((resolve) => {
            try {
                const raf = window && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : null;
                if (!raf) {
                    window.setTimeout(() => resolve(), 0);
                    return;
                }
                raf(() => raf(() => resolve()));
            } catch (e) {
                resolve();
            }
        });
    }

    private async setScreenshotCaptureModalHidden(hidden: boolean) {
        if (this.screenshotCaptureModalHidden === hidden) {
            if (hidden) await this.waitForCaptureVisibilityPaint();
            return;
        }
        this.screenshotCaptureModalHidden = hidden;
        await this.service.render();
        if (hidden) await this.waitForCaptureVisibilityPaint();
    }

    public canRefreshReviewScreenshots() {
        return !!(
            this.selectedReview &&
            this.selectedReview.id &&
            !this.reviewDetailLoading &&
            !this.reviewEvidenceLoading &&
            !this.reviewEvidenceAssetLoading
        );
    }

    public async refreshReviewScreenshots() {
        if (!this.canRefreshReviewScreenshots()) return;
        const loaded = await this.loadReviewEvidenceAssets(true);
        if (!loaded) await this.service.modal.error('스크린샷을 새로고침하지 못했습니다.');
    }

    public showDeleteScreenshotButton() {
        return !!(
            this.selectedReview &&
            this.currentScreenshotDataUrl(this.selectedReview) &&
            (this.selectedReview.can_change_status || this.selectedReview.can_edit)
        );
    }

    public canDeleteCurrentReviewScreenshot() {
        return this.showDeleteScreenshotButton() &&
            !this.deletingScreenshot &&
            !this.reviewDetailLoading &&
            !this.reviewEvidenceLoading &&
            !this.reviewEvidenceAssetLoading;
    }

    private clearActivityMessageAfterCapture(message: any) {
        const savedMessage = String(message || '').trim();
        if (!savedMessage) return;
        if (String(this.activityForm && this.activityForm.message || '').trim() === savedMessage) {
            this.activityForm.message = '';
        }
    }

    private async saveCaptureActivityMessage(reviewId: any, message: any) {
        const text = String(message || '').trim();
        if (!text) return true;
        try {
            const { code, data } = await wiz.call('add_review_activity', this.requestParams({
                review_id: reviewId,
                data: JSON.stringify({ message: text, attachments: [] })
            }));
            if (code === 200 && data && data.review) {
                this.applyReview(data.review);
                this.clearActivityMessageAfterCapture(text);
                return true;
            }
            await this.service.modal.error((data && data.message) || '작업이력 메시지를 저장하지 못했습니다.');
        } catch (e) {
            await this.service.modal.error('작업이력 메시지를 저장하지 못했습니다.');
        }
        return false;
    }

    public async captureReviewScreenshot(options: any = {}) {
        if (!this.canCaptureReviewScreenshot()) return;
        const reviewId = this.selectedReview.id;
        const captureMode = this.normalizeScreenshotCaptureMode(options && options.mode ? options.mode : this.screenshotCaptureMode);
        const activityMessage = String(options && (options.activity_message || options.message) || '').trim();
        this.screenshotCaptureMode = captureMode;
        this.capturingScreenshot = true;
        await this.service.render();
        let capture: any = null;
        let captureFailed: boolean = false;
        try {
            await this.setScreenshotCaptureModalHidden(true);
            capture = await this.captureScreenshot(this.selectedReview, captureMode);
        } catch (e) {
            captureFailed = true;
        }
        await this.setScreenshotCaptureModalHidden(false);

        try {
            if (!this.selectedReview || this.selectedReview.id !== reviewId) {
                // Review changed while the browser capture permission prompt was open.
            } else if (captureFailed || !capture || !capture.screenshot_data_url) {
                await this.service.modal.error('새 스크린샷을 캡처하지 못했습니다.');
            } else {
                const { code, data } = await wiz.call('add_review_screenshot', this.requestParams({
                    review_id: reviewId,
                    data: JSON.stringify(capture)
                }));
                if (!this.selectedReview || this.selectedReview.id !== reviewId) {
                    // Ignore stale results for a review that is no longer open.
                } else if (code === 200 && data.review) {
                    this.applyReview(data.review);
                    this.screenshotPage = this.reviewScreenshotTotal(this.selectedReview);
                    this.ensureScreenshotPage();
                    if (activityMessage) {
                        const saved = await this.saveCaptureActivityMessage(reviewId, activityMessage);
                        if (saved) this.scrollActivityHistoryToBottom();
                    }
                } else {
                    await this.service.modal.error(data.message || '스크린샷을 저장하지 못했습니다.');
                }
            }
        } catch (e) {
            await this.service.modal.error('새 스크린샷을 캡처하지 못했습니다.');
        }
        this.screenshotCaptureModalHidden = false;
        this.capturingScreenshot = false;
        await this.service.render();
    }

    public async deleteCurrentReviewScreenshot() {
        if (!this.canDeleteCurrentReviewScreenshot()) return;
        const reviewId = this.selectedReview.id;
        const screenshotIndex = this.currentScreenshotNumber(this.selectedReview);
        const total = this.reviewScreenshotTotal(this.selectedReview);
        const ok = await this.service.modal.show({
            title: '스크린샷 삭제',
            message: total > 1 ? `현재 스크린샷 ${screenshotIndex}/${total}을 삭제할까요?` : '현재 스크린샷을 삭제할까요?',
            action: '삭제',
            cancel: '취소',
            status: 'warning',
            actionBtn: 'warning'
        });
        if (!ok || !this.selectedReview || this.selectedReview.id !== reviewId) return;

        this.deletingScreenshot = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('delete_review_screenshot', this.requestParams({
                review_id: reviewId,
                data: JSON.stringify({ screenshot_index: screenshotIndex })
            }));
            if (!this.selectedReview || this.selectedReview.id !== reviewId) return;
            if (code === 200 && data && data.review) {
                this.applyReview(data.review);
                this.screenshotPage = Math.min(screenshotIndex, this.reviewScreenshotTotal(this.selectedReview) || 1);
                this.ensureScreenshotPage();
                if (!this.hasReviewScreenshot()) {
                    this.codexForm.include_screenshot = false;
                    this.codexForm.screenshot_index = 1;
                }
                await this.closeScreenshotPreview(false);
            } else {
                await this.service.modal.error((data && data.message) || '스크린샷을 삭제하지 못했습니다.');
            }
        } catch (e) {
            await this.service.modal.error('스크린샷을 삭제하지 못했습니다.');
        } finally {
            this.deletingScreenshot = false;
            await this.service.render();
        }
    }

    public async useCurrentScreenshotForCodex() {
        if (!this.canUseCodex() || !this.hasReviewScreenshot() || this.codexRunning) return;
        this.codexForm.include_screenshot = true;
        this.codexForm.screenshot_index = this.currentScreenshotNumber(this.selectedReview);
        await this.setReviewModalTab('codex');
        await this.service.render();
    }

    public clearCodexClock() {
        if (this.codexClockTimer) {
            window.clearInterval(this.codexClockTimer);
            this.codexClockTimer = null;
        }
    }

    private codexTimestampSeconds(value: any) {
        if (!value) return 0;
        if (typeof value === 'number') return Number.isFinite(value) ? value : 0;
        const text = String(value).trim();
        if (!text) return 0;
        const numeric = Number(text);
        if (Number.isFinite(numeric)) return numeric;

        const serverDateTime = text.match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2}):(\d{2})/);
        const hasTimezone = /(?:[zZ]|[+-]\d{2}:?\d{2})$/.test(text);
        if (serverDateTime && !hasTimezone) {
            const year = Number(serverDateTime[1]);
            const month = Number(serverDateTime[2]) - 1;
            const day = Number(serverDateTime[3]);
            const hour = Number(serverDateTime[4]);
            const minute = Number(serverDateTime[5]);
            const second = Number(serverDateTime[6]);
            return Date.UTC(year, month, day, hour, minute, second) / 1000;
        }

        const parsed = Date.parse(text.replace(' ', 'T'));
        return Number.isFinite(parsed) ? parsed / 1000 : 0;
    }

    public syncCodexElapsedFromJob(job: any = {}) {
        if (job && (job.started || job.created)) this.codexJobStarted = job.started || job.created;
        if (job && typeof job.elapsed_seconds !== 'undefined') {
            this.codexElapsedSeconds = Math.max(0, Math.floor(Number(job.elapsed_seconds) || 0));
            return;
        }
        const started = this.codexTimestampSeconds(this.codexJobStarted);
        this.codexElapsedSeconds = started ? Math.max(0, Math.floor(Date.now() / 1000 - started)) : 0;
    }

    public ensureCodexClock() {
        if (!this.codexRunning || this.codexClockTimer) return;
        this.codexClockTimer = window.setInterval(async () => {
            if (!this.codexRunning) {
                this.clearCodexClock();
                return;
            }
            this.codexElapsedSeconds += 1;
            await this.service.render();
        }, 1000);
    }

    private clearCodexComposerInput() {
        const defaults = { message: '', include_screenshot: false, screenshot_index: 1, include_agent_instruction: false, attachments: [], log_capture_ids: [] };
        if (!this.codexForm || typeof this.codexForm !== 'object') {
            this.codexForm = defaults;
        } else {
            this.codexForm = Object.assign({}, this.codexForm, { message: '' });
        }
        this.codexComposerExpanded = false;
    }

    public applyCodexJobStatus(status: string, job: any = {}) {
        const active = status === 'queued' || status === 'running';
        this.codexJobStatus = active ? status : '';
        this.codexRunning = active;
        if (job && job.id) this.codexJobId = job.id;
        if (!active) this.codexJobId = '';
        if (active && job && typeof job.message === 'string') this.codexJobMessage = job.message;
        if (!active) this.codexJobMessage = '';
        this.syncCodexElapsedFromJob(job);
        if (job && typeof job.log === 'string' && job.log) this.setCodexProgressLog(job.log);
        if (active) this.ensureCodexClock();
        else this.clearCodexClock();
        if (!active) this.clearCodexComposerInput();
        if (this.selectedReview) {
            this.selectedReview.codex_job_status = this.codexJobStatus;
            this.selectedReview.codex_job_id = this.codexJobId;
            this.selectedReview.codex_job_message = this.codexJobMessage;
            this.selectedReview.codex_job_started = this.codexJobStarted;
            this.reviewChange.emit(this.selectedReview);
        }
    }

    public trimCodexProgressLog(value: any) {
        const text = String(value || '');
        const max = Math.max(2000, Number(this.codexProgressLogMaxChars) || 12000);
        if (text.length <= max) return text;
        return `[older logs hidden]\n${text.slice(text.length - max)}`;
    }

    public setCodexProgressLog(value: any) {
        this.codexProgressLog = this.trimCodexProgressLog(value);
    }

    public scrollCodexChatToBottom() {
        setTimeout(() => {
            const element = document.getElementById('reviewops-codex-chat-scroll');
            if (element) element.scrollTop = element.scrollHeight;
        }, 80);
    }

    public scheduleCodexPoll() {
        this.clearCodexPoll();
        if (this.destroyed || !this.codexJobId || !this.codexRunning) return;
        const jobId = this.codexJobId;
        const reviewId = this.selectedReview && this.selectedReview.id ? this.selectedReview.id : '';
        this.codexPollTimer = window.setTimeout(() => {
            this.codexPollTimer = null;
            if (this.destroyed || !this.codexRunning || this.codexJobId !== jobId) return;
            if (!this.selectedReview || this.selectedReview.id !== reviewId) return;
            this.pollCodexTask();
        }, this.codexPollDelayMs());
    }

    private codexPollDelayMs() {
        if (typeof document !== 'undefined' && document.hidden) {
            return Math.max(30000, this.codexPollIntervalMs);
        }
        if (!this.codexPollErrorCount) return this.codexPollIntervalMs;
        const multiplier = Math.pow(2, Math.min(this.codexPollErrorCount, 4));
        return Math.min(this.codexPollMaxBackoffMs, this.codexPollIntervalMs * multiplier);
    }

    private shouldIncludeCodexLog(forceLog: boolean = false) {
        if (forceLog) return true;
        if (this.codexRunning && !String(this.codexProgressLog || '').trim()) return true;
        return Date.now() - this.codexLastLogPollAt >= this.codexLogPollIntervalMs;
    }

    private cleanCodexProgressLogLine(value: any) {
        return String(value || '').replace(/\x1B\[[0-?]*[ -/]*[@-~]/g, '').trim();
    }

    private codexProgressLogJsonItems(line: string) {
        const text = String(line || '').trim();
        if (!text || text.indexOf('{') < 0) return [];
        const items: any[] = [];
        const pushJsonItem = (candidate: string) => {
            const value = String(candidate || '').trim();
            if (!value || value.charAt(0) !== '{') return;
            try {
                const parsed = JSON.parse(value);
                if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) items.push(parsed);
            } catch (e) {
            }
        };
        if (text.charAt(0) === '{') {
            pushJsonItem(text);
            if (items.length) return items;
        }
        let start = -1;
        let depth = 0;
        let quote = '';
        let escaped = false;
        for (let index = 0; index < text.length; index++) {
            const char = text.charAt(index);
            if (quote) {
                if (escaped) {
                    escaped = false;
                } else if (char === '\\') {
                    escaped = true;
                } else if (char === quote) {
                    quote = '';
                }
                continue;
            }
            if (char === '"' || char === "'") {
                quote = char;
                continue;
            }
            if (char === '{') {
                if (depth === 0) start = index;
                depth++;
                continue;
            }
            if (char === '}') {
                if (depth > 0) depth--;
                if (depth === 0 && start >= 0) {
                    pushJsonItem(text.slice(start, index + 1));
                    start = -1;
                }
            }
        }
        if (items.length) return items;
        try {
            const parsed = JSON.parse(text);
            return parsed && typeof parsed === 'object' ? [parsed] : [];
        } catch (e) {
            return [];
        }
    }

    private codexProgressLogEventName(value: any) {
        return String(value || '')
            .trim()
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '.')
            .replace(/^\.+|\.+$/g, '');
    }

    private codexProgressLogTextValue(source: any) {
        if (!source || typeof source !== 'object') return '';
        const keys = ['message', 'detail', 'error', 'text', 'content'];
        for (const key of keys) {
            const value = source[key];
            if (typeof value === 'string' && value.trim()) return value.trim();
        }
        const item = source.item && typeof source.item === 'object' ? source.item : null;
        if (!item) return '';
        for (const key of keys) {
            const value = item[key];
            if (typeof value === 'string' && value.trim()) return value.trim();
        }
        return '';
    }

    private codexProgressLogEventPayload(event: any) {
        if (!event || typeof event !== 'object') return {};
        for (const key of ['params', 'payload', 'data', 'event']) {
            const value = event[key];
            if (!value || typeof value !== 'object' || Array.isArray(value)) continue;
            if (value.item || value.type || value.method || value.status || value.message || value.error) return value;
        }
        return {};
    }

    private codexProgressLogEventItem(event: any, payload: any = {}) {
        const sources = [event, payload];
        for (const source of sources) {
            if (!source || typeof source !== 'object') continue;
            for (const key of ['item', 'output_item', 'tool_call', 'call']) {
                const value = source[key];
                if (value && typeof value === 'object' && !Array.isArray(value)) return value;
            }
        }
        return {};
    }

    private codexProgressLogToolIsShell(name: string, item: any = {}) {
        const text = [
            name,
            item && item.command,
            item && item.cmd,
            item && item.arguments,
            item && item.input
        ].map((value: any) => {
            if (!value) return '';
            if (typeof value === 'string') return value;
            try {
                return JSON.stringify(value);
            } catch (e) {
                return String(value);
            }
        }).join(' ').toLowerCase();
        return /(exec|shell|terminal|bash|\/bin\/bash|명령)/.test(text);
    }

    private codexProgressCommandValue(value: any, depth: number = 0): string {
        if (!value || depth > 4) return '';
        if (typeof value === 'string') {
            const text = value.trim();
            if (!text) return '';
            if (/^[{\[]/.test(text)) {
                try {
                    const parsed = JSON.parse(text);
                    const nested: string = this.codexProgressCommandValue(parsed, depth + 1);
                    if (nested) return nested;
                } catch (e) {
                    return text;
                }
            }
            return text;
        }
        if (Array.isArray(value)) {
            for (const item of value) {
                const nested: string = this.codexProgressCommandValue(item, depth + 1);
                if (nested) return nested;
            }
            return '';
        }
        if (typeof value === 'object') {
            const keys = ['cmd', 'command', 'script', 'input', 'arguments', 'args', 'text'];
            for (const key of keys) {
                const nested: string = this.codexProgressCommandValue(value[key], depth + 1);
                if (nested) return nested;
            }
        }
        return '';
    }

    private redactCodexProgressText(value: any) {
        return String(value || '')
            .replace(/(password\s*=\s*['"])[^'"]+(['"])/gi, '$1***$2')
            .replace(/(["']password["']\s*:\s*["'])[^"']+(["'])/gi, '$1***$2')
            .replace(/(-p)(['"]?)[^\s'"]+/gi, '$1$2***')
            .replace(/((?:api[_-]?key|token|secret|credential|authorization)\s*[:=]\s*['"]?)[^\s'",]+/gi, '$1***');
    }

    private codexProgressStepSummary(value: any, maxLength: number = 160) {
        const text = this.redactCodexProgressText(value).replace(/\s+/g, ' ').trim();
        if (!text) return '';
        const limit = Math.max(40, maxLength || 160);
        if (text.length > limit) return `${text.slice(0, limit - 3)}...`;
        return text;
    }

    private codexProgressCommandSummary(value: any) {
        let text = String(value || '').replace(/\s+/g, ' ').trim();
        if (!text) return '';
        const bashMatch = text.match(/\b(?:\/bin\/)?bash\s+-l?c\s+(['"])([\s\S]*)\1/);
        if (bashMatch && bashMatch[2]) text = bashMatch[2].trim();
        text = text
            .replace(/^(?:작업\s*중|작업중|진행\s*중|진행중)[.:\s-]*/i, '')
            .replace(/^명령\s*실행\s*:\s*/i, '')
            .replace(/^exec_command\s*[:=]\s*/i, '')
            .trim();
        return this.codexProgressStepSummary(text, 120);
    }

    private codexProgressCommandText(item: any = {}) {
        return this.codexProgressCommandSummary(this.codexProgressCommandValue(item));
    }

    private codexProgressToolLabel(name: string) {
        const value = String(name || '').trim();
        const lower = value.toLowerCase();
        if (!value) return '도구 처리';
        if (lower.indexOf('apply_patch') >= 0) return '파일 수정 적용';
        if (lower.indexOf('read') >= 0 || lower.indexOf('open') >= 0 || lower.indexOf('cat') >= 0 || lower.indexOf('sed') >= 0 || lower.indexOf('rg') >= 0) return '파일 확인';
        if (lower.indexOf('image') >= 0 || lower.indexOf('screenshot') >= 0) return '이미지 확인';
        return value.replace(/^functions\./, '').replace(/^mcp__wiz__\./, '');
    }

    private codexProgressStep(label: any, state: string = 'running', key: string = '') {
        const text = this.codexProgressStepSummary(label);
        if (!text) return null;
        const normalizedState = ['queued', 'running', 'completed', 'error'].includes(state) ? state : 'running';
        return {
            label: text,
            state: normalizedState,
            key: key || `${normalizedState}:${text}`
        };
    }

    private codexProgressLogEventState(eventName: string, itemStatus: string) {
        const status = this.codexProgressLogEventName(itemStatus);
        if (['completed', 'succeeded', 'success', 'done'].includes(status) || eventName === 'item.completed' || eventName.endsWith('.completed')) {
            return 'completed';
        }
        if (['failed', 'error', 'cancelled', 'canceled'].includes(status) || eventName === 'error' || eventName === 'fatal.error' || eventName.endsWith('.failed')) {
            return 'error';
        }
        if (status === 'queued') return 'queued';
        return 'running';
    }

    private codexProgressCommandEvent(itemType: string, eventName: string) {
        return itemType === 'command.execution' || itemType === 'command.execution.delta' || eventName === 'command.execution' || eventName.indexOf('command.execution') >= 0;
    }

    private codexProgressLogEventStep(event: any) {
        if (!event || typeof event !== 'object') return '';
        const payload = this.codexProgressLogEventPayload(event);
        const eventName = this.codexProgressLogEventName(event.type || payload.type || event.event || payload.event || event.method || payload.method);
        const item = this.codexProgressLogEventItem(event, payload);
        const itemType = this.codexProgressLogEventName(item.type || event.item_type || payload.item_type || payload.type);
        const itemStatus = this.codexProgressLogEventName(item.status || payload.status || event.status);
        const itemName = String(
            item.tool ||
            item.name ||
            (item.server && item.tool ? `${item.server}.${item.tool}` : '') ||
            event.tool ||
            payload.tool ||
            event.name ||
            payload.name ||
            ''
        ).trim();
        const state = this.codexProgressLogEventState(eventName, itemStatus);
        const agentMessageEvent = eventName === 'agent.message' ||
            itemType === 'agent.message' ||
            itemType === 'agent.message.delta' ||
            itemType === 'message' ||
            itemType.indexOf('agent.message') >= 0 ||
            eventName.indexOf('message') >= 0;
        if (agentMessageEvent) {
            return this.codexProgressStep(state === 'completed' ? '응답 작성 완료' : '응답 작성 중', state, `${eventName}:${itemType}`);
        }
        const text = this.codexProgressLogTextValue(event) || this.codexProgressLogTextValue(payload);
        if (text) {
            const line = this.sanitizeCodexProgressLogLine(text);
            return line ? this.codexProgressStep(line, state, `${eventName}:${itemType}:${line}`) : null;
        }

        if (eventName === 'thread.started' || eventName === 'session.started') {
            return this.codexProgressStep('에이전트 세션 준비', state, eventName);
        }
        if (eventName === 'turn.started' || eventName === 'task.started' || eventName === 'response.started') {
            return this.codexProgressStep('에이전트 요청 시작', state, eventName);
        }
        if (eventName === 'turn.completed' || eventName === 'task.completed' || eventName === 'response.completed' || (eventName === 'turn.status.changed' && itemStatus === 'completed')) {
            return this.codexProgressStep('에이전트 응답 정리 완료', 'completed', eventName);
        }
        if (itemType.indexOf('reasoning') >= 0 || eventName.indexOf('reasoning') >= 0) {
            return this.codexProgressStep(state === 'completed' ? '추론 정리 완료' : '추론 진행 중', state, `${eventName}:${itemType}`);
        }
        if (itemType.indexOf('file.change') >= 0 || (Array.isArray(item.changes) && item.changes.length)) {
            const label = state === 'completed' ? '파일 수정 적용 완료' : (state === 'error' ? '파일 수정 적용 오류' : '파일 수정 적용 중');
            return this.codexProgressStep(label, state, `${eventName}:${itemType}:file-change`);
        }
        if (this.codexProgressCommandEvent(itemType, eventName) || itemName || itemType.indexOf('tool') >= 0 || itemType.indexOf('mcp') >= 0 || itemType.indexOf('function') >= 0 || eventName.indexOf('tool') >= 0 || eventName.indexOf('function') >= 0) {
            const shell = this.codexProgressCommandEvent(itemType, eventName) || this.codexProgressLogToolIsShell(itemName, item);
            const command = shell ? this.codexProgressCommandText(item) : '';
            const toolLabel = this.codexProgressToolLabel(itemName || itemType || eventName);
            if (state === 'completed') {
                return this.codexProgressStep(shell ? (command ? `명령 완료: ${command}` : '명령 실행 완료') : `${toolLabel} 완료`, 'completed', `${eventName}:${itemType}:${toolLabel}:${command}`);
            }
            if (state === 'error') {
                return this.codexProgressStep(shell ? (command ? `명령 오류: ${command}` : '명령 실행 오류') : `${toolLabel} 오류`, 'error', `${eventName}:${itemType}:${toolLabel}:${command}`);
            }
            return this.codexProgressStep(shell ? (command ? `명령 실행: ${command}` : '명령 실행 중') : `${toolLabel} 중`, state, `${eventName}:${itemType}:${toolLabel}:${command}`);
        }
        return null;
    }

    private codexProgressLogEventLine(event: any) {
        const step = this.codexProgressLogEventStep(event);
        return step ? step.label : '';
    }

    private sanitizeCodexProgressLogLine(line: string) {
        const text = String(line || '').trim();
        if (!text || text === '[older logs hidden]') return '';
        if (/^\[(환경|stdout|stderr)\]$/i.test(text)) return '';
        if (/^(codex|python|conda|wiz)=/i.test(text)) return '';

        const compact = text.replace(/[.\s]+$/g, '').trim();
        if (/^(작업\s*중|작업중|진행\s*중|진행중)$/i.test(compact)) return '에이전트 응답 생성 중';
        if (/^(작업\s*중|작업중|진행\s*중|진행중)[.:\s-]+/i.test(text) && /(명령\s*실행|command|exec|bash -lc|\/bin\/bash|shell)/i.test(text)) {
            const command = this.codexProgressCommandSummary(text);
            return command ? `작업 중 · 명령 실행: ${command}` : '작업 중 · 명령 실행';
        }
        if (/(명령\s*실행\s*:|exec_command|\/bin\/bash|bash -lc)/i.test(text)) {
            const command = this.codexProgressCommandSummary(text);
            return command ? `명령 실행: ${command}` : '명령 실행 중';
        }
        if (/^\{/.test(text)) return '';
        return text;
    }

    private codexProgressLogDisplayLine(line: string) {
        const events = this.codexProgressLogJsonItems(line);
        if (events.length) {
            for (const event of events) {
                const eventLine = this.codexProgressLogEventLine(event);
                if (eventLine) return eventLine;
            }
            return '';
        }
        return this.sanitizeCodexProgressLogLine(line);
    }

    private codexProgressLogDisplaySteps(line: string) {
        const events = this.codexProgressLogJsonItems(line);
        if (events.length) {
            const steps: any[] = [];
            events.forEach((event: any) => {
                const step = this.codexProgressLogEventStep(event);
                if (step) steps.push(step);
            });
            return steps;
        }
        const displayLine = this.sanitizeCodexProgressLogLine(line);
        const step = displayLine ? this.codexProgressStep(displayLine) : null;
        return step ? [step] : [];
    }

    private codexProgressLogStepsFromText(value: any) {
        const steps: any[] = [];
        String(value || '')
            .split(/\r?\n/)
            .forEach((rawLine: string) => {
                const line = this.cleanCodexProgressLogLine(rawLine);
                this.codexProgressLogDisplaySteps(line).forEach((step: any) => steps.push(step));
            });
        return steps;
    }

    private codexProgressLogSteps() {
        return this.codexProgressLogStepsFromText(this.codexProgressLog);
    }

    private codexQueuedProgressStep() {
        const message = String(this.codexJobMessage || '').trim();
        const label = message && message.indexOf('대기') >= 0 ? message : '실행 대기 중';
        return this.codexProgressStep(label, 'queued', `queued:${label}`);
    }

    public codexProgressSteps(limit: number = 7) {
        let steps = this.codexProgressLogSteps();
        if (this.codexJobStatus === 'queued') {
            const queuedStep = this.codexQueuedProgressStep();
            if (queuedStep) {
                steps = steps.filter((step: any) => !(step && step.state === queuedStep.state && step.label === queuedStep.label));
                steps.push(queuedStep);
            }
        }
        let compacted = this.compactCodexProgressSteps(steps, limit, true);
        if (!compacted.length && this.codexJobMessage) {
            const step = this.codexProgressStep(this.codexJobMessage, this.codexJobStatus === 'queued' ? 'queued' : 'running');
            compacted = this.compactCodexProgressSteps(step ? [step] : [], limit, true);
        }
        if (!compacted.length && this.codexRunning) {
            const fallback = this.codexJobStatus === 'queued' ? '실행 대기 중' : '요청을 처리하는 중';
            const step = this.codexProgressStep(fallback, this.codexJobStatus === 'queued' ? 'queued' : 'running');
            compacted = this.compactCodexProgressSteps(step ? [step] : [], limit, true);
        }
        return compacted;
    }

    public codexProgressStepStateLabel(step: any) {
        const state = step && step.state ? step.state : 'running';
        if (state === 'completed') return '완료';
        if (state === 'error') return '오류';
        if (state === 'queued') return '대기';
        return step && step.current ? '진행 중' : '진행';
    }

    public codexProgressStepIconClass(step: any) {
        const state = step && step.state ? step.state : 'running';
        if (state === 'completed') return 'fa-solid fa-check';
        if (state === 'error') return 'fa-solid fa-exclamation';
        if (state === 'queued') return 'fa-regular fa-clock';
        return step && step.current ? 'fa-solid fa-spinner animate-spin' : 'fa-solid fa-ellipsis';
    }

    public codexProgressStepBulletClass(step: any) {
        const state = step && step.state ? step.state : 'running';
        const base = 'mt-0.5 inline-flex h-4 w-4 shrink-0 items-center justify-center rounded-full border text-[8px] ';
        if (state === 'completed') return base + 'border-emerald-200 bg-emerald-50 text-emerald-700';
        if (state === 'error') return base + 'border-rose-200 bg-rose-50 text-rose-700';
        if (state === 'queued') return base + 'border-slate-200 bg-white text-slate-500';
        if (step && step.current) return base + 'border-sky-200 bg-sky-50 text-sky-700';
        return base + 'border-slate-200 bg-white text-slate-500';
    }

    public codexProgressStepTextClass(step: any) {
        const current = !!(step && step.current);
        const state = step && step.state ? step.state : 'running';
        const base = 'min-w-0 flex-1 whitespace-normal break-words text-[12px] leading-5 ';
        if (state === 'error') return base + 'font-semibold text-rose-700';
        if (current) return base + 'font-semibold text-sky-700';
        if (state === 'completed') return base + 'font-medium text-slate-500';
        return base + 'font-medium text-slate-600';
    }

    public trackCodexProgressStep(index: number, step: any) {
        return step && step.key ? step.key : `codex-progress:${index}`;
    }

    public codexSessionId() {
        return String(this.selectedReview && this.selectedReview.codex_session_id ? this.selectedReview.codex_session_id : '').trim();
    }

    public canCheckCodexSession() {
        return !!(
            this.selectedReview &&
            this.canUseCodex() &&
            !this.codexRunning &&
            !this.codexDetailLoading &&
            !this.checkingCodexSession
        );
    }

    public async checkCodexSession() {
        if (!this.selectedReview || !this.canUseCodex() || this.codexRunning || this.checkingCodexSession) return;
        if (!this.codexDetailLoaded()) {
            const loaded = await this.loadCodexDetail();
            if (!loaded) return;
        }
        this.checkingCodexSession = true;
        this.saveCodexRuntimePreference();
        await this.service.render();
        const { code, data } = await wiz.call('check_codex_session', this.requestParams({
            review_id: this.selectedReview.id,
            data: JSON.stringify(this.selectedCodexRuntimeContext())
        }));
        this.checkingCodexSession = false;
        if (code === 200 && data.review) {
            this.applyReview(data.review);
            this.codexLoadedReviewId = this.selectedReview.id;
            this.syncCodexStateFromReview();
        }
        if (code === 200 && data.result) {
            const result = data.result || {};
            if (result.status === 'model_changed') {
                await this.service.modal.warning(result.message || '선택한 모델은 신규 에이전트 세션으로 실행됩니다.');
            } else if (result.status === 'model_unsupported') {
                await this.service.modal.error(
                    result.message || '선택한 모델 설정을 지원하지 않습니다. 다른 모델 또는 추론수준을 선택해주세요.'
                );
            } else if (result.available) {
                await this.service.modal.success(result.message || '에이전트 세션을 정상적으로 resume할 수 있습니다.');
            } else {
                await this.service.modal.error(result.message || '사용 가능한 에이전트 세션이 없습니다.');
            }
        } else {
            await this.service.modal.error((data && data.message) || '에이전트 세션을 확인하지 못했습니다.');
        }
        await this.service.render();
    }

    public async toggleCodexIndependentExecution() {
        if (!this.canUseCodex() || this.codexRunning) return;
        this.codexIndependentExecution = !this.codexIndependentExecution;
        await this.service.render();
    }

    public async startCodexRequest(message: string, context: any = {}) {
        if (!this.selectedReview || !this.canUseCodex() || this.codexRunning) return false;
        const reviewId = this.selectedReview.id;
        const requestMessage = String(message || '').trim();
        if (!requestMessage) {
            await this.service.modal.error('에이전트 요청 내용을 입력해주세요.');
            return false;
        }
        if (!this.codexDetailLoaded()) {
            const loaded = await this.loadCodexDetail();
            if (!loaded) return false;
        }
        if (!this.selectedReview || this.selectedReview.id !== reviewId || this.codexRunning || !this.canUseCodex()) return false;
        const independentExecution = this.codexIndependentExecution;
        if (independentExecution && !window.confirm(
            '독립실행은 현재 대기 큐와 관계없이 다른 에이전트 작업과 동시에 실행됩니다. UI·파일·DB 등 같은 대상을 수정하면 충돌하거나 다른 작업에 영향을 줄 수 있습니다. 작업 범위가 겹치지 않는지 확인한 후 실행하세요. 독립실행을 진행할까요?'
        )) return false;
        const runtimeContext = this.selectedCodexRuntimeContext();
        const requestedContext = Object.assign({}, runtimeContext, context || {});
        const normalizedContext = this.normalizeCodexContext(requestedContext);
        if (normalizedContext.model) {
            this.applyCodexRuntimePreference(normalizedContext);
            this.saveCodexRuntimePreference();
        }
        const requester = this.codexRequesterFromUser(this.currentUser);
        this.appendCodexMessage({ role: 'user', content: requestMessage, context: normalizedContext, requester, created: new Date().toISOString() });
        this.closeCodexScreenshotPicker();
        this.closeCodexLogCapturePicker();
        this.closeCodexAttachmentPicker();
        this.closeCodexSharedFilePicker();
        this.codexRunning = true;
        this.codexElapsedSeconds = 0;
        this.codexProgressLog = '';
        this.codexLastLogPollAt = 0;
        await this.service.render();
        this.scrollCodexChatToBottom();
        const { code, data } = await wiz.call('start_codex_task', this.requestParams({
            review_id: reviewId,
            data: JSON.stringify({
                message: requestMessage,
                context: normalizedContext,
                independent_execution: independentExecution,
                independent_execution_confirmed: independentExecution
            })
        }));
        if (this.destroyed || !this.selectedReview || this.selectedReview.id !== reviewId) return true;
        if (code === 200 && data.job && data.job.id) {
            this.codexJobId = data.job.id;
            if (data.review) {
                this.applyReview(data.review);
                this.syncCodexStateFromReview();
                if (!this.codexRunning && ['queued', 'running'].includes(data.job.status)) {
                    this.applyCodexJobStatus(data.job.status || 'running', data.job);
                }
            } else {
                this.applyCodexJobStatus(data.job.status || 'running', data.job);
                const synced = await this.reloadSelectedReviewDetail(true);
                if (!synced) this.scheduleCodexPoll();
            }
        } else {
            this.applyCodexJobStatus('', {});
            this.appendCodexMessage({ role: 'assistant', error: true, content: (data && data.message) || '에이전트 작업을 시작하지 못했습니다.', created: new Date().toISOString() });
        }
        await this.service.render();
        this.scrollCodexChatToBottom();
        return true;
    }

    public async stopCodexTask() {
        if (!this.codexRunning || !this.codexJobId || this.stoppingCodexJob) return;
        const confirmed = window.confirm('진행 중인 에이전트 작업을 중지합니다. 원격 서버에서 실행 중인 에이전트 프로세스가 종료될 수 있습니다. 계속할까요?');
        if (!confirmed) return;
        this.stoppingCodexJob = true;
        await this.service.render();
        const { code, data } = await wiz.call('stop_codex_task', this.requestParams({ job_id: this.codexJobId }));
        this.stoppingCodexJob = false;
        if (code === 200 && data.job) {
            if (data.review) {
                this.applyReview(data.review);
                this.syncCodexStateFromReview();
            } else {
                this.applyCodexJobStatus('', data.job);
                const synced = await this.reloadSelectedReviewDetail(true);
                if (!synced) {
                    this.appendCodexMessage(this.codexMessageWithProgressSnapshot({ role: 'assistant', content: data.job.message || '에이전트 작업이 중지되었습니다.', job_id: data.job.id || this.codexJobId, created: new Date().toISOString() }));
                    if (this.selectedReview) {
                        this.reviewChange.emit(this.selectedReview);
                    }
                }
            }
        } else {
            await this.service.modal.error((data && data.message) || '에이전트 작업을 중지하지 못했습니다.');
        }
        await this.service.render();
        this.scrollCodexChatToBottom();
    }

    public async pollCodexTask(forceLog: boolean = false) {
        if (this.destroyed || !this.codexJobId || !this.codexRunning || this.codexPollLoading) return;
        this.clearCodexPoll();
        const jobId = this.codexJobId;
        const reviewId = this.selectedReview && this.selectedReview.id ? this.selectedReview.id : '';
        const requestSeq = ++this.codexPollRequestSeq;
        this.codexPollLoading = true;
        const includeLog = this.shouldIncludeCodexLog(forceLog);
        let code = 0;
        let data: any = {};
        try {
            const response = await wiz.call('codex_task_status', this.requestParams({
                job_id: jobId,
                include_log: includeLog ? '1' : ''
            }));
            code = response.code;
            data = response.data || {};
        } catch (error) {
            code = 0;
            data = {};
        } finally {
            if (requestSeq === this.codexPollRequestSeq) this.codexPollLoading = false;
        }
        if (!this.isActiveCodexPoll(requestSeq, jobId, reviewId)) return;
        if (code !== 200 || !data.job) {
            this.codexPollErrorCount++;
            if (this.codexPollErrorCount < 4) {
                this.scheduleCodexPoll();
                return;
            }
            this.applyCodexJobStatus('', {});
            this.appendCodexMessage(this.codexMessageWithProgressSnapshot({ role: 'assistant', error: true, content: (data && data.message) || '에이전트 작업 상태를 확인하지 못했습니다.', job_id: jobId, created: new Date().toISOString() }));
            await this.service.render();
            this.scrollCodexChatToBottom();
            return;
        }
        this.codexPollErrorCount = 0;
        if (includeLog) this.codexLastLogPollAt = Date.now();
        const job = data.job;
        if (job.status === 'queued' || job.status === 'running') {
            this.applyCodexJobStatus(job.status, job);
            await this.service.render();
            this.scheduleCodexPoll();
            return;
        }
        this.applyCodexJobStatus('', job);
        const synced = await this.reloadSelectedReviewDetail(true);
        if (!this.isActiveCodexPoll(requestSeq, jobId, reviewId)) return;
        if (!synced) {
            if (job.status === 'done') {
                this.appendCodexMessage(this.codexMessageWithProgressSnapshot({ role: 'assistant', content: job.response || '에이전트 작업이 완료되었습니다.', job_id: job.id || jobId, created: new Date().toISOString() }));
            } else if (job.status === 'cancelled') {
                this.appendCodexMessage(this.codexMessageWithProgressSnapshot({ role: 'assistant', content: job.message || '에이전트 작업이 중지되었습니다.', job_id: job.id || jobId, created: new Date().toISOString() }));
            } else {
                this.appendCodexMessage(this.codexMessageWithProgressSnapshot({ role: 'assistant', error: true, content: job.message || '에이전트 작업에 실패했습니다.', job_id: job.id || jobId, created: new Date().toISOString() }));
            }
            if (this.selectedReview) {
                this.reviewChange.emit(this.selectedReview);
            }
        }
        await this.service.render();
        this.scrollCodexChatToBottom();
    }

    private isActiveCodexPoll(requestSeq: number, jobId: string, reviewId: string) {
        return !!(
            !this.destroyed &&
            requestSeq === this.codexPollRequestSeq &&
            this.selectedReview &&
            this.selectedReview.id === reviewId &&
            (!this.codexJobId || this.codexJobId === jobId)
        );
    }

    public async sendCodexMessage() {
        if (!this.selectedReview || !this.canUseCodex() || this.codexRunning) return;
        const reviewId = this.selectedReview.id;
        const message = String(this.codexForm.message || '').trim();
        if (!message) {
            await this.service.modal.error('에이전트 요청 내용을 입력해주세요.');
            return;
        }
        const attachments = this.selectedCodexAttachmentReferences();
        const logCaptures = this.selectedCodexLogCaptureReferences();
        const context = Object.assign({
            screenshot: !!this.codexForm.include_screenshot && this.hasReviewScreenshot(),
            screenshot_index: !!this.codexForm.include_screenshot && this.hasReviewScreenshot()
                ? (Number(this.codexForm.screenshot_index) || this.currentScreenshotNumber(this.selectedReview))
                : 0,
            agent_instruction: !!this.codexForm.include_agent_instruction,
            html_generation_rules: this.reviewIsHtmlProject(this.selectedReview),
            html_project_instruction_file: this.reviewIsHtmlProject(this.selectedReview),
            html_document_settings: this.reviewIsHtmlProject(this.selectedReview),
            log_captures: logCaptures,
            attachments
        }, this.selectedCodexRuntimeContext());
        const started = await this.startCodexRequest(message, context);
        if (!started || !this.selectedReview || this.selectedReview.id !== reviewId) return;
        this.blurMobileComposerControl();
        this.codexForm.message = '';
        this.codexComposerExpanded = false;
        await this.service.render();
    }

    public async sendReviewActivity() {
        if (!this.selectedReview) return;
        if (this.activityAttachmentBusy) {
            await this.service.modal.error('첨부 파일을 읽는 중입니다.');
            return;
        }
        const message = String(this.activityForm.message || '').trim();
        if (!message) {
            await this.service.modal.error('작업이력 메시지를 입력해주세요.');
            return;
        }
        const payload: any = { message, attachments: this.activityAttachments() };
        if (this.selectedReview.can_change_status && this.activityForm.status) payload.status = this.activityForm.status;
        this.sendingActivity = true;
        await this.service.render();
        const { code, data } = await wiz.call('add_review_activity', this.requestParams({
            review_id: this.selectedReview.id,
            data: JSON.stringify(payload)
        }));
        this.sendingActivity = false;
        if (code === 200) {
            this.blurMobileComposerControl();
            this.applyReview(data.review);
            this.resetActivityForm(this.selectedReview);
            this.activityComposerExpanded = false;
            await this.setReviewModalTab('history');
            this.scrollActivityHistoryToBottom();
        } else {
            await this.service.modal.error(data.message || '작업이력을 저장하지 못했습니다.');
        }
        await this.service.render();
    }

    public async saveActivityEdit() {
        if (!this.selectedReview || !this.activityEditId) return;
        if (this.activityEditAttachmentBusy) {
            await this.service.modal.error('첨부 파일을 읽는 중입니다.');
            return;
        }
        const message = String(this.activityEditForm.message || '').trim();
        if (!message) {
            await this.service.modal.error('작업이력 메시지를 입력해주세요.');
            return;
        }
        const payload: any = { message, attachments: this.activityEditAttachments() };
        this.savingActivityEdit = true;
        await this.service.render();
        const { code, data } = await wiz.call('update_review_activity', this.requestParams({
            activity_id: this.activityEditId,
            data: JSON.stringify(payload)
        }));
        this.savingActivityEdit = false;
        if (code === 200) {
            this.applyReview(data.review);
            this.resetActivityEditState();
        } else {
            await this.service.modal.error(data.message || '작업이력을 저장하지 못했습니다.');
        }
        await this.service.render();
    }

    public async deleteReview() {
        if (!this.selectedReview || !this.selectedReview.can_delete) return;
        const ok = await this.service.modal.show({
            title: '리뷰 삭제',
            message: '이 리뷰와 작업이력을 삭제할까요?',
            action: '삭제',
            cancel: '취소',
            status: 'warning',
            actionBtn: 'warning'
        });
        if (!ok) return;
        const reviewId = this.selectedReview.id;
        const { code, data } = await wiz.call('delete_review', this.requestParams({ review_id: reviewId }));
        if (code === 200) {
            this.reviewDelete.emit({ id: data.review_id || reviewId });
            await this.close();
        } else {
            await this.service.modal.error(data.message || '리뷰를 삭제하지 못했습니다.');
        }
    }

    public applyReview(review: any) {
        if (!review) return;
        const editingPayload = this.editingReview ? Object.assign({}, this.reviewEditForm || {}) : null;
        this.selectedReview = this.mergeReviewContext(review, this.selectedReview || {});
        this.applyUploadSettings(this.selectedReview.upload_settings || (this.selectedReview.project && this.selectedReview.project.upload_settings));
        this.reviewEditForm = editingPayload || this.reviewEditPayload(this.selectedReview);
        this.ensureScreenshotPage();
        this.pruneCodexAttachmentRefs();
        this.pruneCodexLogCaptureRefs();
        this.syncReviewLogVersion();
        if (this.reviewModalTab === 'codex' && !this.canUseCodex()) this.reviewModalTab = 'history';
        this.reviewChange.emit(this.selectedReview);
    }

    public reviewToggleClass(current: string, value: string, kind: string = '') {
        const base = 'rounded-md border px-3 py-2 text-[12px] font-semibold transition-colors disabled:cursor-not-allowed disabled:opacity-50 ';
        if (current !== value) return base + 'border-slate-200 bg-white text-slate-600 hover:border-slate-400 hover:text-slate-900';
        if (kind === 'priority' && value === 'low') return base + 'border-teal-300 bg-teal-50 text-teal-700';
        if (kind === 'priority' && value === 'normal') return base + 'border-sky-300 bg-sky-50 text-sky-700';
        if (kind === 'priority' && value === 'high') return base + 'border-orange-300 bg-orange-50 text-orange-700';
        if (kind === 'priority' && value === 'critical') return base + 'border-rose-300 bg-rose-50 text-rose-700';
        return base + 'border-slate-300 bg-slate-100 text-slate-700';
    }

    public activityStatusToggleClass(current: string, value: string) {
        const base = 'inline-flex h-7 shrink-0 items-center rounded-md border px-2 text-[11px] font-semibold transition-colors disabled:cursor-not-allowed disabled:opacity-50 ';
        if (current !== value) return base + 'border-slate-200 bg-white text-slate-600 hover:border-slate-400 hover:text-slate-900';
        return base + 'border-sky-400 bg-sky-500 text-white shadow-sm shadow-sky-950/20';
    }

    public codexMarkdownAnchor(target: any) {
        let element = target;
        while (element && element !== document.body) {
            const tag = String(element.tagName || '').toLowerCase();
            if (tag === 'a') return element;
            element = element.parentElement;
        }
        return null;
    }

    public isCodexFileDownloadUrl(href: any) {
        const value = String(href || '').trim();
        if (!value) return false;
        try {
            const url = new URL(value, window.location.origin);
            return url.pathname === '/wiz/api/component.review.modal/download_codex_file';
        } catch (e) {
            return value.indexOf('/wiz/api/component.review.modal/download_codex_file') >= 0;
        }
    }

    public async onCodexMarkdownClick(event: any) {
        const anchor = this.codexMarkdownAnchor(event && event.target);
        if (!anchor) return;
        const href = anchor.getAttribute('href') || '';
        if (!this.isCodexFileDownloadUrl(href)) return;
        if (event && event.preventDefault) event.preventDefault();
        if (event && event.stopPropagation) event.stopPropagation();
        await this.openCodexFilePreview(href);
    }

    public codexPreviewFileName(urlValue: string, response: any = null) {
        const disposition = response && response.headers ? String(response.headers.get('content-disposition') || '') : '';
        const utfMatch = disposition.match(/filename\*=UTF-8''([^;]+)/i);
        if (utfMatch && utfMatch[1]) return decodeURIComponent(utfMatch[1].replace(/"/g, '').trim());
        const nameMatch = disposition.match(/filename="?([^";]+)"?/i);
        if (nameMatch && nameMatch[1]) return nameMatch[1].trim();
        try {
            const url = new URL(urlValue, window.location.origin);
            const path = url.searchParams.get('path') || '';
            const cleanPath = this.codexMarkdownDownloadPath(path);
            return decodeURIComponent(cleanPath.split('/').pop() || 'download');
        } catch (e) {
            return 'download';
        }
    }

    public codexPreviewType(fileName: string, contentType: string) {
        const lowerName = String(fileName || '').toLowerCase();
        const mime = String(contentType || '').trim().toLowerCase();
        if (/^(text\/html|application\/xhtml\+xml)(?:;|$)/.test(mime) || /\.html?$/i.test(lowerName)) return 'html';
        if (mime.indexOf('application/pdf') >= 0 || /\.pdf$/i.test(lowerName)) return 'pdf';
        if (mime.indexOf('image/') === 0 || /\.(png|jpe?g|gif|webp|svg|bmp)$/i.test(lowerName)) return 'image';
        if (mime.indexOf('text/markdown') >= 0 || /\.(md|markdown)$/i.test(lowerName)) return 'markdown';
        if (mime.indexOf('application/json') >= 0 || /\.(json|jsonl)$/i.test(lowerName)) return 'text';
        if (mime.indexOf('text/') === 0) return 'text';
        if (/\.(txt|log|csv|tsv|xml|yml|yaml|toml|ini|conf|config|env|gitignore|py|js|jsx|ts|tsx|css|scss|sass|less|pug|sql|sh|bash|zsh|fish|ps1|bat|cmd|java|kt|go|rs|rb|php|c|cc|cpp|h|hpp|cs|swift|m|mm|vue|svelte)$/i.test(lowerName)) return 'text';
        return '';
    }

    public async toggleCodexFilePreviewFullscreen(element: HTMLElement) {
        if (this.codexFilePreviewFullscreen) {
            await this.exitCodexFilePreviewFullscreen();
        } else if (this.codexFilePreview.open) {
            this.codexFilePreviewFullscreenElement = element;
            this.codexFilePreviewFullscreen = true;
            try {
                if (element.requestFullscreen) await element.requestFullscreen();
            } catch (e) {
                // Keep the viewport-sized mode when native fullscreen is unavailable.
            }
            if (this.codexFilePreviewFullscreenElement !== element && document.fullscreenElement === element) {
                await document.exitFullscreen().catch(() => {});
            }
        }
        if (!this.destroyed) await this.service.render();
    }

    private async exitCodexFilePreviewFullscreen() {
        const element = this.codexFilePreviewFullscreenElement;
        this.codexFilePreviewFullscreenElement = null;
        this.codexFilePreviewFullscreen = false;
        if (element && document.fullscreenElement === element) {
            await document.exitFullscreen().catch(() => {});
        }
    }

    @HostListener('document:fullscreenchange')
    public async onCodexFilePreviewFullscreenChange() {
        if (!this.codexFilePreviewFullscreenElement || document.fullscreenElement === this.codexFilePreviewFullscreenElement) return;
        this.codexFilePreviewFullscreenElement = null;
        this.codexFilePreviewFullscreen = false;
        if (!this.destroyed) await this.service.render();
    }

    public revokeCodexFilePreviewObjectUrl() {
        if (!this.codexFilePreviewObjectUrl) return;
        window.URL.revokeObjectURL(this.codexFilePreviewObjectUrl);
        this.codexFilePreviewObjectUrl = '';
    }

    public resetCodexFilePreview(keepOpen: boolean = false) {
        void this.exitCodexFilePreviewFullscreen();
        this.revokeCodexFilePreviewObjectUrl();
        this.codexFilePreview = { open: keepOpen, loading: false, type: '', title: '', content: '', imageUrl: '', fileUrl: '', downloadUrl: '', dataUrl: '', error: '' };
    }

    public previewTextFromBytes(bytes: any) {
        try {
            return new TextDecoder('utf-8').decode(bytes || new Uint8Array());
        } catch (e) {
            return '';
        }
    }

    public async openDataUrlFilePreview(dataUrl: any, fileName: any = 'attachment', mime: any = '', downloadUrl: any = '') {
        const value = String(dataUrl || '').trim();
        const title = this.safeAttachmentName(fileName || 'attachment');
        const contentType = String(mime || this.dataUrlMime(value) || '').toLowerCase();
        const previewType = this.codexPreviewType(title, contentType);
        if (!value || !previewType) {
            await this.service.modal.error('미리볼 수 없는 파일 형식입니다.');
            return;
        }
        this.resetCodexFilePreview(true);
        this.codexFilePreview = Object.assign({}, this.codexFilePreview, {
            loading: true,
            title,
            downloadUrl: String(downloadUrl || ''),
            dataUrl: value
        });
        const preview = this.codexFilePreview;
        this.syncModalScrollLock();
        await this.service.render();
        if (this.codexFilePreview !== preview) return;

        const bytes = this.dataUrlToBytes(value);
        if (!bytes) {
            this.codexFilePreview = Object.assign({}, this.codexFilePreview, { loading: false, error: '파일 데이터를 읽지 못했습니다.' });
            await this.service.render();
            return;
        }
        if (previewType === 'markdown' || previewType === 'text') {
            this.codexFilePreview = {
                open: true,
                loading: false,
                type: previewType,
                title,
                content: this.previewTextFromBytes(bytes),
                imageUrl: '',
                fileUrl: '',
                downloadUrl: String(downloadUrl || ''),
                dataUrl: value,
                error: ''
            };
            await this.service.render();
            return;
        }
        if (previewType === 'image') {
            this.codexFilePreview = { open: true, loading: false, type: 'image', title, content: '', imageUrl: value, fileUrl: '', downloadUrl: String(downloadUrl || ''), dataUrl: value, error: '' };
            await this.service.render();
            return;
        }
        if (previewType === 'pdf' || previewType === 'html') {
            const blobType = previewType === 'html' ? 'text/html;charset=utf-8' : contentType || 'application/pdf';
            this.codexFilePreviewObjectUrl = window.URL.createObjectURL(new Blob([bytes], { type: blobType }));
            this.codexFilePreview = { open: true, loading: false, type: previewType, title, content: '', imageUrl: '', fileUrl: this.codexFilePreviewObjectUrl, downloadUrl: String(downloadUrl || ''), dataUrl: value, error: '' };
            await this.service.render();
        }
    }

    public async openCodexFilePreview(href: any) {
        const downloadUrl = String(href || '').trim();
        if (!downloadUrl) return;
        this.resetCodexFilePreview(true);
        this.codexFilePreview = Object.assign({}, this.codexFilePreview, {
            loading: true,
            title: this.codexPreviewFileName(downloadUrl),
            downloadUrl
        });
        const preview = this.codexFilePreview;
        this.syncModalScrollLock();
        await this.service.render();
        if (this.codexFilePreview !== preview) return;
        try {
            const response = await fetch(downloadUrl, { credentials: 'same-origin' });
            if (this.codexFilePreview !== preview) return;
            const fileName = this.codexPreviewFileName(downloadUrl, response);
            const contentType = String(response.headers.get('content-type') || '');
            if (!response.ok) {
                let message = '파일을 불러오지 못했습니다.';
                try {
                    const payload = await response.clone().json();
                    message = payload && payload.message ? payload.message : payload && payload.data && payload.data.message ? payload.data.message : message;
                } catch (e) {
                    const text = await response.text();
                    if (text) message = text.slice(0, 300);
                }
                if (this.codexFilePreview !== preview) return;
                this.codexFilePreview = Object.assign({}, this.codexFilePreview, { loading: false, title: fileName, error: message });
                await this.service.render();
                return;
            }
            const previewType = this.codexPreviewType(fileName, contentType);
            if (previewType === 'html') {
                const content = await response.text();
                if (this.codexFilePreview !== preview) return;
                this.codexFilePreviewObjectUrl = window.URL.createObjectURL(new Blob([content], { type: 'text/html;charset=utf-8' }));
                this.codexFilePreview = { open: true, loading: false, type: 'html', title: fileName, content: '', imageUrl: '', fileUrl: this.codexFilePreviewObjectUrl, downloadUrl, dataUrl: '', error: '' };
                await this.service.render();
                return;
            }
            if (previewType === 'markdown') {
                const content = await response.text();
                if (this.codexFilePreview !== preview) return;
                this.codexFilePreview = { open: true, loading: false, type: 'markdown', title: fileName, content, imageUrl: '', fileUrl: '', downloadUrl, dataUrl: '', error: '' };
                await this.service.render();
                return;
            }
            if (previewType === 'text') {
                const content = await response.text();
                if (this.codexFilePreview !== preview) return;
                this.codexFilePreview = { open: true, loading: false, type: 'text', title: fileName, content, imageUrl: '', fileUrl: '', downloadUrl, dataUrl: '', error: '' };
                await this.service.render();
                return;
            }
            if (previewType === 'image') {
                const blob = await response.blob();
                if (this.codexFilePreview !== preview) return;
                this.codexFilePreviewObjectUrl = window.URL.createObjectURL(blob);
                this.codexFilePreview = { open: true, loading: false, type: 'image', title: fileName, content: '', imageUrl: this.codexFilePreviewObjectUrl, fileUrl: '', downloadUrl, dataUrl: '', error: '' };
                await this.service.render();
                return;
            }
            if (previewType === 'pdf') {
                const blob = await response.blob();
                if (this.codexFilePreview !== preview) return;
                this.codexFilePreviewObjectUrl = window.URL.createObjectURL(blob);
                this.codexFilePreview = { open: true, loading: false, type: 'pdf', title: fileName, content: '', imageUrl: '', fileUrl: this.codexFilePreviewObjectUrl, downloadUrl, dataUrl: '', error: '' };
                await this.service.render();
                return;
            }
            const blob = await response.blob();
            if (this.codexFilePreview !== preview) return;
            this.resetCodexFilePreview(false);
            this.syncModalScrollLock();
            this.downloadBlob(blob, fileName || 'download');
            await this.service.render();
        } catch (e) {
            if (this.codexFilePreview !== preview) return;
            this.codexFilePreview = Object.assign({}, this.codexFilePreview, { loading: false, error: '파일을 불러오지 못했습니다.' });
            await this.service.render();
        }
    }

    public downloadBlob(blob: Blob, fileName: string) {
        if (!blob) return;
        const url = window.URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = this.safeAttachmentName(fileName || 'download');
        document.body.appendChild(anchor);
        anchor.click();
        anchor.remove();
        window.setTimeout(() => window.URL.revokeObjectURL(url), 1000);
    }

    public downloadCodexFilePreview() {
        const url = String(this.codexFilePreview && this.codexFilePreview.downloadUrl || '');
        const dataUrl = String(this.codexFilePreview && this.codexFilePreview.dataUrl || '');
        if (!url && dataUrl) {
            this.downloadDataUrl(dataUrl, (this.codexFilePreview && this.codexFilePreview.title) || 'download', this.dataUrlMime(dataUrl) || 'application/octet-stream');
            return;
        }
        if (!url) return;
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = this.safeAttachmentName((this.codexFilePreview && this.codexFilePreview.title) || 'download');
        anchor.rel = 'noopener noreferrer';
        document.body.appendChild(anchor);
        anchor.click();
        anchor.remove();
    }

    public async closeCodexFilePreview(render: boolean = true) {
        this.resetCodexFilePreview(false);
        this.syncModalScrollLock();
        if (render) await this.service.render();
    }

    public markdownHtml(value: any, linkMode: string = '') {
        const text = value === undefined || value === null || value === '' ? '-' : String(value);
        const cacheKey = [linkMode || 'default', this.currentProjectId(), this.adminMode ? '1' : '0', text].join('\n');
        if (this.markdownHtmlCache[cacheKey]) return this.markdownHtmlCache[cacheKey];
        let html = '';
        try {
            html = this.markdownConverter.makeHtml(text);
            if (linkMode === 'codex') html = this.rewriteCodexMarkdownLinks(html);
        } catch (e) {
            html = `<p>${this.escapeHtml(text)}</p>`;
        }
        this.markdownHtmlCache[cacheKey] = html;
        this.markdownHtmlCacheKeys.push(cacheKey);
        if (this.markdownHtmlCacheKeys.length > 80) {
            const oldest = this.markdownHtmlCacheKeys.shift();
            if (oldest) delete this.markdownHtmlCache[oldest];
        }
        return html;
    }

    public rewriteCodexMarkdownLinks(html: string) {
        if (!html || !this.currentProjectId()) return html;
        const template = document.createElement('template');
        template.innerHTML = html;
        const anchors = Array.prototype.slice.call(template.content.querySelectorAll('a[href]'));
        anchors.forEach((anchor: HTMLAnchorElement) => {
            const href = anchor.getAttribute('href') || '';
            if (!this.shouldRewriteCodexMarkdownHref(href)) return;
            const downloadUrl = this.codexMarkdownFileDownloadUrl(href);
            if (!downloadUrl) return;
            anchor.setAttribute('href', downloadUrl);
            anchor.removeAttribute('download');
            anchor.setAttribute('data-reviewops-file-preview', 'codex');
            anchor.setAttribute('target', '_blank');
            anchor.setAttribute('rel', 'noopener noreferrer');
        });
        return template.innerHTML;
    }

    public shouldRewriteCodexMarkdownHref(href: string) {
        const value = String(href || '').trim();
        if (!value || value.charAt(0) === '#') return false;
        if (/^(https?:|mailto:|tel:|data:|blob:|javascript:)/i.test(value) || value.indexOf('//') === 0) return false;
        if (/^\/(wiz|api|auth|assets|project-html|projects)(\/|$)/i.test(value)) return false;
        return true;
    }

    public codexMarkdownFileDownloadUrl(href: string) {
        const projectId = this.currentProjectId();
        const path = this.codexMarkdownDownloadPath(href);
        if (!projectId || !path) return '';
        const params = [
            `project_id=${encodeURIComponent(projectId)}`,
            `path=${encodeURIComponent(path)}`
        ];
        if (this.adminMode) params.push('admin=1');
        return `/wiz/api/component.review.modal/download_codex_file?${params.join('&')}`;
    }

    public codexMarkdownDownloadPath(href: any) {
        let path = String(href || '').trim();
        if (!path) return '';
        if (/^file:\/\//i.test(path)) path = path.replace(/^file:\/\//i, '');
        path = path.split('#', 1)[0].split('?', 1)[0].trim();
        path = path.replace(/:\d+(?::\d+)?$/, '').trim();
        return path;
    }

    public markdownText(value: any) {
        if (value === undefined || value === null || value === '') return '-';
        if (typeof value === 'object') return JSON.stringify(value, null, 2);
        return String(value);
    }

    public escapeHtml(value: any) {
        return String(value === undefined || value === null ? '' : value)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }

    public markdownJson(value: any) {
        try {
            return JSON.stringify(value || [], null, 2);
        } catch (e) {
            return '[]';
        }
    }

    public dataUrlMime(dataUrl: string) {
        const match = String(dataUrl || '').match(/^data:([^;,]+)[;,]/);
        return match ? match[1] : '';
    }

    public dataUrlBytes(dataUrl: string) {
        const value = String(dataUrl || '');
        const comma = value.indexOf(',');
        if (comma < 0) return 0;
        const base64 = value.slice(comma + 1).replace(/\s/g, '');
        return Math.floor((base64.length * 3) / 4);
    }

    public dataUrlSizeLabel(dataUrl: string) {
        return this.networkSizeLabel(this.dataUrlBytes(dataUrl));
    }

    public dataUrlExtension(dataUrl: string) {
        const mime = this.dataUrlMime(dataUrl);
        if (mime === 'image/jpeg') return 'jpg';
        if (mime === 'image/png') return 'png';
        if (mime === 'image/gif') return 'gif';
        if (mime === 'image/webp') return 'webp';
        if (mime === 'image/svg+xml') return 'svg';
        if (mime === 'application/pdf') return 'pdf';
        return 'bin';
    }

    public networkSizeLabel(value: any) {
        const bytes = Number(value) || 0;
        if (bytes >= 1024 * 1024) return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
        if (bytes >= 1024) return `${(bytes / 1024).toFixed(1)} KB`;
        return `${bytes} B`;
    }

    public applyUploadSettings(settings: any) {
        if (!settings || typeof settings !== 'object') return;
        this.uploadSettings = settings;
        this.reviewAttachmentAccept = this.uploadPolicyAccept('review_attachment', this.reviewAttachmentAccept);
        this.activityAttachmentAccept = this.uploadPolicyAccept('activity_attachment', this.activityAttachmentAccept);
        this.reviewAttachmentLimits = {
            files: this.uploadPolicyMaxFiles('review_attachment', this.reviewAttachmentLimits.files),
            fileBytes: this.uploadPolicyFileBytes('review_attachment', this.reviewAttachmentLimits.fileBytes),
            totalBytes: this.uploadPolicyTotalBytes('review_attachment', this.reviewAttachmentLimits.totalBytes)
        };
        this.activityAttachmentLimits = {
            files: this.uploadPolicyMaxFiles('activity_attachment', this.activityAttachmentLimits.files),
            fileBytes: this.uploadPolicyFileBytes('activity_attachment', this.activityAttachmentLimits.fileBytes),
            totalBytes: this.uploadPolicyTotalBytes('activity_attachment', this.activityAttachmentLimits.totalBytes)
        };
    }

    public uploadPolicy(key: string) {
        const policies = this.uploadSettings && this.uploadSettings.policies ? this.uploadSettings.policies : {};
        return policies && policies[key] ? policies[key] : {};
    }

    public uploadPolicyAccept(key: string, fallback: string = '') {
        const policy = this.uploadPolicy(key);
        if (policy.allow_all_formats) return '';
        if (Array.isArray(policy.allowed_mimes) && policy.allowed_mimes.indexOf('*/*') >= 0) return '';
        return String(policy.accept || fallback || '');
    }

    public uploadPolicyFileBytes(key: string, fallback: number) {
        const value = Number(this.uploadPolicy(key).max_file_bytes);
        return value > 0 ? value : fallback;
    }

    public uploadPolicyTotalBytes(key: string, fallback: number) {
        const policy = this.uploadPolicy(key);
        if (policy && policy.max_total_bytes !== undefined) return Number(policy.max_total_bytes) || 0;
        return fallback;
    }

    public uploadPolicyMaxFiles(key: string, fallback: number) {
        const value = Number(this.uploadPolicy(key).max_files);
        return value > 0 ? value : fallback;
    }

    public fileExtension(name: any) {
        const match = String(name || '').toLowerCase().match(/\.[a-z0-9_-]+$/);
        return match ? match[0] : '';
    }

    public uploadPolicyAllowsFile(key: string, file: File) {
        const policy = this.uploadPolicy(key);
        if (!policy || policy.allow_all_formats) return true;
        const extensions = Array.isArray(policy.allowed_extensions) ? policy.allowed_extensions : [];
        const mimes = Array.isArray(policy.allowed_mimes) ? policy.allowed_mimes : [];
        if (!extensions.length && !mimes.length) return true;
        if (mimes.indexOf('*/*') >= 0) return true;
        const ext = this.fileExtension(file && file.name);
        const mime = String(file && file.type ? file.type : '').toLowerCase();
        if (ext && extensions.indexOf(ext) >= 0) return true;
        if (mime) {
            for (const allowed of mimes) {
                const value = String(allowed || '').toLowerCase();
                if (value === mime) return true;
                if (value.endsWith('/*') && mime.startsWith(value.slice(0, -1))) return true;
            }
        }
        return false;
    }

    public uploadPolicyFormatMessage(key: string, files: File[]) {
        const policy = this.uploadPolicy(key);
        if (!policy || !files || !files.length) return '';
        if (files.some((file) => !this.uploadPolicyAllowsFile(key, file))) {
            return `${String(policy.label || '파일')}에서 허용되지 않는 파일 형식입니다.`;
        }
        return '';
    }

    public networkDurationLabel(item: any) {
        const value = Number(item && item.duration_ms);
        if (!value) return '-';
        return value >= 1000 ? `${(value / 1000).toFixed(2)}s` : `${Math.round(value)}ms`;
    }

    public compactJson(value: any) {
        try {
            return JSON.stringify(value || {});
        } catch (e) {
            return '';
        }
    }

    public fingerprintSummary(item: any) {
        if (!item) return '';
        return item.summary || item.fingerprint_hash || item.user_agent || item.platform || item.target_origin || item.type || '';
    }

    public consoleLevelBadgeClass(level: string) {
        const base = 'shrink-0 rounded px-1.5 py-0.5 text-[10px] font-semibold uppercase ';
        const value = String(level || 'log').toLowerCase();
        if (['error', 'assert', 'unhandledrejection'].includes(value)) return base + 'bg-rose-100 text-rose-700';
        if (['warn', 'warning'].includes(value)) return base + 'bg-amber-100 text-amber-700';
        return base + 'bg-slate-100 text-slate-600';
    }

    public selectedLogTab() {
        return this.reviewLogTabs.find((item) => item.key === this.reviewLogTab) || this.reviewLogTabs[0];
    }

    public reviewLogEntries() {
        const tab = this.selectedLogTab();
        return this.selectedReviewLogEntries(tab.field);
    }

    public reviewLogCount(tab: string) {
        return this.selectedReviewLogCount(tab);
    }

    public logEntryTitle(item: any) {
        return item.title || item.url || item.text || item.message || item.selector || item.event || item.type || item.source || '로그';
    }

    public logEntryMeta(item: any) {
        const parts = [item.source, item.method, item.status, item.resource_type, item.level, item.at || item.created || item.time]
            .filter((value) => value !== null && value !== undefined && String(value).trim());
        return parts.join(' · ');
    }

    public logEntryBody(item: any) {
        try {
            return JSON.stringify(item || {}, null, 2);
        } catch (e) {
            return String(item || '');
        }
    }

    public kstDateTime(value: any) {
        return this.service.formatter.kstDateTime(value, '-');
    }

    public documentVersionDownloadFileName(version: any) {
        const projectName = this.reviewProjectName(this.selectedReview) || 'document';
        const versionLabel = version && (version.version_label || version.created) ? version.version_label || version.created : 'latest';
        const fallback = `${projectName}-${versionLabel}.pdf`;
        const fileName = version && version.file_name ? version.file_name : fallback;
        const safeName = this.safeAttachmentName(fileName);
        return /\.[a-z0-9]{1,12}$/i.test(safeName) ? safeName : `${safeName}.pdf`;
    }

    public documentVersionDownloading(version: any) {
        return !!version && String(this.downloadingDocumentVersionId) === String(version.id);
    }

    public applyLoadedDocumentVersion(version: any) {
        if (!version || !this.selectedReview) return;
        if (!this.selectedReview.evidence) this.selectedReview.evidence = {};
        const evidence = this.selectedReview.evidence;
        const current = evidence.document_version || {};
        if (!evidence.document_version_id || String(evidence.document_version_id) === String(version.id)) {
            evidence.document_version_id = version.id;
            evidence.document_version = Object.assign({}, current, version);
        }
    }

    public async loadDocumentVersionFile(versionId: string = '', render: boolean = true) {
        const current = this.documentEvidenceVersion(this.selectedReview);
        const id = versionId || (current && current.id ? String(current.id) : '');
        if (!id) return null;
        if (current && String(current.id) === String(id) && current.file_data_url) return current;

        this.documentFileLoading = true;
        if (render) await this.service.render();
        const projectId = this.currentProjectId();
        const { code, data } = await wiz.call('load_document_version', this.requestParams({
            id: projectId,
            project_id: projectId,
            version_id: id
        }));
        this.documentFileLoading = false;
        if (code === 200 && data.version) {
            this.applyLoadedDocumentVersion(data.version);
            if (render) await this.service.render();
            return data.version;
        }
        if (render) {
            await this.service.modal.error(data.message || 'PDF 문서를 불러오지 못했습니다.');
            await this.service.render();
        }
        return null;
    }

    public async downloadDocumentVersion(version: any = null) {
        const target = version || this.documentEvidenceVersion(this.selectedReview);
        const id = target && target.id ? String(target.id) : '';
        if (!id || this.downloadingDocumentVersionId) return;

        this.downloadingDocumentVersionId = id;
        await this.service.render();
        try {
            const loaded = await this.loadDocumentVersionFile(id, false);
            const documentVersion = loaded || target;
            const dataUrl = documentVersion && documentVersion.file_data_url ? String(documentVersion.file_data_url) : '';
            if (!dataUrl) {
                await this.service.modal.error('다운로드할 PDF 파일을 불러오지 못했습니다.');
                return;
            }
            this.downloadDataUrl(dataUrl, this.documentVersionDownloadFileName(documentVersion), documentVersion.file_mime || 'application/pdf');
        } catch (e) {
            await this.service.modal.error('PDF 파일을 다운로드하지 못했습니다.');
        } finally {
            this.downloadingDocumentVersionId = '';
            await this.service.render();
        }
    }

    public downloadReviewDocument(review: any) {
        return this.downloadDocumentVersion(this.documentEvidenceVersion(review));
    }

    public agentInstructionLogSpecs() {
        return [
            { key: 'navigation_log', label: 'navigation' },
            { key: 'input_log', label: 'input' },
            { key: 'network_log', label: 'network' },
            { key: 'console_log', label: 'console' },
            { key: 'fingerprint_log', label: 'fingerprint' }
        ];
    }

    public csvCellText(value: any): string {
        if (value === undefined || value === null) return '';
        if (Array.isArray(value)) return value.map((item) => this.csvCellText(item)).filter((item) => item !== '').join('; ');
        if (typeof value === 'object') {
            return Object.keys(value)
                .filter((key) => typeof value[key] !== 'function' && key !== '_key')
                .map((key) => `${key}=${this.csvCellText(value[key])}`)
                .filter((item) => item !== '')
                .join('; ');
        }
        return String(value).replace(/\r?\n/g, ' ').trim();
    }

    public csvEscape(value: any) {
        const text = this.csvCellText(value);
        if (/[",\r\n]/.test(text)) return `"${text.replace(/"/g, '""')}"`;
        return text;
    }

    public agentInstructionLogRows(review: any, evidenceOverride: any = null) {
        const evidence = evidenceOverride || this.reviewEvidence(review);
        const rows: any[] = [];
        this.agentInstructionLogSpecs().forEach((spec) => {
            const entries = Array.isArray(evidence[spec.key]) ? evidence[spec.key] : [];
            entries.forEach((entry: any, index: number) => {
                const row: any = { log_type: spec.label, index: index + 1 };
                if (entry && typeof entry === 'object' && !Array.isArray(entry)) {
                    Object.keys(entry).forEach((key) => {
                        if (key !== '_key' && typeof entry[key] !== 'function') row[key] = entry[key];
                    });
                } else {
                    row.message = entry;
                }
                rows.push(row);
            });
        });
        return rows;
    }

    public buildAgentInstructionLogsCsv(review: any, evidenceOverride: any = null) {
        const rows = this.agentInstructionLogRows(review, evidenceOverride);
        const headers = ['log_type', 'index'];
        rows.forEach((row) => {
            Object.keys(row).forEach((key) => {
                if (headers.indexOf(key) < 0) headers.push(key);
            });
        });
        if (!rows.length) return headers.join(',');
        return [headers.join(',')].concat(rows.map((row) => headers.map((header) => this.csvEscape(row[header])).join(','))).join('\n');
    }

    public buildLogCaptureMarkdown(capture: any, index: number = 0) {
        const title = this.logCaptureDisplayLabel(capture, index);
        return [
            `# ${this.markdownText(title)}`,
            '',
            `- 캡처 시각: ${this.markdownText(this.kstDateTime(capture && (capture.created || capture.captured_at)))}`,
            `- 로그 건수: ${this.markdownText(this.logCaptureCountLabel(capture))}`,
            '',
            '```csv',
            this.buildAgentInstructionLogsCsv(this.selectedReview, capture || {}),
            '```',
            ''
        ].join('\n');
    }

    public buildAgentInstructionCopyMarkdown(review: any) {
        const evidence = this.reviewEvidence(review);
        const documentVersion = this.documentEvidenceVersion(review);
        const reviewAttachments = review && Array.isArray(review.attachments) ? review.attachments : [];
        return [
            '# 에이전트 작업 지시서',
            '',
            '## 요청사항',
            '',
            `- ID: ${this.markdownText(review && review.id)}`,
            `- 제목: ${this.markdownText(review && review.title)}`,
            `- 상태: ${this.markdownText(review && this.statusLabel(review.status))}`,
            `- 우선순위: ${this.markdownText(review && this.priorityLabel(review.priority))}`,
            `- 분류: ${this.markdownText(review && this.categoryLabel(review.category))}`,
            `- 프로젝트 종류: ${this.markdownText(this.projectTypeLabel(review))}`,
            `- 문서 버전: ${this.reviewIsDocument(review) ? this.markdownText(this.documentVersionDisplayLabel(documentVersion)) : '-'}`,
            `- 문서 페이지: ${this.reviewIsDocument(review) ? `p.${Number(evidence.document_page) || 1}` : '-'}`,
            `- 요청 링크: ${this.markdownText(review && review.current_url)}`,
            `- 마지막 접속 링크: ${this.markdownText(this.lastAccessUrl(review))}`,
            `- 첨부 파일: ${reviewAttachments.length}개`,
            '',
            this.markdownText(review && review.body),
            ''
        ].join('\n');
    }

    public async copyTextToClipboard(text: string) {
        if (typeof navigator !== 'undefined' && navigator.clipboard && navigator.clipboard.writeText) {
            await navigator.clipboard.writeText(text);
            return;
        }
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.setAttribute('readonly', 'readonly');
        textarea.style.position = 'fixed';
        textarea.style.left = '-9999px';
        textarea.style.top = '0';
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        const copied = document.execCommand('copy');
        textarea.remove();
        if (!copied) throw new Error('clipboard copy failed');
    }

    public async copyAgentInstructionMarkdown(review: any) {
        if (!review) return;
        try {
            const loaded = await this.loadReviewEvidence(false);
            if (!loaded && !this.reviewEvidenceLoaded()) return;
            await this.copyTextToClipboard(this.buildAgentInstructionCopyMarkdown(this.selectedReview || review));
            await this.service.modal.success('MD가 복사되었습니다.');
        } catch (e) {
            await this.service.modal.error('MD 복사에 실패했습니다.');
        }
    }

    public agentInstructionArchiveFileName(review: any) {
        const id = review && review.id ? String(review.id) : 'review';
        const title = String(review && review.title ? review.title : 'agent-work-order')
            .replace(/[^a-zA-Z0-9가-힣._-]+/g, '-')
            .replace(/-+/g, '-')
            .slice(0, 48)
            .replace(/^-|-$/g, '');
        return `reviewops-${id}-${title || 'agent-work-order'}.zip`;
    }

    public buildReviewRequestMarkdown(review: any) {
        const evidence = this.reviewEvidence(review);
        const screenshotDataUrl = evidence.screenshot_data_url || '';
        const documentVersion = this.documentEvidenceVersion(review);
        const reviewAttachments = review && Array.isArray(review.attachments) ? review.attachments : [];
        return [
            '# 리뷰 요청사항',
            '',
            '이 파일은 리뷰어가 남긴 원 요청을 사람이 읽기 쉽게 분리한 문서입니다. 전체 작업 순서와 파일 위치는 ZIP 루트의 `README.md`를 먼저 확인하세요.',
            '',
            '## 리뷰 정보',
            '',
            `- ID: ${this.markdownText(review && review.id)}`,
            `- 제목: ${this.markdownText(review && review.title)}`,
            `- 상태: ${this.markdownText(review && this.statusLabel(review.status))}`,
            `- 우선순위: ${this.markdownText(review && this.priorityLabel(review.priority))}`,
            `- 분류: ${this.markdownText(review && this.categoryLabel(review.category))}`,
            `- 작성자: ${this.markdownText(review && review.author ? review.author.name : '')}`,
            `- 프로젝트 종류: ${this.markdownText(this.projectTypeLabel(review))}`,
            `- 문서 버전: ${this.reviewIsDocument(review) ? this.markdownText(this.documentVersionDisplayLabel(documentVersion)) : '-'}`,
            `- 문서 파일: ${this.reviewIsDocument(review) ? this.markdownText(documentVersion && documentVersion.file_name) : '-'}`,
            `- 문서 페이지: ${this.reviewIsDocument(review) ? `p.${Number(evidence.document_page) || 1}` : '-'}`,
            `- 요청 링크: ${this.markdownText(review && review.current_url)}`,
            `- 마지막 접속 링크: ${this.markdownText(this.lastAccessUrl(review))}`,
            `- 화면: ${review ? `${review.viewport_width}x${review.viewport_height} / ${this.reviewScaleLabel(review.scale)}` : '-'}`,
            `- 캡처 방식: ${this.markdownText(this.captureLabel(evidence.capture_method || 'not_available'))}`,
            `- 스크린샷 첨부: ${evidence.screenshot_data_url ? 'yes' : 'no'}`,
            `- 리뷰 첨부 파일: ${reviewAttachments.length}개`,
            `- 콘솔 로그: ${(evidence.console_log || []).length}건`,
            `- 스크린샷 MIME: ${this.markdownText(this.dataUrlMime(screenshotDataUrl))}`,
            `- 스크린샷 크기: ${this.markdownText(this.dataUrlSizeLabel(screenshotDataUrl))}`,
            '',
            '## 리뷰어 요청 내용',
            '',
            this.markdownText(review && review.body),
            '',
            '## 첨부 파일',
            '',
            reviewAttachments.length ? reviewAttachments.map((attachment: any, index: number) => {
                return `- ${index + 1}. ${this.markdownText(attachment && attachment.name)} (${this.markdownText(attachment && attachment.mime)}, ${this.attachmentSizeLabel(attachment)})`;
            }).join('\n') : '-',
            ''
        ].join('\n');
    }

    public archiveJson(value: any) {
        try {
            return JSON.stringify(value || {}, null, 2);
        } catch (e) {
            return '{}';
        }
    }

    public utf8Bytes(value: any) {
        return new TextEncoder().encode(String(value === undefined || value === null ? '' : value));
    }

    public dataUrlToBytes(dataUrl: string) {
        const value = String(dataUrl || '');
        const match = value.match(/^data:([^;,]*)(;base64)?,(.*)$/i);
        if (!match) return null;
        try {
            const payload = match[3] || '';
            if (match[2]) {
                const binary = atob(payload.replace(/\s/g, ''));
                const bytes = new Uint8Array(binary.length);
                for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
                return bytes;
            }
            return this.utf8Bytes(decodeURIComponent(payload));
        } catch (e) {
            return null;
        }
    }

    public zipFileExtensionForMime(mime: string, fallback: string = 'bin') {
        const value = String(mime || '').toLowerCase();
        const map: any = {
            'image/png': 'png',
            'image/jpeg': 'jpg',
            'image/gif': 'gif',
            'image/webp': 'webp',
            'image/svg+xml': 'svg',
            'application/pdf': 'pdf',
            'text/plain': 'txt',
            'text/markdown': 'md',
            'text/csv': 'csv',
            'application/json': 'json',
            'application/zip': 'zip',
            'application/msword': 'doc',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
            'application/vnd.ms-excel': 'xls',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
            'application/vnd.ms-powerpoint': 'ppt',
            'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx'
        };
        return map[value] || fallback;
    }

    public safeArchivePathPart(value: any, fallback: string = 'file') {
        const text = String(value || fallback)
            .replace(/[\\/:*?"<>|#%{}^~[\]`]+/g, '-')
            .replace(/\s+/g, '-')
            .replace(/-+/g, '-')
            .replace(/^-|-$/g, '')
            .slice(0, 120);
        return text || fallback;
    }

    public archiveAttachmentName(attachment: any, index: number) {
        const base = this.safeAttachmentName(attachment && attachment.name ? attachment.name : `attachment-${index + 1}`);
        if (/\.[a-z0-9]{1,8}$/i.test(base)) return this.safeArchivePathPart(base, `attachment-${index + 1}`);
        const ext = this.zipFileExtensionForMime(attachment && attachment.mime, 'bin');
        return `${this.safeArchivePathPart(base, `attachment-${index + 1}`)}.${ext}`;
    }

    public uniqueArchivePath(path: string, used: any) {
        const normalized = String(path || 'file').replace(/^\/+/, '');
        if (!used[normalized]) {
            used[normalized] = true;
            return normalized;
        }
        const slash = normalized.lastIndexOf('/');
        const dir = slash >= 0 ? normalized.slice(0, slash + 1) : '';
        const name = slash >= 0 ? normalized.slice(slash + 1) : normalized;
        const dot = name.lastIndexOf('.');
        const stem = dot > 0 ? name.slice(0, dot) : name;
        const ext = dot > 0 ? name.slice(dot) : '';
        let seq = 2;
        while (used[`${dir}${stem}-${seq}${ext}`]) seq++;
        const next = `${dir}${stem}-${seq}${ext}`;
        used[next] = true;
        return next;
    }

    public sanitizedActivitiesForArchive(review: any, attachmentPaths: any) {
        const activities = review && review.activities ? review.activities : [];
        return activities.map((activity: any, activityIndex: number) => {
            const key = String(activity && (activity.id || activity.created || activityIndex));
            const paths = attachmentPaths[key] || [];
            return {
                index: activityIndex + 1,
                id: activity && activity.id,
                author: activity && activity.author,
                created: activity && activity.created,
                status: activity && activity.status,
                status_label: activity && activity.status ? this.statusLabel(activity.status) : '',
                message: activity && activity.message,
                attachments: (activity && activity.attachments ? activity.attachments : []).map((attachment: any, index: number) => ({
                    name: attachment && attachment.name,
                    mime: attachment && attachment.mime,
                    size: Number(attachment && attachment.size) || this.dataUrlBytes(attachment && attachment.data_url),
                    archive_path: paths[index] || ''
                }))
            };
        });
    }

    public buildActivityMarkdown(activity: any, index: number, attachmentPaths: string[]) {
        const attachments = activity && activity.attachments ? activity.attachments : [];
        return [
            `# 작업이력 ${index + 1}`,
            '',
            `- 작성자: ${this.markdownText(activity && activity.author ? activity.author.name : '')}`,
            `- 작성일: ${this.markdownText(this.kstDateTime(activity && activity.created))}`,
            `- 상태: ${activity && activity.status ? this.statusLabel(activity.status) : '-'}`,
            '',
            '## 내용',
            '',
            this.markdownText(activity && activity.message),
            '',
            '## 첨부 파일',
            '',
            attachments.length ? attachments.map((attachment: any, attachmentIndex: number) => {
                const path = attachmentPaths[attachmentIndex] || '';
                return `- ${this.markdownText(attachment && attachment.name)} (${this.markdownText(attachment && attachment.mime)}, ${this.attachmentSizeLabel(attachment)})${path ? `: ${path}` : ''}`;
            }).join('\n') : '-',
            ''
        ].join('\n');
    }

    public buildArchiveReadme(review: any, entries: any[]) {
        const evidence = this.reviewEvidence(review);
        const documentVersion = this.documentEvidenceVersion(review);
        const tree = entries.map((entry: any) => `- \`${entry.path}\`${entry.description ? `: ${entry.description}` : ''}`).join('\n');
        return [
            '# README - 에이전트 작업 지시서',
            '',
            '에이전트는 이 파일을 가장 먼저 읽고 작업을 시작하세요. 이 ZIP은 ReviewOps 리뷰 분석을 위해 표준화된 파일 구조로 만든 작업 지시서입니다.',
            '',
            '## 요청사항',
            '',
            '아래 리뷰 요청, 스크린샷, 수집 로그, 작업이력과 첨부 파일을 기준으로 문제를 파악하고 재현 경로, 원인 후보, 수정 방향을 제안하거나 필요한 코드를 수정하세요.',
            '',
            `- 리뷰 ID: ${this.markdownText(review && review.id)}`,
            `- 제목: ${this.markdownText(review && review.title)}`,
            `- 상태: ${this.markdownText(review && this.statusLabel(review.status))}`,
            `- 우선순위: ${this.markdownText(review && this.priorityLabel(review.priority))}`,
            `- 분류: ${this.markdownText(review && this.categoryLabel(review.category))}`,
            `- 프로젝트 종류: ${this.markdownText(this.projectTypeLabel(review))}`,
            `- 문서 버전: ${this.reviewIsDocument(review) ? this.markdownText(this.documentVersionDisplayLabel(documentVersion)) : '-'}`,
            `- 문서 페이지: ${this.reviewIsDocument(review) ? `p.${Number(evidence.document_page) || 1}` : '-'}`,
            `- 요청 링크: ${this.markdownText(review && review.current_url)}`,
            `- 마지막 접속 링크: ${this.markdownText(this.lastAccessUrl(review))}`,
            `- 화면: ${review ? `${review.viewport_width}x${review.viewport_height} / ${this.reviewScaleLabel(review.scale)}` : '-'}`,
            `- 캡처 방식: ${this.markdownText(this.captureLabel(evidence.capture_method || 'not_available'))}`,
            '',
            '## 먼저 볼 파일',
            '',
            '1. `review/request.md`: 리뷰어가 남긴 요청 내용과 기본 메타데이터',
            '2. `assets/screenshots/`: 실제 화면 캡처 파일',
            '3. `assets/review-attachments/`: 리뷰 등록 시 첨부한 파일',
            '4. `activities/`: 작업이력과 작업이력별 첨부 파일 위치',
            '5. `evidence/`: 네비게이션, 입력, 네트워크, 콘솔, 브라우저/SDK 환경 로그와 캡처 버전',
            '6. `assets/documents/`: 문서형 프로젝트의 리뷰 대상 PDF 파일',
            '',
            '## 파일 트리',
            '',
            tree || '- 파일 없음',
            '',
            '## 분석 메모',
            '',
            '- 입력 로그는 민감정보 원문 대신 마스킹된 요약/메타데이터만 포함합니다.',
            '- 리뷰 첨부 파일은 `assets/review-attachments/` 하위에 파일 단위로 분리되어 있습니다.',
            '- 작업이력 첨부 파일은 `assets/activity-attachments/` 하위에 파일 단위로 분리되어 있습니다.',
            '- `metadata/file-manifest.json`에는 각 파일의 설명과 크기가 들어 있습니다.',
            ''
        ].join('\n');
    }

    public buildAgentInstructionArchiveEntries(review: any) {
        const evidence = this.reviewEvidence(review);
        const used: any = {};
        const entries: any[] = [];
        const reviewAttachmentPaths: string[] = [];
        const attachmentPaths: any = {};

        const addEntry = (path: string, bytes: Uint8Array, description: string) => {
            const uniquePath = this.uniqueArchivePath(path, used);
            entries.push({ path: uniquePath, bytes, description, size: bytes.length });
            return uniquePath;
        };
        const addText = (path: string, content: string, description: string) => addEntry(path, this.utf8Bytes(content), description);
        const addJson = (path: string, value: any, description: string) => addText(path, this.archiveJson(value), description);
        const addDataUrl = (path: string, dataUrl: string, description: string) => {
            const bytes = this.dataUrlToBytes(dataUrl);
            if (!bytes) return '';
            return addEntry(path, bytes, description);
        };

        const documentVersion = this.documentEvidenceVersion(review);
        const documentDataUrl = documentVersion && documentVersion.file_data_url ? documentVersion.file_data_url : '';
        const documentPath = documentDataUrl
            ? addDataUrl(
                `assets/documents/${this.safeArchivePathPart(documentVersion.file_name || 'review-document.pdf', 'review-document.pdf')}`,
                documentDataUrl,
                '리뷰 대상 PDF 문서 버전'
            )
            : '';
        const screenshotPaths: string[] = [];
        const screenshots = this.reviewScreenshots(review);
        for (let screenshotIndex = 0; screenshotIndex < screenshots.length; screenshotIndex++) {
            const screenshot = screenshots[screenshotIndex];
            const screenshotDataUrl = screenshot && screenshot.data_url ? screenshot.data_url : '';
            const path = screenshotDataUrl
                ? addDataUrl(
                    `assets/screenshots/review-screenshot-${String(screenshotIndex + 1).padStart(2, '0')}.${this.dataUrlExtension(screenshotDataUrl)}`,
                    screenshotDataUrl,
                    `리뷰 화면 스크린샷 ${screenshotIndex + 1}`
                )
                : '';
            if (path) screenshotPaths.push(path);
        }
        const screenshotDataUrl = screenshots.length && screenshots[0].data_url ? screenshots[0].data_url : '';
        const screenshotPath = screenshotPaths[0] || '';

        const reviewAttachments = review && Array.isArray(review.attachments) ? review.attachments : [];
        const logCaptures = this.reviewLogCaptures(review);
        for (let attachmentIndex = 0; attachmentIndex < reviewAttachments.length; attachmentIndex++) {
            const attachment = reviewAttachments[attachmentIndex];
            const path = addDataUrl(
                `assets/review-attachments/${String(attachmentIndex + 1).padStart(2, '0')}-${this.archiveAttachmentName(attachment, attachmentIndex)}`,
                attachment && attachment.data_url,
                '리뷰 첨부 파일'
            );
            reviewAttachmentPaths.push(path);
        }

        const activities = review && review.activities ? review.activities : [];
        for (let activityIndex = 0; activityIndex < activities.length; activityIndex++) {
            const activity = activities[activityIndex];
            const key = String(activity && (activity.id || activity.created || activityIndex));
            attachmentPaths[key] = [];
            const attachments = activity && activity.attachments ? activity.attachments : [];
            for (let attachmentIndex = 0; attachmentIndex < attachments.length; attachmentIndex++) {
                const attachment = attachments[attachmentIndex];
                const path = addDataUrl(
                    `assets/activity-attachments/activity-${String(activityIndex + 1).padStart(3, '0')}/${String(attachmentIndex + 1).padStart(2, '0')}-${this.archiveAttachmentName(attachment, attachmentIndex)}`,
                    attachment && attachment.data_url,
                    `작업이력 ${activityIndex + 1} 첨부 파일`
                );
                attachmentPaths[key].push(path);
            }
        }

        addText('review/request.md', this.buildReviewRequestMarkdown(review), '리뷰어 요청사항과 리뷰 기본 정보');
        addJson('review/review.json', {
            id: review && review.id,
            title: review && review.title,
            body: review && review.body,
            status: review && review.status,
            status_label: review && review.status ? this.statusLabel(review.status) : '',
            priority: review && review.priority,
            priority_label: review && review.priority ? this.priorityLabel(review.priority) : '',
            category: review && review.category,
            category_label: review && review.category ? this.categoryLabel(review.category) : '',
            author: review && review.author,
            current_url: review && review.current_url,
            last_access_url: this.lastAccessUrl(review),
            viewport_width: review && review.viewport_width,
            viewport_height: review && review.viewport_height,
            scale: review && review.scale,
            project_type: this.projectType(review),
            project_type_label: this.projectTypeLabel(review),
            document_version_id: evidence.document_version_id || '',
            document_page: evidence.document_page || 0,
            document_version: documentVersion ? {
                id: documentVersion.id,
                version_label: documentVersion.version_label,
                file_name: documentVersion.file_name,
                file_mime: documentVersion.file_mime,
                file_size: documentVersion.file_size,
                file_size_label: documentVersion.file_size_label,
                created: documentVersion.created
            } : null,
            document_path: documentPath,
            screenshot_path: screenshotPath,
            screenshot_paths: screenshotPaths,
            attachments: reviewAttachments.map((attachment: any, index: number) => ({
                name: attachment && attachment.name,
                mime: attachment && attachment.mime,
                size: Number(attachment && attachment.size) || this.dataUrlBytes(attachment && attachment.data_url),
                archive_path: reviewAttachmentPaths[index] || ''
            }))
        }, '리뷰 기본 메타데이터 JSON');
        addJson('review/attachments.json', reviewAttachments.map((attachment: any, index: number) => ({
            name: attachment && attachment.name,
            mime: attachment && attachment.mime,
            size: Number(attachment && attachment.size) || this.dataUrlBytes(attachment && attachment.data_url),
            archive_path: reviewAttachmentPaths[index] || ''
        })), '리뷰 첨부 파일 목록 JSON');
        addJson('evidence/navigation-log.json', evidence.navigation_log || [], 'iframe/SDK 네비게이션 로그');
        addJson('evidence/input-log.json', evidence.input_log || [], '마스킹된 입력 이벤트 로그');
        addJson('evidence/network-log.json', evidence.network_log || [], '네트워크 요청/응답 로그');
        addJson('evidence/console-log.json', evidence.console_log || [], 'SDK/원격 브라우저 콘솔 로그');
        addJson('evidence/fingerprint-log.json', evidence.fingerprint_log || [], '브라우저, iframe, SDK 환경 로그');
        addJson('evidence/log-captures.json', logCaptures.map((capture: any, index: number) => ({
            id: this.logCaptureId(capture, index),
            label: this.logCaptureDisplayLabel(capture, index),
            created: capture && (capture.created || capture.captured_at),
            counts: this.logCaptureCounts(capture),
            total: this.logCaptureTotal(capture)
        })), '캡처 시점별 로그 버전 목록');
        logCaptures.forEach((capture: any, index: number) => {
            addText(
                `evidence/log-captures/log-capture-${String(index + 1).padStart(2, '0')}.csv`,
                this.buildAgentInstructionLogsCsv(review, capture || {}),
                `로그 버전 ${index + 1} CSV`
            );
        });
        addJson('evidence/debug-summary.json', {
            capture_method: evidence.capture_method || 'not_available',
            capture_label: this.captureLabel(evidence.capture_method || 'not_available'),
            screenshot_path: screenshotPath,
            screenshot_paths: screenshotPaths,
            screenshot_mime: this.dataUrlMime(screenshotDataUrl),
            screenshot_size: this.dataUrlBytes(screenshotDataUrl),
            document_path: documentPath,
            document_page: evidence.document_page || 0,
            console_count: (evidence.console_log || []).length,
            log_capture_count: logCaptures.length,
            sdk: this.latestFingerprint(review, 'reviewops-sdk') || {},
            browser: this.latestFingerprint(review, 'browser-fingerprint') || {},
            iframe: this.latestFingerprint(review, 'iframe-fingerprint') || {}
        }, '디버깅 요약 JSON');

        const sanitizedActivities = this.sanitizedActivitiesForArchive(review, attachmentPaths);
        addJson('activities/activity-log.json', sanitizedActivities, '작업이력 전체 JSON');
        for (let activityIndex = 0; activityIndex < activities.length; activityIndex++) {
            const activity = activities[activityIndex];
            const key = String(activity && (activity.id || activity.created || activityIndex));
            addText(
                `activities/activity-${String(activityIndex + 1).padStart(3, '0')}.md`,
                this.buildActivityMarkdown(activity, activityIndex, attachmentPaths[key] || []),
                `작업이력 ${activityIndex + 1} 요약`
            );
        }

        const manifestEntry = {
            path: 'metadata/file-manifest.json',
            bytes: this.utf8Bytes(this.archiveJson(entries.map((entry) => ({
                path: entry.path,
                description: entry.description,
                size: entry.size
            })))),
            description: 'ZIP 파일 목록과 설명',
            size: 0
        };
        manifestEntry.size = manifestEntry.bytes.length;
        manifestEntry.path = this.uniqueArchivePath(manifestEntry.path, used);
        entries.push(manifestEntry);

        const readme = this.buildArchiveReadme(review, entries);
        return [{ path: 'README.md', bytes: this.utf8Bytes(readme), description: '에이전트가 가장 먼저 읽어야 할 작업 지시서', size: this.utf8Bytes(readme).length }].concat(entries);
    }

    public zipCrcTable() {
        const cached = (this as any)._zipCrcTable;
        if (cached) return cached;
        const table: number[] = [];
        for (let n = 0; n < 256; n++) {
            let c = n;
            for (let k = 0; k < 8; k++) {
                c = (c & 1) ? (0xedb88320 ^ (c >>> 1)) : (c >>> 1);
            }
            table[n] = c >>> 0;
        }
        (this as any)._zipCrcTable = table;
        return table;
    }

    public crc32(bytes: Uint8Array) {
        const table = this.zipCrcTable();
        let crc = 0xffffffff;
        for (let i = 0; i < bytes.length; i++) {
            crc = table[(crc ^ bytes[i]) & 0xff] ^ (crc >>> 8);
        }
        return (crc ^ 0xffffffff) >>> 0;
    }

    public zipDosTime(date: Date) {
        return (date.getHours() << 11) | (date.getMinutes() << 5) | Math.floor(date.getSeconds() / 2);
    }

    public zipDosDate(date: Date) {
        return ((date.getFullYear() - 1980) << 9) | ((date.getMonth() + 1) << 5) | date.getDate();
    }

    public concatBytes(chunks: Uint8Array[]) {
        const total = chunks.reduce((sum, chunk) => sum + chunk.length, 0);
        const out = new Uint8Array(total);
        let offset = 0;
        for (const chunk of chunks) {
            out.set(chunk, offset);
            offset += chunk.length;
        }
        return out;
    }

    public createZipBlob(entries: any[]) {
        const now = new Date();
        const dosTime = this.zipDosTime(now);
        const dosDate = this.zipDosDate(now);
        const locals: Uint8Array[] = [];
        const centrals: Uint8Array[] = [];
        let offset = 0;

        for (const entry of entries) {
            const nameBytes = this.utf8Bytes(entry.path);
            const bytes = entry.bytes || new Uint8Array();
            const crc = this.crc32(bytes);

            const local = new Uint8Array(30 + nameBytes.length);
            const localView = new DataView(local.buffer);
            localView.setUint32(0, 0x04034b50, true);
            localView.setUint16(4, 20, true);
            localView.setUint16(6, 0x0800, true);
            localView.setUint16(8, 0, true);
            localView.setUint16(10, dosTime, true);
            localView.setUint16(12, dosDate, true);
            localView.setUint32(14, crc, true);
            localView.setUint32(18, bytes.length, true);
            localView.setUint32(22, bytes.length, true);
            localView.setUint16(26, nameBytes.length, true);
            localView.setUint16(28, 0, true);
            local.set(nameBytes, 30);
            locals.push(local, bytes);

            const central = new Uint8Array(46 + nameBytes.length);
            const centralView = new DataView(central.buffer);
            centralView.setUint32(0, 0x02014b50, true);
            centralView.setUint16(4, 20, true);
            centralView.setUint16(6, 20, true);
            centralView.setUint16(8, 0x0800, true);
            centralView.setUint16(10, 0, true);
            centralView.setUint16(12, dosTime, true);
            centralView.setUint16(14, dosDate, true);
            centralView.setUint32(16, crc, true);
            centralView.setUint32(20, bytes.length, true);
            centralView.setUint32(24, bytes.length, true);
            centralView.setUint16(28, nameBytes.length, true);
            centralView.setUint16(30, 0, true);
            centralView.setUint16(32, 0, true);
            centralView.setUint16(34, 0, true);
            centralView.setUint16(36, 0, true);
            centralView.setUint32(38, 0, true);
            centralView.setUint32(42, offset, true);
            central.set(nameBytes, 46);
            centrals.push(central);
            offset += local.length + bytes.length;
        }

        const centralOffset = offset;
        const centralBytes = this.concatBytes(centrals);
        const end = new Uint8Array(22);
        const endView = new DataView(end.buffer);
        endView.setUint32(0, 0x06054b50, true);
        endView.setUint16(4, 0, true);
        endView.setUint16(6, 0, true);
        endView.setUint16(8, entries.length, true);
        endView.setUint16(10, entries.length, true);
        endView.setUint32(12, centralBytes.length, true);
        endView.setUint32(16, centralOffset, true);
        endView.setUint16(20, 0, true);

        return new Blob([this.concatBytes(locals.concat([centralBytes, end]))], { type: 'application/zip' });
    }

    public async downloadAgentQuery(review: any) {
        if (!review) return;
        const loaded = await this.loadFullReviewForDownload();
        if (!loaded) return;
        review = this.selectedReview || review;
        const documentVersion = this.documentEvidenceVersion(review);
        if (documentVersion && documentVersion.id && !documentVersion.file_data_url) {
            await this.loadDocumentVersionFile(documentVersion.id);
        }
        const blob = this.createZipBlob(this.buildAgentInstructionArchiveEntries(this.selectedReview || review));
        const url = window.URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = this.agentInstructionArchiveFileName(review);
        document.body.appendChild(anchor);
        anchor.click();
        anchor.remove();
        window.setTimeout(() => window.URL.revokeObjectURL(url), 1000);
    }

    public async loadAttachmentData(attachment: any, source: string = 'review', index: number = 0, activity: any = null, activityIndex: number = 0) {
        if (!attachment || attachment.data_url || !this.selectedReview || !this.selectedReview.id) return attachment;
        const { code, data } = await wiz.call('load_review_attachment', this.requestParams({
            review_id: this.selectedReview.id,
            source,
            index: String(index || 0),
            activity_id: activity && activity.id ? activity.id : '',
            activity_index: String(activityIndex || 0)
        }));
        if (code !== 200 || !data.attachment) {
            await this.service.modal.error((data && data.message) || '첨부파일을 불러오지 못했습니다.');
            return null;
        }
        Object.assign(attachment, data.attachment || {});
        await this.service.render();
        return attachment;
    }

    public async downloadAttachment(attachment: any, source: string = 'review', index: number = 0, activity: any = null, activityIndex: number = 0) {
        attachment = await this.loadAttachmentData(attachment, source, index, activity, activityIndex);
        if (!attachment || !attachment.data_url) return;
        this.downloadDataUrl(attachment.data_url, this.safeAttachmentName(attachment.name), attachment.mime || 'application/octet-stream');
    }

    public async openAttachmentPreview(attachment: any, source: string = 'review', index: number = 0, activity: any = null, activityIndex: number = 0) {
        if (!this.isPreviewableImageAttachment(attachment)) return;
        const loaded = await this.loadAttachmentData(attachment, source, index, activity, activityIndex);
        if (!loaded) return;
        const dataUrl = String(loaded.data_url || '');
        if (!dataUrl) {
            await this.service.modal.error('파일 미리보기를 불러오지 못했습니다.');
            return;
        }
        if (!this.isImageAttachment(loaded)) {
            await this.openDataUrlFilePreview(dataUrl, loaded.name || '첨부 파일', loaded.mime || this.dataUrlMime(dataUrl));
            return;
        }
        this.attachmentPreviewUrl = dataUrl;
        this.attachmentPreviewTitle = this.safeAttachmentName(loaded.name || '이미지 첨부');
        this.attachmentPreviewAttachment = loaded;
        this.syncModalScrollLock();
        await this.service.render();
    }

    public async closeAttachmentPreview(render: boolean = true) {
        this.attachmentBackdropPointerDown = false;
        this.attachmentBackdropPointerUp = false;
        this.attachmentPreviewUrl = '';
        this.attachmentPreviewTitle = '';
        this.attachmentPreviewAttachment = null;
        this.syncModalScrollLock();
        if (render) await this.service.render();
    }

    public downloadAttachmentPreview() {
        const attachment = this.attachmentPreviewAttachment || {};
        const dataUrl = this.attachmentPreviewUrl || attachment.data_url;
        if (!dataUrl) return;
        this.downloadDataUrl(dataUrl, this.safeAttachmentName(attachment.name || this.attachmentPreviewTitle), attachment.mime || this.dataUrlMime(dataUrl) || 'image/png');
    }

    public downloadDataUrl(dataUrl: string, fileName: string, fallbackMime: string = 'application/octet-stream') {
        const value = String(dataUrl || '');
        if (!value) return;
        const anchor = document.createElement('a');
        const bytes = this.dataUrlToBytes(value);
        let objectUrl = '';
        if (bytes) {
            const mime = this.dataUrlMime(value) || fallbackMime;
            objectUrl = window.URL.createObjectURL(new Blob([bytes], { type: mime }));
            anchor.href = objectUrl;
        } else {
            anchor.href = value;
        }
        anchor.download = this.safeAttachmentName(fileName || `download.${this.dataUrlExtension(value)}`);
        document.body.appendChild(anchor);
        anchor.click();
        anchor.remove();
        if (objectUrl) window.setTimeout(() => window.URL.revokeObjectURL(objectUrl), 1000);
    }

    public screenshotFileName(review: any) {
        const id = review && review.id ? review.id : 'review';
        const previewIndex = Number(this.screenshotPreviewIndex) || 0;
        const screenshots = this.reviewScreenshots(review);
        const screenshot = previewIndex > 0 ? screenshots[previewIndex - 1] : this.currentScreenshot(review);
        const dataUrl = this.screenshotPreviewUrl || (screenshot && screenshot.data_url) || '';
        const index = screenshot && screenshot.index ? String(screenshot.index).padStart(2, '0') : String(previewIndex || this.currentScreenshotNumber(review)).padStart(2, '0');
        return `reviewops-${id}-screenshot-${index}.${this.dataUrlExtension(dataUrl)}`;
    }

    public async openScreenshotPreview(review: any, index: number = 0) {
        const screenshots = this.reviewScreenshots(review);
        const page = Number(index) > 0 ? Number(index) : this.currentScreenshotNumber(review);
        const screenshot = screenshots[page - 1] || this.currentScreenshot(review);
        const dataUrl = screenshot && screenshot.data_url ? screenshot.data_url : '';
        if (!dataUrl) return;
        this.screenshotPreviewUrl = dataUrl;
        const title = review && review.title ? review.title : '스크린샷';
        this.screenshotPreviewIndex = screenshot && screenshot.index ? Number(screenshot.index) : page;
        const label = screenshot && screenshot.label ? screenshot.label : this.currentScreenshotLabel(review);
        this.screenshotPreviewTitle = `${label} · ${title}`;
        this.syncModalScrollLock();
        await this.service.render();
    }

    public async closeScreenshotPreview(render: boolean = true) {
        this.screenshotBackdropPointerDown = false;
        this.screenshotBackdropPointerUp = false;
        this.screenshotPreviewUrl = '';
        this.screenshotPreviewTitle = '';
        this.screenshotPreviewIndex = 0;
        this.syncModalScrollLock();
        if (render) await this.service.render();
    }

    public async deletePreviewReviewScreenshot() {
        const previewIndex = Number(this.screenshotPreviewIndex) || 0;
        if (previewIndex > 0) {
            this.screenshotPage = previewIndex;
            this.ensureScreenshotPage();
        }
        await this.deleteCurrentReviewScreenshot();
    }

    public downloadReviewScreenshot(review: any) {
        const dataUrl = this.screenshotPreviewUrl || this.currentScreenshotDataUrl(review);
        if (!dataUrl) return;
        this.downloadDataUrl(dataUrl, this.screenshotFileName(review), this.dataUrlMime(dataUrl) || 'image/png');
    }
}

export default ComponentReviewModalComponent;